import React, {Component}   from 'react'
import ReactDOM from 'react-dom'
import {
  Spin,
  Empty,
  Button,
  Table,
  Rate ,
  Select,
  message,
  Switch,
  Dropdown,
  Menu,
  Tabs ,
  Input,
  Modal,
  Drawer,
  Col,
  Radio,
  Checkbox,
  Row,
  Popconfirm,
  Popover,
  InputNumber, Pagination} from 'antd'
import { Pie } from '@ant-design/plots';
import moment from 'moment';
import { v4 as uuidv4 } from "uuid";
import {ClickButton} from "../../components/link-button/index"
import {reqDelPortfolio, reqPrice,reqGetFXRate, reqGetPortfolio,reqGetPortfolios,reqUpdateModelParam,reqSearchETFData,reqSearchETFPage,PRICEDOWNLOAD,
      reqUpdatePortfolioName,reqUpdateTransaction,reqGetTransactionPlanStatus,reqDelTransaction,reqAddPortfolioName,reqReCalcOptimalData,reqGetSectorOptimalData,reqGetJpSectorWeight,reqGetWorldStockBreakdown,reqSaveOptimalData,reqGetPortfolioFile,reqGetUserAccounts,reqGetManagedUserAccounts,reqGetFinancialInstitutions,reqSaveUserAccount, getETFAssetName, BASE} from "../../api/index";
import { reqPreviewDividend } from "../../api/index";
import './portfolio.less'
import {DateTimeToString,AddMonths,rateFormat1,removeTFromCode,ToHalfWidthNumber,rateFixed,rateFixed1,numFormat,makeURL1} from '../utils/functionUtils'
import { SettingOutlined,DownloadOutlined,FormOutlined,PlusCircleOutlined, DownOutlined, CaretRightOutlined, MenuOutlined, ArrowUpOutlined, ArrowDownOutlined, UnorderedListOutlined, QuestionCircleOutlined, CaretUpOutlined, CaretDownOutlined, SortAscendingOutlined, SortDescendingOutlined, SwapOutlined } from '@ant-design/icons';

import {getCommonStorage,getLoginFromLocalStorage,saveCommonStorage,getDummyFromLocalStorage,saveDummyToLocalStorage,getTransLocalStorage} from '../utils/storageUtils'
import PasteableDatePicker from './pasteable-date-picker';
const { TextArea } = Input;
message.config({ zIndex: 3000, getContainer: () => document.body });


const resolvePortInstrumentUrl = (item) => {
  const url = makeURL1(item);
  if (url) return url;

  const exchange = String(item?.Exchange || item?.ExchangeEn || '').toUpperCase();
  const code = String(item?.Code || '').trim();

  if (exchange === 'JPX' && code) {
    return `https://finance.yahoo.co.jp/quote/${removeTFromCode(code)}.T`;
  }

  return undefined;
};

const Option = Select.Option
const { TabPane } = Tabs;
const ALWAYS_VISIBLE_COLUMNS = ['Asset'];
const PORT_COLUMNS_DISPLAY_STORAGE_KEY = 'PortColumnsDisPlay';
const PORT_COLUMNS_ORDER_STORAGE_KEY = 'PortColumnsOrder';
const PORT_SECTOR_COLUMNS_DISPLAY_STORAGE_KEY = 'PortSectorColumnsDisPlay';
const PORT_SECTOR_COLUMNS_ORDER_STORAGE_KEY = 'PortSectorColumnsOrder';
const PORT_TABLE_SORT_STORAGE_KEY = 'TableSortInfo';
const ASSET_SEARCH_PAGE_SIZE_KEY = 'PortAssetSearchPageSize';
const ASSET_SEARCH_PAGE_SIZES = [20, 50, 100, 200];
const DEFAULT_ASSET_SEARCH_PAGE_SIZE = 50;

const readAssetSearchPageSize = () => {
  try {
    const stored = localStorage.getItem(ASSET_SEARCH_PAGE_SIZE_KEY);
    return ASSET_SEARCH_PAGE_SIZES.find((size) => String(size) === stored)
      || DEFAULT_ASSET_SEARCH_PAGE_SIZE;
  } catch {
    return DEFAULT_ASSET_SEARCH_PAGE_SIZE;
  }
};
const PORT_SECTOR_TABLE_SORT_STORAGE_KEY = 'PortSectorTableSortInfo';
const CASH_ACCOUNT_CODE = '__CASH_ACCOUNT__';
const DEFAULT_CASH_INSTRUMENT_CODE = 'JPYCASH';
const DEFAULT_CASH_INSTRUMENT_ASSET = '日本円預金';
const DEFAULT_CASH_INSTRUMENT_NAME = '日本円現金/普通預金';
const IRR_CF_HELP_MESSAGE = 'IRR計算用のキャッシュフロー';
const CUMULATIVE_INVESTMENT_HELP_MESSAGE = '取得原価の合計。現金口座の入出金を手入力している場合は、現金口座の IRR CF 合計の符号反転額';
const MARKET_VALUE_HELP_MESSAGE = '保有している全資産の時価額の合計';
const UNREALIZED_PROFIT_HELP_MESSAGE = '現在の評価額と保有中ポジションの取得原価との差額';
const REALIZED_PROFIT_HELP_MESSAGE = '売却や償還などで確定した損益';
const TOTAL_PROFIT_HELP_MESSAGE = '評価損益と実現損益の合計金額';
const TOTAL_PROFIT_RATE_HELP_MESSAGE = '総合益 ÷ 累計投資額';
const IRR_HELP_MESSAGE = '取得価格から現在価格までの収益率を、実際の保有日数をもとに365日基準で年率換算した値です。閏年をまたぐ場合も実際の日数で計算するため、ちょうど1年間の保有でも単純な騰落率とはわずかに異なる場合があります。';
const EXPECTED_RETURN_HELP_MESSAGE = '最適ポートフォリオの観測期間開始日（制約条件画面で定義）から今日までの年率リターン';
const EXPECTED_RISK_HELP_MESSAGE = '最適ポートフォリオの観測期間開始日（制約条件画面で定義）から今日までの日次リターンの標準偏差';
const SHARPE_RATIO_HELP_MESSAGE = '（期待収益率 - 無リスク金利）÷ 想定リスク';
const PORTFOLIO_MANAGEMENT_HELP_MESSAGE = 'ポートフォリオ管理では、保有資産の構成や損益、収益率を確認し、あなたのポートフォリオと最適ポートフォリオを比較できます。';

const PORTFOLIO_PERCENT_COLUMN_WIDTH = 96;

const PORTFOLIO_COLUMN_WIDTHS = {
  '': 24,
  Asset: 88,
  Sector: 104,
  Code: 84,
  TradeDate: 88,
  Name: 160,
  TaxCategoryDisplay: 72,
  EventTypeDisplay: 72,
  AutoPlan: 72,
  StartDate: 88,
  CurrentPriceDate: 88,
  Value: 92,
  CostBasis: 92,
  Cashflow: 92,
  IRRCashflow: 92,
  SettingAmount: 92,
  Profit: 92,
  UnrealizedProfit: 92,
  RealizedProfit: 92,
  ProfitRate: PORTFOLIO_PERCENT_COLUMN_WIDTH,
  CurrentPrice: 92,
  AvgPrice: 92,
  AdjustedAvgPrice: 92,
  Quantity: 72,
  AdjustedQuantity: 88,
  SimulationPercent: PORTFOLIO_PERCENT_COLUMN_WIDTH,
  OptimalPercent: PORTFOLIO_PERCENT_COLUMN_WIDTH,
  PercentDiff: PORTFOLIO_PERCENT_COLUMN_WIDTH,
  IRR: PORTFOLIO_PERCENT_COLUMN_WIDTH,
  Benchmark: 92,
};

export const normalizeNavBaseUnits = (value) => {
  const normalized = Number(value);
  return Number.isFinite(normalized) && normalized > 0 ? normalized : 1;
};

export const getInstrumentNavBaseUnits = (item) =>
  normalizeNavBaseUnits(item?.NavBaseUnits ?? item?.nav_base_units);

export const normalizeConstraintOperator = (value) => {
  const normalized = String(value ?? '').trim();
  if (normalized === '≦') {
    return '<=';
  }
  if (normalized === '≧') {
    return '>=';
  }
  return normalized;
};

const isPortDebugEnabled = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const params = new URLSearchParams(window.location.search || '');
  return params.get('debug') === '1' || window.localStorage.getItem('PortDebug') === '1';
};

const extractApiErrorMessage = (result, fallbackMessage) => {
  if (typeof result?.data === 'string') {
    return result.data;
  }
  return result?.data?.msg || result?.data?.message || fallbackMessage;
};

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const PIE_FALLBACK_COLORS = [
  '#1f77b4',
  '#ff7f0e',
  '#2ca02c',
  '#d62728',
  '#9467bd',
  '#8c564b',
  '#e377c2',
  '#7f7f7f',
  '#bcbd22',
  '#17becf',
];
const CURRENT_PIE_VIEW_ASSET = 'asset';
const CURRENT_PIE_VIEW_SECTOR = 'sector';
const CURRENT_PIE_VIEW_WORLD_SECTOR = 'world-sector';
const CURRENT_PIE_VIEW_WORLD_LOCATION = 'world-location';
const PORT_COLUMN_SETTINGS_BY_VIEW = {
  [CURRENT_PIE_VIEW_ASSET]: {
    display: PORT_COLUMNS_DISPLAY_STORAGE_KEY,
    order: PORT_COLUMNS_ORDER_STORAGE_KEY,
    sort: PORT_TABLE_SORT_STORAGE_KEY,
  },
  [CURRENT_PIE_VIEW_SECTOR]: {
    display: PORT_SECTOR_COLUMNS_DISPLAY_STORAGE_KEY,
    order: PORT_SECTOR_COLUMNS_ORDER_STORAGE_KEY,
    sort: PORT_SECTOR_TABLE_SORT_STORAGE_KEY,
  },
};
const SECTOR_MODE_ALLOWED_COLUMNS = [
  'Asset',
  'Name',
  'Sector',
  'EventTypeDisplay',
  'TradeDate',
  'Value',
  'SimulationPercent',
  'OptimalPercent',
  'PercentDiff',
  'CurrentPriceDate',
  'Benchmark',
  'Code',
];
const UNKNOWN_JAPAN_STOCK_SECTOR_LABEL = '未設定';
const FIXED_RATIO_CONSTRAINT_ASSET = '日本円預金';
const FIXED_RATIO_CONSTRAINT_BENCHMARK_LABEL = '個人向け国債（変動10年）';
const SECTOR_MODE_EXCLUDED_CASH_IDENTIFIERS = new Set([
  'JPYCASH',
  '日本円預金',
  'JPY DEPOSITS',
]);
const CONSTRAINT_LABEL_WIDTH = 225;
const CONSTRAINT_OPERATOR_WIDTH = 58;
const CONSTRAINT_VALUE_WIDTH = 58;
const CONSTRAINT_RATE_VALUE_WIDTH = 64;
const PIE_CONTROL_HEIGHT = 25;
const PIE_CONTROL_LINE_HEIGHT = '23px';
const PORT_PIE_NARROW_MEDIA_QUERY = '(max-width: 600px)';
const DISPLAY_SETTING_TABLET_MAX_WIDTH = 1024;
const DISPLAY_SETTING_DESKTOP_WIDTH = 480;
const NATURAL_CODE_COLLATOR = new Intl.Collator(['ja', 'en'], {
  numeric: true,
  sensitivity: 'base',
});
const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}(?:[T\s].*)?$/;
const TOPIX_17_SECTOR_DISPLAY_ORDER = [
  '食品',
  'エネルギー資源',
  '建設・資材',
  '素材・化学',
  '医薬品',
  '自動車・輸送機',
  '鉄鋼・非鉄',
  '機械',
  '電機・精密',
  '情報通信・サービスその他',
  '電力・ガス',
  '運輸・物流',
  '商社・卸売',
  '小売',
  '銀行',
  '金融（除く銀行）',
  '不動産',
];
const TOPIX_17_SECTOR_DISPLAY_ORDER_MAP = new Map(
  TOPIX_17_SECTOR_DISPLAY_ORDER.map((sectorName, index) => [sectorName, index])
);

const truncatePieLabelText = (value) => {
  const text = String(value ?? '').trim();
  if (text === '') {
    return '-';
  }
  return text;
};

const truncateDisplayText = (text, maxLength = 6) => {
  const chars = Array.from(String(text || ''));
  return chars.length > maxLength
    ? `${chars.slice(0, maxLength).join('')}...`
    : chars.join('');
};

const getIsNarrowPortfolioViewport = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.innerWidth <= 600;
};

const wrapColumnTitle = (title) => {
  if (typeof title !== 'string') {
    return title;
  }
  const parts = title.split('（');
  if (parts.length === 1) {
    return title;
  }
  return (
    <>
      {parts[0]}
      <wbr />
      {'（' + parts.slice(1).join('（')}
    </>
  );
};




const rateFormat = (num) => {
  if  (num==='None') return 'ー';
  if  (num==='-') return '-';
  return (Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
}
const percentFormat = (num) => {
  if  (num==='None') return 'ー';
  if  (num==='-') return '-';
  if (num === null || num === undefined || Number.isNaN(Number(num))) return '-';
  let v = num * 100 ;  
  return rateFormat(v).concat('%')
}

const getCurrencyLabel = (ccy) => {
  const normalized = String(ccy || '').toUpperCase();
  if (normalized === 'JPY') return '日本円';
  if (normalized === 'USD') return '米ドル';
  return normalized || '-';
}

const formatCurrencyAmount = (amount, ccy) => {
  if (amount === null || amount === undefined || Number.isNaN(Number(amount))) {
    return '-';
  }
  return String(ccy || '').toUpperCase() === 'JPY'
    ? numFormat(amount)
    : rateFormat(amount);
}

const formatDividendTaxRate = (grossAmount, taxAmount) => {
  const gross = Number(grossAmount);
  const tax = Number(taxAmount);
  if (!Number.isFinite(gross) || gross <= 0 || !Number.isFinite(tax) || tax < 0) {
    return '-';
  }
  const percentage = (tax / gross) * 100;
  return `${percentage.toFixed(3).replace(/\.?0+$/, '')}%`;
}



const spinStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.6)',
  zIndex: 9000,
  overflow: 'auto',
};

const createDefaultPortfolioTitleSettings = () => ([
  {name:'分類',dataIndex:'Asset',USD:'Asset',format:'rateFormat',visible:true,disabled:true,helpMessage:'資産クラスごとの区分'},
  {name:'銘柄コード',dataIndex:'Code',USD:'Code',format:'rateFormat',visible:true,disabled:false,helpMessage:'銘柄コード'},
  {name:'銘柄名',dataIndex:'Name',USD:'Name',format:'rateFormat',visible:true,disabled:false,helpMessage:'銘柄名'},
  {name:'業種',dataIndex:'Sector',USD:'Sector',format:'rateFormat',visible:true,disabled:false,helpMessage:'業種'},
  {name:'税区分',dataIndex:'TaxCategoryDisplay',USD:'TaxCategoryDisplay',format:'percentFormat',visible:true,disabled:false,helpMessage:'特定預り、NISA、iDeCo などの税区分'},
  {name:'取引区分',dataIndex:'EventTypeDisplay',USD:'EventTypeDisplay',format:'percentFormat',visible:true,disabled:false,helpMessage:'約定・配当・入金・出金の区分'},
  {name:'積立コース',dataIndex:'AutoPlan',USD:'AutoPlan',format:'percentFormat',visible:true,disabled:false,helpMessage:'積立設定の有無や積立コース'},
  {name:'取引日',dataIndex:'TradeDate',USD:'TradeDate',format:'rateFormat',visible:true,disabled:false,helpMessage:'各取引の取引日'},
  {name:'保有開始',dataIndex:'StartDate',USD:'StartDate',format:'rateFormat',visible:true,disabled:false,helpMessage:'保有開始の基準日'},
  {name:'保有数',dataIndex:'Quantity',USD:'quantity',format:'numFormat',visible:true,disabled:false,helpMessage:'現在の保有数量'},
  {name:'保有数（株式分割調整後）',dataIndex:'AdjustedQuantity',USD:'quantity',format:'numFormat',visible:true,disabled:false,helpMessage:'株式分割などを反映した調整後保有数量'},
  {name:'取得単価',dataIndex:'AvgPrice',USD:'avgPriceUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:'取得単価'},
  {name:'取得単価（株式分割調整後）',dataIndex:'AdjustedAvgPrice',USD:'avgPriceUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:'株式分割調整後の取得単価'},
  {name:'時価日付',dataIndex:'CurrentPriceDate',USD:'CurrentPriceDate',format:'rateFormat',visible:true,disabled:false,helpMessage:'時価単価の取得日'},
  {name:'時価単価',dataIndex:'CurrentPrice',USD:'priceUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:'現在の時価単価'},
  {name:'時価額',dataIndex:'Value',USD:'marketValueUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:'保有している全資産の時価額の合計'},
  {name:'設定額',dataIndex:'SettingAmount',USD:'profitUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:'積立や買付設定で入力した予定金額'},
  {name:'取得原価',dataIndex:'CostBasis',USD:'profitUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:'現在保有している数量に対応する取得原価'},
  {name:'受払額',dataIndex:'Cashflow',USD:'profitUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:'購入・売却・配当・手数料・税金を含む受払金額'},
  {name:'IRR CF',dataIndex:'IRRCashflow',USD:'profitUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:IRR_CF_HELP_MESSAGE},
  {name:'\u8a55\u4fa1\u76ca',dataIndex:'UnrealizedProfit',USD:'profitUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:UNREALIZED_PROFIT_HELP_MESSAGE},
  {name:'\u5b9f\u73fe\u76ca',dataIndex:'RealizedProfit',USD:'profitUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:REALIZED_PROFIT_HELP_MESSAGE},
  {name:'総合益',dataIndex:'Profit',USD:'profitUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:TOTAL_PROFIT_HELP_MESSAGE},
  {name:'総合益率',dataIndex:'ProfitRate',USD:'profitUSD',format:'rateFormat',visible:true,disabled:false,helpMessage:TOTAL_PROFIT_RATE_HELP_MESSAGE},
  {name:'収益年率',dataIndex:'IRR',USD:'IRR',format:'percentFormat',visible:true,disabled:false,helpMessage:IRR_HELP_MESSAGE},
  {name:'現在割合',dataIndex:'SimulationPercent',USD:'simulationPercent',format:'percentFormat',visible:true,disabled:false,helpMessage:'現在のポートフォリオにおける構成比'},
  {name:'最適割合',dataIndex:'OptimalPercent',USD:'optimalSimulationPercent',format:'percentFormat',visible:true,disabled:false,helpMessage:'最適化モデルが算出した推奨構成比'},
  {name:'割合差',dataIndex:'PercentDiff',USD:'percentageDiff',format:'percentFormat',visible:true,disabled:false,helpMessage:'最適割合 - 現在割合 の差'},
  {name:'ベンチマーク',dataIndex:'Benchmark',USD:'Benchmark',format:'percentFormat',visible:true,disabled:false,helpMessage:'資産区分の判定に参考としているベンチマーク'},
  {name:'資産区分',dataIndex:'AssetOptional',USD:'Asset',format:'rateFormat',visible:true,disabled:false,helpMessage:'資産区分の補助表示'},
]);

const cloneTitleSettings = (titles = []) => titles.map((item) => ({ ...item }));

const createSectorModeTitleSettings = (baseTitles = createDefaultPortfolioTitleSettings()) => (
  cloneTitleSettings(baseTitles).filter((item) => (
    SECTOR_MODE_ALLOWED_COLUMNS.includes(item.dataIndex)
    || ALWAYS_VISIBLE_COLUMNS.includes(item.dataIndex)
  ))
);

export default class Portfolio extends Component {

  reorderListRef = React.createRef();
  isUnmounted = false;
  loggedPieColorFallbackKeys = new Set();
  lastPortfolioSummaryDebugSignature = '';
  dividendPreviewRequestId = 0;
  assetETFDataRetryDelayMs = 1000;
  assetETFDataMaxAttempts = 3;
  assetSearchRequestId = 0;
  assetSearchKeyword = "";
  defaultAssetDataTitle = createDefaultPortfolioTitleSettings();
  defaultSectorDataTitle = createSectorModeTitleSettings(this.defaultAssetDataTitle);

  state = {
    loading : true,
    userId : '',
    locale: getTransLocalStorage(),
    tipMessage: '',
    tabInput:'',
    addVisible:false,
    openValSettingHelpKey:'',
    saveEnabled:false,
    activeTab: '',
    lastManuallyExpandedRowKey: null,
    lastOpenedChildRowIds: null,
    lastPortfolioExpandAction: null,
    visible:false,
    data : [],
    pageError:'',
    errorMsg:'',
    debugEnabled: isPortDebugEnabled(),
    debugInfo:null,
    searchData: [],
    assetETFData: [],
    assetETFDataStatus: 'idle',
    assetETFDataError: '',
    isJPYMode:true,
    isNarrowViewport: getIsNarrowPortfolioViewport(),
    currentPage:1,
    currentTitle:0,    
    currentStatus:'First',
    settingFlg:false,
    settingVisible:false,
    orderVisible:false,
    searchVisible:false,
    searchValue:'',
    searchResult:[],
    assetSearchTotal: 0,
    assetSearchPage: 1,
    assetSearchPageSize: readAssetSearchPageSize(),
    assetSearchPerformed:false,
    assetSearchSortOrder: '', assetSearchSortField: 'asset',
    currentPieView: CURRENT_PIE_VIEW_ASSET,
    sectorOptimalCache:{},
    currentSectorPayloadCache:{},
    worldStockBreakdownCache:{},
    sectorOptimalMessage:'',
    assetEditVisible:false,
    assetAddFlag:false,
    currentAssetItem:{},
    userAccounts:[],
    managedUserAccounts:[],
    accountManagerVisible:false,
    financialInstitutions:[],
    accountDraft:null,
    cashModalVisible:false,
    cashTransactionId:null,
    cashTransactionIsNew:true,
    cashTransactionType:'DEPOSIT',
    cashTransactionAmount:'',
    cashTransactionAmountFocused:false,
    cashTransactionDate: DateTimeToString(new Date()),
    cashTransactionMemo:'',
    cashTransactionAccountId:null,
    cashTransactionAccount:null,
    cashTransactionInstrumentCode: DEFAULT_CASH_INSTRUMENT_CODE,
    cashTransactionInstrumentAsset: DEFAULT_CASH_INSTRUMENT_ASSET,
    cashTransactionInstrumentName: DEFAULT_CASH_INSTRUMENT_NAME,
    settingAmountSnapshot:null,
    settingAmountDraft:numFormat(0),
    quantityDraft:'',
    priceDraft:'',
    fxRateDraft:'',
    cashflowDraft:'',
    assetNumericFieldInFocus:null,
    settingVisible2:false,
    ratioSettingList:[],
    ratioSettingOriginalList:[],
    ratioSettingMode: CURRENT_PIE_VIEW_ASSET,
    sorter:{},
    fixedDepositSetting:0,
    newObservValue:1,
    ratioSelectTitle:'閉じる',
    expandedKeys:[],
    selectedRowKey:'',
    tabEdit:{
      selectValue:'update',
      inputDisabled:false,
      inputValue:'',
    },
    dataTitlesByView: {
      [CURRENT_PIE_VIEW_ASSET]: createDefaultPortfolioTitleSettings(),
      [CURRENT_PIE_VIEW_SECTOR]: createSectorModeTitleSettings(),
    },
    dataTitle : createDefaultPortfolioTitleSettings(),
    tmpTitle:[],
    settingInitialTitle:[],
    applyTitleButton:'',
    orderDraft:[],
    reorderDragIndex:null,
    reorderDropIndex:null,
    reorderDragOffsetY:0,
    reorderDragStartY:null,
    selectedSettingTitleIndex:null,
    settingDragIndex:null,
    settingDropIndex:null,
    settingDragOffsetY:0,
    settingDragStartY:null,
    
    currentPieData:{
      appendPadding: [10, 10, 30, 10] ,
      data: [],      
      angleField: 'value',
      colorField: 'type',
      radius: 0.75,
      legend: false,
      autoFit: true, 
      startAngle: -Math.PI / 2,
      endAngle: Math.PI * 1.5,
      label: {
        type: 'spider',
        labelHeight: 40,
        formatter: (data) => this.formatCurrentPieLabel(data),
      },
      interactions: [
        {
          type: 'element-active',
        },
      ],
      tooltip: {
        customContent: (title, items) => this.customTooltip(title, items),
      },
    },

    optimalPieData:{
      appendPadding: [10, 10, 30, 10] ,
      data: [],      
      angleField: 'value',
      colorField: 'type',
      radius: 0.75,
      legend: false,
      autoFit: true, 
      startAngle: -Math.PI / 2,
      endAngle: Math.PI * 1.5,
      label: {
        type: 'spider',
        labelHeight: 40,
        formatter: (data) => this.formatOptimalPieLabel(data),
      },
      interactions: [
        {
          type: 'element-active',
        },
      ],
      tooltip: {
        customContent: (title, items) => this.customTooltip1(title, items),
      },
    },
    sectorOptimalPieData:{
      appendPadding: [10, 10, 30, 10] ,
      data: [],
      angleField: 'value',
      colorField: 'type',
      radius: 0.75,
      legend: false,
      autoFit: true,
      startAngle: -Math.PI / 2,
      endAngle: Math.PI * 1.5,
      label: {
        type: 'spider',
        labelHeight: 40,
        formatter: (data) => this.formatOptimalPieLabel(data),
      },
      interactions: [
        {
          type: 'element-active',
        },
      ],
      tooltip: {
        customContent: (title, items) => this.customTooltip1(title, items),
      },
    },
    searchColumns: [
      {
        title: 'Asset',
        dataIndex: 'Asset',
        width: '100%',
        key: 'Asset',
        render: (str,item) => (
          <div style={{minWidth:0, fontSize:12}} onClick={()=>this.handleClickAssetEdit(item)}>
            <div style={{display:'flex', alignItems:'start', margin:'5px 0'}}>
              <div style={{flex:'0 0 30px', width:30}}>
                <Button
                  type="link"
                  style={{width:30, padding:0}}
                  onClick={(event)=>{
                    event.stopPropagation();
                    this.handleClickAssetEdit(item);
                  }}
                  icon={<PlusCircleOutlined style={{fontSize:'140%'}}/>}
                />
              </div>

              <div
                style={{
                  display:'flex',
                  flexDirection:'column',
                  marginLeft:'10px',
                  flex:1,
                  minWidth:0,
                }}
              >
                <div
                  style={{
                    display:'grid',
                    gridTemplateColumns:'116px 120px minmax(0, 1fr)',
                    columnGap:'8px',
                    alignItems:'start',
                    textAlign:'left',
                  }}
                >
                  <div style={{overflowWrap:'anywhere'}}>
                    {item.Asset}
                    {this.renderAssetClassificationEvidence(item)}
                  </div>

                  <div style={{whiteSpace:'nowrap'}}>
                    <a
                      href={resolvePortInstrumentUrl(item)}
                      target='_blank'
                      rel='noopener noreferrer'
                      onClick={this.handleLinkClick}
                      style={{textDecoration:'underline', whiteSpace:'nowrap'}}
                    >
                      {removeTFromCode(item.Code)}
                    </a>
                  </div>

                  <div style={{minWidth:0}}>
                    {(() => {
                      const benchmarkDisplay = String(
                        item.BenchmarkIndex || ''
                      ).trim();

                      if (!benchmarkDisplay || benchmarkDisplay === '要決定') {
                        return null;
                      }

                      const benchmarkURL = String(
                        item.BenchmarkIndexURL || ''
                      ).trim();

                      if (!benchmarkURL) {
                        return benchmarkDisplay;
                      }

                      return (
                        <a
                          href={benchmarkURL}
                          target='_blank'
                          rel='noopener noreferrer'
                          onClick={this.handleLinkClick}
                          style={{
                            textDecoration:'underline',
                            overflowWrap:'anywhere',
                            minWidth:0,
                          }}
                        >
                          {benchmarkDisplay}
                        </a>
                      );
                    })()}
                  </div>
                </div>

                <div style={{whiteSpace:'normal', overflowWrap:'anywhere', lineHeight:1.5}}>
                  {item.Name}
                </div>
              </div>
            </div>
            <div style={{backgroundColor:'#c8c8c8', height:1, marginTop:2}}></div>
          </div>
        ),
      },
    ],
    tableColumns : [
      {
        title: '',
        dataIndex: '',
        width: 24,
        key: '0',
        fixed: 'left',
      },
      {
        title: wrapColumnTitle('分類'),
        dataIndex: 'Asset',
        width: PORTFOLIO_COLUMN_WIDTHS.Asset,
        key: '1',
        fixed: 'left',
        showSorterTooltip: false,
        sorter: (a, b) => a.Asset.localeCompare(b.Asset),
        render: (str,record) => (          
          <div style={{display:'flex', alignItems:'center', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', lineHeight:'1.2'}}>
            <div style={{flex:'0 0 auto', width:'12px', display:'flex', alignItems:'center', justifyContent:'center', marginRight:'2px'}}>
              {record.Folder===2 ? (
                <span
                  style={{
                    display:'inline-block',
                    width:'10px',
                    height:'10px',
                    borderRadius:'2px',
                    backgroundColor:record.Color,
                  }}
                />
              ) : null}
            </div>
            <div style={{overflow:'hidden', textOverflow:'ellipsis'}}>
              {this.getClassificationRenderContent(record)}
            </div>
          </div>
        ),
      },
      {
        title: wrapColumnTitle('資産区分'),
        dataIndex: 'AssetOptional',
        key: '1-asset-optional',
        width: PORTFOLIO_COLUMN_WIDTHS.Asset,
        fixed: 'left',
        showSorterTooltip: false,
        sorter: (a, b) =>
          this.getAssetClassDisplay(a).localeCompare(this.getAssetClassDisplay(b)),
        render: (v,record) => (          
          <div style={{display:'flex', alignItems:'center', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', lineHeight:'1.2'}}>
            <div style={{overflow:'hidden', textOverflow:'ellipsis'}}>
              {this.getAssetClassDisplay(record)}
            </div>
          </div>
        ),
      },
      {
        title: wrapColumnTitle('業種'),
        dataIndex: 'Sector',
        key: '1-1',
        width: PORTFOLIO_COLUMN_WIDTHS.Sector,
        fixed: 'left',
        align: 'left',
        ellipsis: true,
        showSorterTooltip: false,
        sorter: (a, b) => this.sortTextColumn(a.Sector, b.Sector),
        render: (v, record) => (
          <div style={{whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>
            {this.getSectorColumnDisplay(record)}
          </div>
        ),
      },
      {
        title: wrapColumnTitle('コード'),
        dataIndex: 'Code',
        key: '2',
        width: PORTFOLIO_COLUMN_WIDTHS.Code,
        fixed: 'left',
        align: 'left',
        showSorterTooltip: false,
        sorter: (a, b) => (String(a.Code || '')).localeCompare(String(b.Code || '')),
        render: (v, record) => {
          const codeDisplay = this.isInstrumentLinkRow(record)
            ? (record?.Code ? removeTFromCode(record.Code) : '-')
            : this.summarizeHierarchyText(record, (item) => item?.Code && removeTFromCode(item.Code));

          return (
            <div style={{whiteSpace:'nowrap'}}>
              {this.wrapInstrumentLink(record, codeDisplay)}
            </div>
          );
        },
      },
      {
        title: wrapColumnTitle('取引日'),
        dataIndex: 'TradeDate',
        key: '2-0',
        width: PORTFOLIO_COLUMN_WIDTHS.TradeDate,
        fixed: 'left',
        align: 'left',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortTextColumn((a.TradeDate ?? a.Asset), (b.TradeDate ?? b.Asset)),
        render: (v, record) => (
          <div style={{whiteSpace:'nowrap'}}>
            {this.getTradeDateRenderContent(record)}
          </div>
        ),
      },
      {
        title: wrapColumnTitle('銘柄名'),
        dataIndex: 'Name',
        key: '2-1',
        width: PORTFOLIO_COLUMN_WIDTHS.Name,
        align: 'left',
        ellipsis: true,
        showSorterTooltip: false,
        sorter: (a, b) => this.sortTextColumn(a.Name, b.Name),
        render: (v, record) => {
          const nameDisplay = this.isInstrumentLinkRow(record)
            ? (record?.Name || '-')
            : this.summarizeHierarchyText(record, (item) => item?.Name);

          return (
            <div style={{whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>
              {this.wrapInstrumentLink(record, nameDisplay)}
            </div>
          );
        },
      },
      {
        title: wrapColumnTitle('税区分'),
        dataIndex: 'TaxCategoryDisplay',
        width: PORTFOLIO_COLUMN_WIDTHS.TaxCategoryDisplay,
        key: '3',
        align: 'right',
        ellipsis: true,
        showSorterTooltip: false,
        sorter: (a, b) => this.sortTextColumn(a.TaxCategoryDisplay, b.TaxCategoryDisplay),
        render: (v, record) => this.summarizeHierarchyText(record, (item) => this.getTaxShortDisplayFromNode(item))
      },
      {
        title: <span>取引<br />区分</span>,
        dataIndex: 'EventTypeDisplay',
        width: PORTFOLIO_COLUMN_WIDTHS.EventTypeDisplay,
        key: '3-1',
        align: 'right',
        ellipsis: true,
        showSorterTooltip: false,
        sorter: (a, b) => this.sortTextColumn(a.EventTypeDisplay, b.EventTypeDisplay),
        render: (v, record) => this.summarizeHierarchyText(record, (item) => item?.EventTypeDisplay ?? this.getEventTypeDisplayFromNode(item))
      },
      {
        title: wrapColumnTitle('積立コース'),
        dataIndex: 'AutoPlan',
        width: PORTFOLIO_COLUMN_WIDTHS.AutoPlan,
        key: '4',
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortTextColumn(a.AutoPlan, b.AutoPlan),
        render: (v,record) => (
          <div>{this.summarizeHierarchyText(record, (item) => item?.AutoPlan)}</div>
        )
      },
      {
        title: wrapColumnTitle('保有開始'),
        dataIndex: 'StartDate',
        key: '5',
        width: PORTFOLIO_COLUMN_WIDTHS.StartDate,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.StartDate ,b.StartDate),
        render: (v,record) => (
          <div>{this.getStartDateDisplay(record)}</div>
        )
      },
      {
        title: wrapColumnTitle('時価額'),
        dataIndex: 'Value',
        key: '6',
        width: PORTFOLIO_COLUMN_WIDTHS.Value,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.Value ,b.Value),
        render: (v,record) => (
          <div>{this.isReservedTransactionRow(record) || record.Quantity===0 ? '-' : (record.DCcy ==='USD' ? rateFormat(v) : numFormat(v))}</div>
        )
      },
      {
        title: wrapColumnTitle('取得原価'),
        dataIndex: 'CostBasis',
        key: '6-1',
        width: PORTFOLIO_COLUMN_WIDTHS.CostBasis,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn((a.CostBasis ?? 0),(b.CostBasis ?? 0)),
        render: (v,record) => (
          <div>{this.getCostBasisDisplay(record)}</div>
        )
      },
      {
        title: wrapColumnTitle('受払額'),
        dataIndex: 'Cashflow',
        key: '7',
        width: PORTFOLIO_COLUMN_WIDTHS.Cashflow,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.Cashflow ,b.Cashflow),
        render: (v,record) => (
          <div>{this.isReservedTransactionRow(record) ? '-' : (record.DCcy ==='JPY' ? numFormat(v) : rateFormat(v))}</div>
        )
      },
      {
        title: wrapColumnTitle('IRR CF'),
        dataIndex: 'IRRCashflow',
        key: '7-0',
        width: PORTFOLIO_COLUMN_WIDTHS.IRRCashflow,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn((a.IRRCashflow ?? 0),(b.IRRCashflow ?? 0)),
        render: (v,record) => (
          <div>{this.isReservedTransactionRow(record) ? '-' : (record.DCcy === 'JPY' ? numFormat(v ?? 0) : rateFormat(v ?? 0))}</div>
        )
      },
      {
        title: wrapColumnTitle('設定額'),
        dataIndex: 'SettingAmount',
        key: '7-1',
        width: PORTFOLIO_COLUMN_WIDTHS.SettingAmount,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn((a.SettingAmount ?? 0),(b.SettingAmount ?? 0)),
        render: (v,record) => (
          <div>{this.getSettingAmountDisplay(v, record)}</div>
        )
      },
      {
        title: wrapColumnTitle('総合益'),
        dataIndex: 'Profit',
        key: '8',
        width: PORTFOLIO_COLUMN_WIDTHS.Profit,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.Profit ,b.Profit),
        render: (v,record) => (
          //20251230 UEDA Quantity===0 でも '-' にせず Profit を表示する
          <div>{this.isReservedTransactionRow(record) ? '-' : (record.DCcy === 'JPY' ? numFormat(v) : rateFormat(v))}</div>
        )
      },
      {
        title: wrapColumnTitle('\u8a55\u4fa1\u76ca'),
        dataIndex: 'UnrealizedProfit',
        key: '8-1',
        width: PORTFOLIO_COLUMN_WIDTHS.UnrealizedProfit,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.UnrealizedProfit ,b.UnrealizedProfit),
        render: (v,record) => (
          <div>{this.getUnrealizedProfitDisplay(record, v)}</div>
        )
      },
      {
        title: wrapColumnTitle('\u5b9f\u73fe\u76ca'),
        dataIndex: 'RealizedProfit',
        key: '8-2',
        width: PORTFOLIO_COLUMN_WIDTHS.RealizedProfit,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.RealizedProfit ,b.RealizedProfit),
        render: (v,record) => (
          <div>{this.isReservedTransactionRow(record) ? '-' : (record.DCcy === 'JPY' ? numFormat(v) : rateFormat(v))}</div>
        )
      },
      {
        title: wrapColumnTitle('総合益率'),
        dataIndex: 'ProfitRate',
        key: '9',
        width: PORTFOLIO_COLUMN_WIDTHS.ProfitRate,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.ProfitRate ,b.ProfitRate),
        render: (v,record) => (
          <div>{this.isReservedTransactionRow(record) || (record.CostBasis ?? 0) === 0 ? '-' : percentFormat(v)}</div>
        )
      },
      {
        title: wrapColumnTitle('時価日付'),
        dataIndex: 'CurrentPriceDate',
        key: '10',
        width: PORTFOLIO_COLUMN_WIDTHS.CurrentPriceDate,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.CurrentPrice ,b.CurrentPrice),
        render: (v,record) => (
          <div>{this.isReservedTransactionRow(record) || record.Quantity===0 ? '-' : record.CurrentPriceDate}</div>
        )
      },
      {
        title: wrapColumnTitle('時価単価'),
        dataIndex: 'CurrentPrice',
        key: '11',
        width: PORTFOLIO_COLUMN_WIDTHS.CurrentPrice,
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.CurrentPrice ,b.CurrentPrice),
        render: (v,record) => (
          <div>{this.isReservedTransactionRow(record) || record.Quantity===0 ? '-' : (record.DCcy ==='JPY' ? numFormat(v) : rateFormat(v))}</div>
        )
      },
      {
        title: wrapColumnTitle('取得単価'),
        dataIndex: 'AvgPrice',
        width: PORTFOLIO_COLUMN_WIDTHS.AvgPrice,
        key: '12',
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(
          this.getHierarchyWeightedAverage(a, 'AvgPrice', 'Quantity', 'AdjustedAvgPrice', 'AdjustedQuantity'),
          this.getHierarchyWeightedAverage(b, 'AvgPrice', 'Quantity', 'AdjustedAvgPrice', 'AdjustedQuantity')
        ),
        render: (v,record) => {
          const avgPrice = this.getHierarchyWeightedAverage(record, 'AvgPrice', 'Quantity', 'AdjustedAvgPrice', 'AdjustedQuantity');
          return <div>{this.getAvgPriceDisplay(record, avgPrice)}</div>
        }
      },
      {
        title: wrapColumnTitle(<>取得単価<br />- 分割後</>),
        dataIndex: 'AdjustedAvgPrice',
        width: PORTFOLIO_COLUMN_WIDTHS.AdjustedAvgPrice,
        key: '12-1',
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(
          this.getHierarchyWeightedAverage(a, 'AdjustedAvgPrice', 'AdjustedQuantity', 'AvgPrice', 'Quantity'),
          this.getHierarchyWeightedAverage(b, 'AdjustedAvgPrice', 'AdjustedQuantity', 'AvgPrice', 'Quantity')
        ),
        render: (v,record) => {
          const adjustedAvgPrice = this.getHierarchyWeightedAverage(record, 'AdjustedAvgPrice', 'AdjustedQuantity', 'AvgPrice', 'Quantity');
          return <div>{this.getAvgPriceDisplay(record, adjustedAvgPrice)}</div>
        }
      },
      {
        title: wrapColumnTitle('保有数'),
        dataIndex: 'Quantity',
        width: PORTFOLIO_COLUMN_WIDTHS.Quantity,
        key: '13',
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(
          this.getQuantityColumnDisplayValue(a, a?.Quantity),
          this.getQuantityColumnDisplayValue(b, b?.Quantity)
        ),
        render: (v,record) => (
          <div>{this.isReservedTransactionRow(record) ? '-' : numFormat(this.getQuantityColumnDisplayValue(record, v))}</div>
        )
      },
      {
        title: wrapColumnTitle(<>保有数<br />- 分割後</>),
        dataIndex: 'AdjustedQuantity',
        width: PORTFOLIO_COLUMN_WIDTHS.AdjustedQuantity,
        key: '13-1',
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.AdjustedQuantity ?? a.Quantity ,b.AdjustedQuantity ?? b.Quantity),
        render: (v,record) => (
          <div>{this.isReservedTransactionRow(record) ? '-' : numFormat(v ?? record.Quantity)}</div>
        )
      },
      {
        title: wrapColumnTitle('現在割合'),
        dataIndex: 'SimulationPercent',
        width: PORTFOLIO_COLUMN_WIDTHS.SimulationPercent,
        key: '14',
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.SimulationPercent ,b.SimulationPercent),
        render: (v,record) => (
          <div>{this.getPercentColumnDisplay(record, v, 'SimulationPercent')}</div>
        )
      },
      {
        title: wrapColumnTitle('最適割合'),
        dataIndex: 'OptimalPercent',
        width: PORTFOLIO_COLUMN_WIDTHS.OptimalPercent,
        key: '15',
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.OptimalPercent ,b.OptimalPercent),
        render: (v,record) => (
          <div>{this.getPercentColumnDisplay(record, v, 'OptimalPercent')}</div>
        )
      },
      {
        title: wrapColumnTitle('割合差'),
        dataIndex: 'PercentDiff',
        width: PORTFOLIO_COLUMN_WIDTHS.PercentDiff,
        key: '16',
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.PercentDiff ,b.PercentDiff),
        render: (v,record) => (
          <div>{this.getPercentColumnDisplay(record, v, 'PercentDiff')}</div>
        )
      },
      {
        title: wrapColumnTitle('収益年率'),
        dataIndex: 'IRR',
        width: PORTFOLIO_COLUMN_WIDTHS.IRR,
        key: '17',
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortColumn(a.IRR ,b.IRR),
        render: (v,record) => (
          <div>{this.isReservedTransactionRow(record) ? '-' : percentFormat(v)}</div>
        )
      },
      {
        title: wrapColumnTitle('ベンチマーク'),
        dataIndex: 'Benchmark',
        width: PORTFOLIO_COLUMN_WIDTHS.Benchmark,
        key: '18',
        align: 'right',
        showSorterTooltip: false,
        sorter: (a, b) => this.sortTextColumn(a.Benchmark, b.Benchmark),
        render: (v,record) => (
          <div>
            {this.state.currentPieView === CURRENT_PIE_VIEW_SECTOR
              ? this.getBenchmarkColumnDisplay(record)
              : this.getPortfolioBenchmarkDisplay(record)}
          </div>
        )
      }

    ],
    tableColumnsDisPlay:[]
  };

  

  customPieLable = (data) => {
      
    return data.type.replace(/-\d+$/, '')+'\n'+rateFormat1(data.percent*100)+'%'
  }
  getIsNarrowViewport = () => getIsNarrowPortfolioViewport();

  createViewportMediaQueryList = () => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return null;
    }
    return window.matchMedia(PORT_PIE_NARROW_MEDIA_QUERY);
  };

  syncViewportMode = () => {
    const nextIsNarrow = this.viewportMediaQueryList
      ? this.viewportMediaQueryList.matches
      : this.getIsNarrowViewport();
    if (nextIsNarrow !== this.state.isNarrowViewport) {
      this.setState({
        isNarrowViewport: nextIsNarrow,
      });
    }
  };

  handleViewportChange = () => {
    this.syncViewportMode();
  };

  extractPieEntryIndex = (type) => {
    const match = String(type ?? '').match(/-(\d+)$/);
    if (!match) {
      return Number.MAX_SAFE_INTEGER;
    }
    return Number(match[1]);
  };

  formatCurrentPieLabel = (data) => (
    `${truncatePieLabelText(data.type.replace(/-\d+$/, ''))}\n${Number(data.percent * 100).toFixed(1)}%`
  );

  formatOptimalPieLabel = (data) => (
    `${truncatePieLabelText(data.type.replace(/-\d+$/, ''))}\n${Number(data.percent * 100).toFixed(1)}%`
  );

  getResponsivePieData = (pieData, kind) => {
    if (!pieData) {
      return pieData;
    }
    if (this.state.isNarrowViewport && (kind === 'current' || kind === 'optimal')) {
      return {
        ...pieData,
        label: false,
      };
    }
    return pieData;
  };

  getNarrowPieLabels = (pieData) => {
    if (!this.state.isNarrowViewport) {
      return [];
    }
    const data = Array.isArray(pieData?.data) ? pieData.data : [];
    const totalValue = data.reduce((sum, item) => sum + (Number(item?.value) || 0), 0);
    return data.slice(0, 3).map((item) => ({
      key: item?.type || '',
      color: item?.color || '#5f6b76',
      label: truncatePieLabelText(String(item?.type || '').replace(/-\d+$/, '')),
      percent: `${numFormat(totalValue === 0 ? 0 : ((Number(item?.value) || 0) / totalValue) * 100)}%`,
    }));
  };

  renderNarrowPieLegend = (items = []) => {
    if (!items.length) {
      return null;
    }
    return (
      <div
        style={{
          position:'absolute',
          left:'8px',
          right:'8px',
          bottom:'6px',
          display:'flex',
          flexDirection:'column',
          gap:'2px',
          padding:'6px 8px',
          background:'rgba(255,255,255,0.82)',
          borderRadius:'8px',
          backdropFilter:'blur(2px)',
          pointerEvents:'none',
        }}
      >
        {items.map((item) => (
          <div
            key={item.key}
            style={{
              display:'flex',
              alignItems:'center',
              justifyContent:'space-between',
              gap:'8px',
              fontSize:'10px',
              lineHeight:'12px',
              color:'#2f3542',
              fontWeight:600,
            }}
          >
            <div style={{ display:'flex', alignItems:'center', gap:'6px', minWidth:0 }}>
              <span style={{ color:item.color, fontSize:'11px', lineHeight:'11px', flex:'0 0 auto' }}>■</span>
              <span style={{ whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{item.label}</span>
            </div>
            <span style={{ flex:'0 0 auto' }}>{item.percent}</span>
          </div>
        ))}
      </div>
    );
  };

  getSafePieColor = (color, index, context = {}) => {
    const normalized = typeof color === 'string' ? color.trim() : '';
    if (normalized) {
      return normalized;
    }

    const fallbackKey = [
      context?.type || 'unknown',
      context?.portfolio || '',
      context?.code || '',
      context?.benchmarkCode || '',
      context?.name || '',
      index,
    ].join('|');

    if (!this.loggedPieColorFallbackKeys.has(fallbackKey)) {
      this.loggedPieColorFallbackKeys.add(fallbackKey);
      console.warn('[PORT] Pie color fallback applied', {
        portfolio: context?.portfolio || '',
        type: context?.type || 'unknown',
        asset: context?.asset || '',
        name: context?.name || '',
        code: context?.code || '',
        benchmark: context?.benchmarkCode || '',
        originalColor: color,
        fallbackColor: PIE_FALLBACK_COLORS[index % PIE_FALLBACK_COLORS.length],
      });
    }

    return PIE_FALLBACK_COLORS[index % PIE_FALLBACK_COLORS.length];
  }
  sortColumn = (v1, v2) => {
    if  (v1===v2) {
      return 0;
    }else if  (v1==='None' || v1==='-') {
      return -1;
    }else if  (v2==='None' || v2==='-') {
      return 1;
    }else{
      return v1 - v2
    }
  }
  sortTextColumn = (v1, v2) => {
    const text1 = String(v1 ?? '').trim();
    const text2 = String(v2 ?? '').trim();
    if (text1 === text2) {
      return 0;
    }
    if (text1 === '' || text1 === '-') {
      return -1;
    }
    if (text2 === '' || text2 === '-') {
      return 1;
    }
    return text1.localeCompare(text2, 'ja');
  }

  normalizeDisplayOrderValue = (value) => {
    const normalized = Number(value);
    if (!Number.isFinite(normalized) || normalized < 0) {
      return null;
    }
    return normalized;
  }

  normalizeDefaultSortText = (value) => {
    const text = String(value ?? '').trim();
    if (text === '' || text === '-' || text === 'None') {
      return null;
    }
    return text;
  }

  normalizeDefaultSortCode = (value) => {
    const normalized = this.normalizeDefaultSortText(removeTFromCode(value ?? ''));
    if (!normalized || !/[0-9A-Za-z]/.test(normalized)) {
      return null;
    }
    return normalized;
  }

  normalizeDefaultSortDate = (value) => {
    const text = this.normalizeDefaultSortText(value);
    if (!text || !ISO_DATE_PATTERN.test(text)) {
      return null;
    }
    const timestamp = Date.parse(text);
    if (Number.isNaN(timestamp)) {
      return null;
    }
    return timestamp;
  }

  compareNullableValues = (left, right, compareFn) => {
    if (left === null && right === null) {
      return 0;
    }
    if (left === null) {
      return 1;
    }
    if (right === null) {
      return -1;
    }
    return compareFn(left, right);
  }

  compareNullableTextAsc = (left, right) => (
    this.compareNullableValues(left, right, (a, b) => a.localeCompare(b, 'ja'))
  )

  compareNullableNaturalCodeAsc = (left, right) => (
    this.compareNullableValues(left, right, (a, b) => NATURAL_CODE_COLLATOR.compare(a, b))
  )

  compareNullableNumberAsc = (left, right) => (
    this.compareNullableValues(left, right, (a, b) => a - b)
  )

  compareNullableNumberDesc = (left, right) => (
    this.compareNullableValues(left, right, (a, b) => b - a)
  )

  getHierarchySortKind = (row) => {
    if (this.isAssetClassRow(row)) return 'asset';
    if (this.isSectorRow(row)) return 'sector';
    if (this.isCodeRow(row)) return 'code';
    if (this.isTaxCategoryRow(row)) return 'tax';
    if (this.isTradeRow(row)) return 'trade';
    return 'other';
  }

  compareAssetClassRowsForDefaultSort = (leftRow, rightRow) => {
    const displayOrderCompare = this.compareNullableNumberAsc(
      this.normalizeDisplayOrderValue(leftRow?.AssetDisplayOrder),
      this.normalizeDisplayOrderValue(rightRow?.AssetDisplayOrder)
    );
    if (displayOrderCompare !== 0) {
      return displayOrderCompare;
    }

    const assetEnCompare = this.compareNullableTextAsc(
      this.normalizeDefaultSortText(leftRow?.AssetEn),
      this.normalizeDefaultSortText(rightRow?.AssetEn)
    );
    if (assetEnCompare !== 0) {
      return assetEnCompare;
    }

    return this.compareNullableTextAsc(
      this.normalizeDefaultSortText(leftRow?.Asset),
      this.normalizeDefaultSortText(rightRow?.Asset)
    );
  }

  compareSectorRowsForDefaultSort = (leftRow, rightRow) => {
    const leftSectorName = this.normalizeDefaultSortText(
      this.getJapanStockSectorLabel(leftRow?.Sector || leftRow?.Asset)
    );
    const rightSectorName = this.normalizeDefaultSortText(
      this.getJapanStockSectorLabel(rightRow?.Sector || rightRow?.Asset)
    );
    const leftDisplayOrder = TOPIX_17_SECTOR_DISPLAY_ORDER_MAP.get(leftSectorName);
    const rightDisplayOrder = TOPIX_17_SECTOR_DISPLAY_ORDER_MAP.get(rightSectorName);
    const leftSortRank = leftDisplayOrder ?? TOPIX_17_SECTOR_DISPLAY_ORDER.length;
    const rightSortRank = rightDisplayOrder ?? TOPIX_17_SECTOR_DISPLAY_ORDER.length;
    const officialOrderCompare = this.compareNullableNumberAsc(leftSortRank, rightSortRank);
    if (officialOrderCompare !== 0) {
      return officialOrderCompare;
    }

    return this.compareNullableTextAsc(
      leftSectorName,
      rightSectorName
    );
  }

  compareCodeRowsForDefaultSort = (leftRow, rightRow) => {
    const codeCompare = this.compareNullableNaturalCodeAsc(
      this.normalizeDefaultSortCode(leftRow?.Code || leftRow?.Asset),
      this.normalizeDefaultSortCode(rightRow?.Code || rightRow?.Asset)
    );
    if (codeCompare !== 0) {
      return codeCompare;
    }

    return this.compareNullableTextAsc(
      this.normalizeDefaultSortText(leftRow?.Name),
      this.normalizeDefaultSortText(rightRow?.Name)
    );
  }

  compareTaxRowsForDefaultSort = (leftRow, rightRow) => (
    this.compareNullableTextAsc(
      this.normalizeDefaultSortText(leftRow?.TaxCategoryDisplay || leftRow?.HierarchyLabel || leftRow?.Asset),
      this.normalizeDefaultSortText(rightRow?.TaxCategoryDisplay || rightRow?.HierarchyLabel || rightRow?.Asset)
    )
  )

  compareTradeRowsForDefaultSort = (leftRow, rightRow) => {
    const tradeDateCompare = this.compareNullableNumberDesc(
      this.normalizeDefaultSortDate(leftRow?.TradeDate),
      this.normalizeDefaultSortDate(rightRow?.TradeDate)
    );
    if (tradeDateCompare !== 0) {
      return tradeDateCompare;
    }

    return this.compareNullableNumberDesc(
      Number.isFinite(Number(leftRow?.Id)) ? Number(leftRow?.Id) : null,
      Number.isFinite(Number(rightRow?.Id)) ? Number(rightRow?.Id) : null
    );
  }

  compareRowsForDefaultHierarchySort = (leftRow, rightRow) => {
    const rankByKind = {
      asset: 1,
      sector: 2,
      code: 3,
      tax: 4,
      trade: 5,
      other: 9,
    };
    const leftKind = this.getHierarchySortKind(leftRow);
    const rightKind = this.getHierarchySortKind(rightRow);
    if (leftKind !== rightKind) {
      return (rankByKind[leftKind] || 9) - (rankByKind[rightKind] || 9);
    }

    if (leftKind === 'asset') {
      return this.compareAssetClassRowsForDefaultSort(leftRow, rightRow);
    }
    if (leftKind === 'sector') {
      return this.compareSectorRowsForDefaultSort(leftRow, rightRow);
    }
    if (leftKind === 'code') {
      return this.compareCodeRowsForDefaultSort(leftRow, rightRow);
    }
    if (leftKind === 'tax') {
      return this.compareTaxRowsForDefaultSort(leftRow, rightRow);
    }
    if (leftKind === 'trade') {
      return this.compareTradeRowsForDefaultSort(leftRow, rightRow);
    }

    return 0;
  }

  sortRowsByDefaultHierarchy = (rows) => {
    if (!Array.isArray(rows)) {
      return rows;
    }

    return rows
      .map((row) => ({
        ...row,
        children: this.sortRowsByDefaultHierarchy(row?.children),
      }))
      .sort((leftRow, rightRow) => this.compareRowsForDefaultHierarchySort(leftRow, rightRow));
  }

  formatInceptionDate = (value) => {
    if (!value) {
      return '';
    }

    return String(value).split(/[ T]/)[0];
  }

  customTooltip1 = (title, items) => {
    if  (items.length > 0){
      //this.handleSecClick(items[0].data.code)
    }

    return (
      <div style={{padding:5, fontSize:12, fontWeight:'bold', background: 'rgba(255, 255, 255, 0.8)' }}>
          {items.map((item, index) => 
          (
            <div
              key={`${item?.data?.type || 'tooltip'}-${item?.data?.code || index}`}
              style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}
            >
              <div style={{display:'flex',alignItems:'flex-start',height:'20px'}} >
                <div >{item.data.type.split('-')[0]} </div>
                <div style={{marginLeft:'10px'}}>{removeTFromCode(item.data.code)}</div>
                <div style={{marginLeft:'10px',color:'#a6a6a6'}}>開始：</div>
                <div >{this.formatInceptionDate(item.data.inceptionDate)} </div>
              </div>
              <div style={{height:'20px'}}>{item.data.fullName}</div>
          </div>

          )
          )}
      </div>
    );
  };
  customTooltip = (title, items) => {
    if  (items.length > 0){
      //this.handleSecClick(items[0].data.code)
    }

    return (
      <div style={{padding:5, fontSize:12, fontWeight:'bold', background: 'rgba(255, 255, 255, 0.8)' }}>
          {items.map((item, index) => 
          (
            <div
              key={`${item?.data?.type || 'tooltip'}-${item?.data?.code || index}`}
              style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}
            >
              <div style={{display:'flex',alignItems:'flex-start',height:'20px'}} >
                <div >{item.data.type.split('-')[0]} </div>
              </div>
              {Number.isFinite(Number(item?.data?.japanStockRatio)) && (
                <div style={{fontSize:'11px', fontWeight:'normal'}}>
                  日本株内比率: {rateFormat1((Number(item.data.japanStockRatio) || 0) * 100)}%
                </div>
              )}
              {Number.isFinite(Number(item?.data?.securityCount)) && (
                <div style={{fontSize:'11px', fontWeight:'normal'}}>
                  銘柄数: {numFormat(item.data.securityCount)}
                </div>
              )}
              {Array.isArray(item?.data?.securityItems) && item.data.securityItems.length > 0 && (
                <div style={{marginTop:'4px', fontSize:'11px', fontWeight:'normal'}}>
                  {item.data.securityItems.map((securityItem) => (
                    <div key={`${securityItem.code}-${securityItem.name}`}>
                      {removeTFromCode(securityItem.code)} {securityItem.name}
                    </div>
                  ))}
                </div>
              )}
          </div>

          )
          )}
      </div>
    );
  };

  getPortfolioChildrenForPie = (selectTab, data = this.state.data) => {
    const currentPortfolio = Array.isArray(data) ? data.find((item) => item?.Portfolio === selectTab) : null;
    return Array.isArray(currentPortfolio?.children) ? currentPortfolio.children : [];
  };

  isJapanStockAssetRow = (row) => {
    const candidates = [row?.Asset, row?.AssetOptional, row?.HierarchyAssetClass];
    return candidates.some((value) => String(value ?? '').trim() === '日本株');
  };

  getJapanStockSectorLabel = (value) => this.normalizeHierarchyText(value) ?? UNKNOWN_JAPAN_STOCK_SECTOR_LABEL;

  isValidJapanStockSectorLabel = (value) => {
    const normalized = String(value ?? '').trim();
    const normalizedLower = normalized.toLowerCase();

    return (
      normalized !== ''
      && normalized !== UNKNOWN_JAPAN_STOCK_SECTOR_LABEL
      && normalizedLower !== 'tbd'
      && normalizedLower !== 'unknown'
      && normalizedLower !== 'undefined'
      && normalizedLower !== 'null'
      && normalized !== '-'
    );
  };

  getJapanStockSectorFromItem = (item = {}) => {
    const candidates = [
      item?.sector_name,
      item?.sectorName,
      item?.sector,
      item?.Sector,
    ];

    const sectorName = candidates.find(
      (value) => this.isValidJapanStockSectorLabel(value)
    );

    return sectorName
      ? this.getJapanStockSectorLabel(sectorName)
      : UNKNOWN_JAPAN_STOCK_SECTOR_LABEL;
  };

  collectJapanStockSecuritySummaries = (rows, securities = new Map()) => {
    if (!Array.isArray(rows)) return securities;

    rows.forEach((row) => {
      if (!row || typeof row !== 'object') {
        return;
      }

      const securityKey = String(row?.Code ?? '').trim();
      if (securityKey !== '' && this.isCodeRow(row)) {
        const existing = securities.get(securityKey) || {
          code: securityKey,
          name: this.normalizeHierarchyText(row?.Name) ?? this.normalizeHierarchyText(row?.Asset) ?? '-',
          quantity: 0,
        };
        existing.quantity += Number(row?.Quantity) || 0;
        securities.set(securityKey, existing);
        return;
      }

      if (securityKey !== '' && this.isTradeRow(row)) {
        const existing = securities.get(securityKey) || {
          code: securityKey,
          name: this.normalizeHierarchyText(row?.Name) ?? this.normalizeHierarchyText(row?.Asset) ?? '-',
          quantity: 0,
        };
        existing.quantity += Number(row?.Quantity) || 0;
        securities.set(securityKey, existing);
      }

      if (Array.isArray(row?.children) && row.children.length > 0) {
        this.collectJapanStockSecuritySummaries(row.children, securities);
      }
    });

    return securities;
  };

  buildCurrentAssetPieEntries = (portfolioChildren, selectTab) => {
    const sortedRows = (portfolioChildren || [])
      .filter((row) => Number(row?.Value) !== 0)
      .slice()
      .sort((a, b) => Number(b?.Value || 0) - Number(a?.Value || 0));

    return sortedRows.map((item, index) => ({
      type: `${item?.Asset || '-'}-${index}`,
      fullName: '',
      color: this.getSafePieColor(item?.Color, index, {
        portfolio: selectTab,
        type: 'current',
        asset: item?.Asset,
        name: item?.Name,
        code: item?.Code,
      }),
      value: Number(item?.Value) || 0,
      code: '',
    }));
  };

  buildJapanStockSectorPieEntries = (portfolioChildren, selectTab, sectorColorMap = this.getSectorOptimalColorMap(selectTab)) => {
    const japanStockRow = (portfolioChildren || []).find((row) => this.isJapanStockAssetRow(row));
    if (!japanStockRow) {
      return [];
    }

    const japanStockMarketValue = Number(japanStockRow?.Value) || 0;
    const sectorRows = this.ensureJapanStockSectorGroups(Array.isArray(japanStockRow?.children) ? japanStockRow.children : [])
      .filter((row) => this.isSectorRow(row) && Number(row?.Value) !== 0)
      .slice()
      .sort((a, b) => Number(b?.Value || 0) - Number(a?.Value || 0));

    return sectorRows.map((item, index) => {
      const sectorName = this.getJapanStockSectorLabel(item?.Sector || item?.Asset);
      const preferredColor = item?.color_hex || sectorColorMap[sectorName] || item?.Color;
      const securityItems = Array.from(this.collectJapanStockSecuritySummaries(item?.children).values())
        .filter((securityItem) => Math.abs(Number(securityItem.quantity) || 0) > 0)
        .map(({ code, name }) => ({ code, name }))
        .sort((a, b) => String(a.code).localeCompare(String(b.code), 'ja'));
      return {
        type: `${sectorName}-${index}`,
        fullName: '',
        color: this.getSafePieColor(preferredColor, index, {
          portfolio: selectTab,
          type: 'sector',
          asset: japanStockRow?.Asset,
          name: sectorName,
          code: item?.Code,
        }),
        value: Number(item?.Value) || 0,
        code: '',
        japanStockRatio: japanStockMarketValue === 0 ? 0 : ((Number(item?.Value) || 0) / japanStockMarketValue),
        securityCount: securityItems.length,
        securityItems,
      };
    });
  };

  buildSectorOptimalColorMap = (sectorItems = []) => (
    (Array.isArray(sectorItems) ? sectorItems : []).reduce((acc, item) => {
      const sectorName = this.getJapanStockSectorFromItem(item);
      const colorHex = typeof item?.color_hex === 'string' ? item.color_hex.trim() : '';
      if (sectorName && colorHex) {
        acc[sectorName] = colorHex;
      }
      return acc;
    }, {})
  );

  getSectorOptimalColorMap = (selectTab) => {
    const sectorCache = this.state.sectorOptimalCache?.[selectTab];
    if (sectorCache?.colorMap && typeof sectorCache.colorMap === 'object') {
      return sectorCache.colorMap;
    }
    return {};
  };

  hasJapanStockSectorPieData = (selectTab, data = this.state.data) => (
    this.buildJapanStockSectorPieEntries(this.getPortfolioChildrenForPie(selectTab, data), selectTab).length > 0
  );

  mergeSectorOptimalItemMetadata = (
    responseItems = [],
    previousItems = []
  ) => {
    const previousByInstrumentId = new Map(
      (Array.isArray(previousItems) ? previousItems : []).map((item) => [
        this.normalizeInstrumentCodeKey(
          item?.instrument_id
          ?? item?.instrumentCode
          ?? item?.code
          ?? item?.Code
        ),
        item,
      ])
    );

    return (Array.isArray(responseItems) ? responseItems : []).map((item) => {
      const instrumentKey = this.normalizeInstrumentCodeKey(
        item?.instrument_id
        ?? item?.instrumentCode
        ?? item?.code
        ?? item?.Code
      );
      const previousItem = instrumentKey
        ? previousByInstrumentId.get(instrumentKey)
        : null;

      const responseSector = this.getJapanStockSectorFromItem(item);
      const previousSector = this.getJapanStockSectorFromItem(previousItem);

      const sectorName = this.isValidJapanStockSectorLabel(responseSector)
        ? responseSector
        : (
          this.isValidJapanStockSectorLabel(previousSector)
            ? previousSector
            : UNKNOWN_JAPAN_STOCK_SECTOR_LABEL
        );

      return {
        ...previousItem,
        ...item,
        sector_name: sectorName,
        color_hex:
          item?.color_hex
          || previousItem?.color_hex
          || '',
        instrument_name:
          item?.instrument_name
          || previousItem?.instrument_name
          || '',
      };
    });
  };

  buildSectorOptimalPieEntries = (sectorItems = [], selectTab) => (
    this.filterSectorModeExcludedCashItems(Array.isArray(sectorItems) ? sectorItems : [])
      .filter((item) => Number(item?.percentage) > 0)
      .slice()
      .sort((a, b) => Number(b?.percentage || 0) - Number(a?.percentage || 0))
      .map((item, index) => ({
        type: `${this.getJapanStockSectorFromItem(item)}-${index}`,
        fullName: item?.instrument_name || '',
        color: item?.color_hex || this.getSafePieColor(null, index, {
          portfolio: selectTab,
          type: 'sector-optimal',
          asset: '日本株',
          name: this.getJapanStockSectorFromItem(item),
          code: item?.instrument_id,
        }),
        value: Number(item?.percentage) || 0,
        code: item?.instrument_id || '',
        inceptionDate: item?.inception_date || '',
      }))
  );

  buildSectorOptimalCacheEntry = (payload = {}, selectTab, previousRepresentativeItems = []) => {
    const mergedSectorItems = this.mergeSectorOptimalItemMetadata(
      Array.isArray(payload?.items) ? payload.items : [],
      previousRepresentativeItems
    );
    const sectorItems = this.filterSectorModeExcludedCashItems(
      mergedSectorItems
    );
    const pieEntries = this.buildSectorOptimalPieEntries(
      sectorItems,
      selectTab
    );
    const colorMap = this.buildSectorOptimalColorMap(sectorItems);
    const pieColors = pieEntries.map((item) => item.color);
    const constraintMaps = this.extractSectorConstraintMaps(payload);
    return {
      status: payload?.status || 'success',
      message: payload?.message || '',
      needsRefresh: false,
      fetchedAt: new Date().toISOString(),
      colorMap,
      representativeItems: sectorItems,
      constraintMaps,
      Return: Number(payload?.Return) || 0,
      Vol: Number(payload?.Vol) || 0,
      Sharpe: Number(payload?.Sharpe) || 0,
      pieData: {
        ...this.state.sectorOptimalPieData,
        data: pieEntries,
        color: pieColors,
        theme: 'custom-theme',
      },
    };
  };

  shouldForceReloadSectorOptimalCache = (cacheEntry = null) => (
    !cacheEntry
      || cacheEntry?.status !== 'success'
      || Boolean(cacheEntry?.needsRefresh)
  );

  markSectorOptimalCacheStale = (portfolio) => {
    if (!portfolio) {
      return;
    }

    this.setState((prevState) => {
      const currentEntry = prevState.sectorOptimalCache?.[portfolio];
      if (!currentEntry) {
        return null;
      }

      return {
        sectorOptimalCache: {
          ...prevState.sectorOptimalCache,
          [portfolio]: {
            ...currentEntry,
            needsRefresh: true,
          },
        },
      };
    });
  };

  buildSavedSectorOptimalCache = (portfolioRecords = [], previousCache = this.state.sectorOptimalCache) => (
    (Array.isArray(portfolioRecords) ? portfolioRecords : []).reduce((acc, portfolioRecord) => {
      const portfolioName = portfolioRecord?.Portfolio;
      const savedPayload = portfolioRecord?.SavedSectorOptimal;
      if (!portfolioName || savedPayload?.status !== 'success') {
        return acc;
      }

      const previousRepresentativeItems = Array.isArray(previousCache?.[portfolioName]?.representativeItems)
        ? previousCache[portfolioName].representativeItems
        : [];
      const cacheEntry = this.buildSectorOptimalCacheEntry(
        savedPayload,
        portfolioName,
        previousRepresentativeItems
      );
      acc[portfolioName] = {
        ...cacheEntry,
        needsRefresh: false,
      };
      return acc;
    }, {})
  );

  buildCurrentSectorPieState = (pieData = {}, basePieState = this.state.currentPieData) => {
    const pieEntries = Array.isArray(pieData?.data) ? pieData.data : [];
    const pieColors = Array.isArray(pieData?.color)
      ? pieData.color
      : pieEntries.map((item) => item?.color).filter(Boolean);

    return {
      ...basePieState,
      ...pieData,
      data: pieEntries,
      color: pieColors,
      theme: pieData?.theme || 'custom-theme',
    };
  };

  fetchCurrentSectorPieData = async (selectTab = this.state.activeTab, portfolioRecord = null) => {
    const record = portfolioRecord || (this.state.data || []).find(
      (item) => item?.Portfolio === selectTab
    );

    if (!record) {
      return null;
    }

    try {
      const result = await reqGetJpSectorWeight({
        uid: this.state.userId,
        portfolio: selectTab,
      });

      if (result?.status !== 0) {
        message.error('現在ポートフォリオの日本株業種取得に失敗しました');
        return null;
      }

      const payload = result.data || null;

      if (payload?.status !== 'success') {
        const errorMessage = payload?.message || '対象となる日本株がありません';
        if (payload?.status === 'error') {
          message.error(errorMessage);
        }
        return {
          kind: 'non_success',
          payload,
          message: errorMessage,
        };
      }

      return {
        kind: 'success',
        payload,
        pieData: this.buildCurrentSectorPieState(payload?.pieData || {}),
      };
    } catch (error) {
      console.error('[PORT] JP sector weight API failed', error);
      message.error('現在ポートフォリオの日本株業種取得に失敗しました');
      return null;
    }
  };

  fetchSectorOptimalPieData = async (selectTab = this.state.activeTab, options = {}) => {
    const { force = false, portfolioRecord = null, previousRepresentativeItems = null } = options;
    const { data, sectorOptimalCache } = this.state;
    const record = portfolioRecord || (data || []).find((item) => item?.Portfolio === selectTab);

    if (!record) {
      return null;
    }

    if (!force && sectorOptimalCache?.[selectTab]) {
      return {
        kind: 'success',
        cacheEntry: sectorOptimalCache[selectTab],
        fromCache: true,
      };
    }

    let result;
    try {
      result = await reqGetSectorOptimalData({
        uid: this.state.userId,
        data: this.buildSectorOptimizationRequestRecord(record),
      });
    } catch (error) {
      console.error('[PORT] JP sector optimization API failed', error);
      message.error('日本株業種ベース最適化に失敗しました');
      return null;
    }

    if (result.status !== 0) {
      message.error('日本株業種ベース最適化に失敗しました');
      return null;
    }

    const payload = result.data || {};
    if (payload.status === 'success') {
      const representativeItems = Array.isArray(previousRepresentativeItems)
        ? previousRepresentativeItems
        : (
          Array.isArray(sectorOptimalCache?.[selectTab]?.representativeItems)
            ? sectorOptimalCache[selectTab].representativeItems
            : []
        );
      const nextCacheEntry = this.buildSectorOptimalCacheEntry(
        payload,
        selectTab,
        representativeItems
      );

      return {
        kind: 'success',
        cacheEntry: nextCacheEntry,
        payload,
      };
    }

    const nextMessage = payload.message || '対象業種がありません';
    if (payload.status === 'error') {
      message.error(nextMessage);
    } else if (payload.status === 'no_targets') {
      message.info(nextMessage);
    }

    return {
      kind: 'non_success',
      message: nextMessage,
      cacheEntry: {
        status: payload.status,
        message: nextMessage,
        colorMap: {},
        representativeItems: [],
        constraintMaps: { weightLb: {}, weightUb: {} },
        pieData: this.state.optimalPieData,
      },
      payload,
    };
  };

  getDisplayedOptimalStats = (portfolioRecord) => {
    if (this.state.currentPieView === CURRENT_PIE_VIEW_SECTOR) {
      const sectorCacheEntry = this.state.sectorOptimalCache?.[portfolioRecord?.Portfolio];
      if (sectorCacheEntry?.status === 'success') {
        return {
          Return: sectorCacheEntry?.Return ?? 0,
          Vol: sectorCacheEntry?.Vol ?? 0,
          Sharpe: sectorCacheEntry?.Sharpe ?? 0,
        };
      }
    }
    return {
      Return: portfolioRecord?.Return ?? 0,
      Vol: portfolioRecord?.Vol ?? 0,
      Sharpe: portfolioRecord?.Sharpe ?? 0,
    };
  };

  applySectorOptimalPercentagesToRows = (
    rows,
    sectorPercentMap,
    inheritedSector = '',
  ) => {
    if (!Array.isArray(rows)) return rows;

    return rows.map((row) => {
      if (!row || typeof row !== 'object') {
        return row;
      }

      const sectorValue = this.isSectorRow(row)
        ? row?.Asset
        : inheritedSector || row?.HierarchySector || row?.Sector;

      const normalizedSector = this.getJapanStockSectorLabel(sectorValue);

      const nextChildren = Array.isArray(row?.children)
        ? this.applySectorOptimalPercentagesToRows(
            row.children,
            sectorPercentMap,
            normalizedSector,
          )
        : row.children;

      let sectorOptimalPercent = row?.SectorOptimalPercent;

      if (String(row?.Asset ?? '').trim() === '日本株') {
        sectorOptimalPercent = Object.values(sectorPercentMap || {})
          .reduce((sum, value) => sum + (Number(value) || 0), 0);
      } else if (
        this.isSectorRow(row)
        || this.isCodeRow(row)
        || this.isTradeRow(row)
      ) {
        sectorOptimalPercent = sectorPercentMap?.[normalizedSector] ?? 0;
      }

      return {
        ...row,
        SectorOptimalPercent: sectorOptimalPercent ?? 0,
        children: nextChildren,
      };
    });
  };

  loadCurrentSectorPieData = async (selectTab = this.state.activeTab) => {
    const result = await this.fetchCurrentSectorPieData(selectTab);

    if (result?.kind !== 'success') {
      return result?.payload || null;
    }

    this.setState((prevState) => ({
      currentSectorPayloadCache: {
        ...prevState.currentSectorPayloadCache,
        [selectTab]: result.payload,
      },
      currentPieView: CURRENT_PIE_VIEW_SECTOR,
      currentPieData: result.pieData,
    }));

    return result.payload;
  };


  hasSavedSectorOptimalResult = (portfolioRecord) => (
    portfolioRecord?.SavedSectorOptimal?.status === 'success'
  );


  saveInitialSectorOptimalResult = async (
    selectTab,
    cacheEntry,
    portfolioRecord = null
  ) => {
    if (!selectTab || cacheEntry?.status !== 'success') {
      return false;
    }

    const record = portfolioRecord || (this.state.data || []).find(
      (item) => item?.Portfolio === selectTab
    );
    if (!record) {
      return false;
    }

    const result = await reqSaveOptimalData({
      uid: this.state.userId,
      data: {
        ...record,
        Return: cacheEntry?.Return ?? record?.Return ?? 0,
        Vol: cacheEntry?.Vol ?? record?.Vol ?? 0,
        Sharpe: cacheEntry?.Sharpe ?? record?.Sharpe ?? 0,
      },
      optimizationMode: 'JP_SECTOR',
      sectorOptimalItems: Array.isArray(cacheEntry?.representativeItems)
        ? cacheEntry.representativeItems
        : [],
    });

    return result?.status === 0;
  };


  loadSectorOptimalPieData = async (selectTab = this.state.activeTab, options = {}) => {
    const { force = false, autoSaveIfMissing = false } = options;
    const cached = this.state.sectorOptimalCache?.[selectTab];
    const portfolioRecord = options?.portfolioRecord || (this.state.data || []).find(
      (item) => item?.Portfolio === selectTab
    );
    const shouldAutoSaveInitialResult = autoSaveIfMissing
      && !this.hasSavedSectorOptimalResult(portfolioRecord);

    if (!force && cached && !this.shouldForceReloadSectorOptimalCache(cached)) {
      this.setState({
        sectorOptimalPieData: cached.pieData,
        sectorOptimalMessage: cached.message || '',
      });
      return cached;
    }

    this.setState({
      loading: true,
      tipMessage: '業種最適化中',
      sectorOptimalMessage: '',
    });

    const result = await this.fetchSectorOptimalPieData(selectTab, options);

    if (result?.kind === 'success') {
      if (shouldAutoSaveInitialResult) {
        await this.saveInitialSectorOptimalResult(
          selectTab,
          result.cacheEntry,
          portfolioRecord
        );
      }

      this.setState((prevState) => ({
        sectorOptimalCache: {
          ...prevState.sectorOptimalCache,
          [selectTab]: result.cacheEntry,
        },
        sectorOptimalPieData: result.cacheEntry.pieData,
        sectorOptimalMessage: result.cacheEntry.message || '',
        loading: false,
        tipMessage: '',
      }));
      return result.cacheEntry;
    }

    if (result?.kind === 'non_success') {
      this.setState((prevState) => ({
        sectorOptimalCache: {
          ...prevState.sectorOptimalCache,
          [selectTab]: {
            ...result.cacheEntry,
            pieData: prevState.optimalPieData,
          },
        },
        sectorOptimalPieData: prevState.optimalPieData,
        sectorOptimalMessage: result.message,
        loading: false,
        tipMessage: '',
      }));
      return {
        ...result.cacheEntry,
        pieData: this.state.optimalPieData,
      };
    }

    this.setState({
      loading: false,
      tipMessage: '',
    });
    return null;
  };

  extractSectorConstraintMaps = (payload = {}) => {
    const optimizationModelParams = payload?.debug_request?.optimize_request?.portfolio_optimizer_options?.optimization_model_params || {};
    return {
      weightLb: optimizationModelParams?.weight_lb || {},
      weightUb: optimizationModelParams?.weight_ub || {},
    };
  };

  shouldShowSettingAmountField = (currentAssetItem = this.state.currentAssetItem) => (
    Boolean(currentAssetItem?.AutoQuantity) && Boolean(currentAssetItem?.AutoPlan)
  );

  shouldInitializeSettlementAmount = (currentAssetItem = this.state.currentAssetItem) => {
    if (!currentAssetItem?.New) {
      return false;
    }

    const cashflow = Number(currentAssetItem?.Cashflow ?? currentAssetItem?.Amount ?? currentAssetItem?.Notional ?? 0);
    return !Number.isFinite(cashflow) || cashflow <= 0;
  };

  buildWorldStockBreakdownPieData = (payload = {}, view) => {
    const isSectorView = view === CURRENT_PIE_VIEW_WORLD_SECTOR;
    const source = isSectorView
      ? payload?.sectorWeights
      : payload?.locationWeights;

    const items = Array.isArray(source) ? source : [];

    const data = items
      .map((item, index) => {
        const name = String(
          isSectorView ? item?.sector : item?.location
        ).trim();
        const value = Number(item?.weight) || 0;

        if (!name || value <= 0) {
          return null;
        }

        return {
          type: `${name}-${index}`,
          fullName: name,
          value,
          color: this.getSafePieColor(null, index, {
            type: isSectorView ? 'world-sector' : 'world-location',
            name,
          }),
        };
      })
      .filter(Boolean);

    return {
      ...this.state.currentPieData,
      data,
      color: data.map((item) => item.color),
      theme: 'custom-theme',
    };
  };


  fetchWorldStockBreakdown = async (portfolioName, baseDate = null) => {
    const cached = this.state.worldStockBreakdownCache?.[portfolioName];
    if (cached?.status === 'success') {
      return cached;
    }

    try {
      const result = await reqGetWorldStockBreakdown({
        uid: this.state.userId,
        portfolio: portfolioName,
        ...(baseDate ? { baseDate } : {}),
      });

      if (result?.status !== 0) {
        message.error('世界株の業種・地域配分の取得に失敗しました');
        return null;
      }

      const payload = result.data || {};
      if (payload.status !== 'success') {
        message.info(payload.message || '世界株の業種・地域データがありません');
        return null;
      }

      this.setState((prevState) => ({
        worldStockBreakdownCache: {
          ...prevState.worldStockBreakdownCache,
          [portfolioName]: payload,
        },
      }));

      return payload;
    } catch (error) {
      console.error('[PORT] World stock breakdown API failed', error);
      message.error('世界株の業種・地域配分の取得に失敗しました');
      return null;
    }
  };


  handleCurrentPieViewChange = async (nextView) => {
    const { activeTab } = this.state;
    const nextDataTitle = this.getDataTitlesByView(nextView);
    const nextTableColumns = this.applySortInfoToTableColumns(
      this.state.tableColumns,
      this.getStoredSortInfo(nextView)
    );

    const commonNextState = {
      lastManuallyExpandedRowKey: null,
      lastOpenedChildRowIds: null,
      lastPortfolioExpandAction: null,
      selectedRowKey: '',
      dataTitle: nextDataTitle,
      tableColumns: nextTableColumns,
      tableColumnsDisPlay: this.buildTableColumnsDisplay(
        nextDataTitle,
        activeTab,
        this.state.data,
        nextView
      ),
    };

    if (
      nextView === CURRENT_PIE_VIEW_WORLD_SECTOR
      || nextView === CURRENT_PIE_VIEW_WORLD_LOCATION
    ) {
      this.setState({
        loading: true,
        tipMessage: '世界株構成を取得中',
      });

      const payload = await this.fetchWorldStockBreakdown(activeTab);

      if (!payload) {
        this.setState({
          loading: false,
          tipMessage: '',
        });
        return;
      }

      const pieData = this.buildWorldStockBreakdownPieData(
        payload,
        nextView
      );

      this.setState({
        ...commonNextState,
        currentPieView: nextView,
        currentPieData: pieData,
        sectorOptimalMessage: '',
        loading: false,
        tipMessage: '',
      });

      return;
    }

    if (nextView === CURRENT_PIE_VIEW_SECTOR && activeTab) {
      const cachedSectorOptimal = this.state.sectorOptimalCache?.[activeTab];
      const hasFreshSectorOptimal = cachedSectorOptimal?.status === 'success'
        && !this.shouldForceReloadSectorOptimalCache(cachedSectorOptimal);

      if (hasFreshSectorOptimal) {
        const currentSectorResult = await this.fetchCurrentSectorPieData(activeTab);

        if (currentSectorResult?.kind !== 'success') {
          return;
        }

        this.setState((prevState) => ({
          ...commonNextState,
          currentPieView: CURRENT_PIE_VIEW_SECTOR,
          currentSectorPayloadCache: {
            ...prevState.currentSectorPayloadCache,
            [activeTab]: currentSectorResult.payload,
          },
          currentPieData: currentSectorResult.pieData,
          sectorOptimalPieData: cachedSectorOptimal.pieData,
          sectorOptimalMessage: cachedSectorOptimal.message || '',
        }));
        return;
      }

      this.setState({
        loading: true,
        tipMessage: '業種最適化中',
      });

      const [currentSectorResult, sectorOptimalResult] = await Promise.all([
        this.fetchCurrentSectorPieData(activeTab),
        this.fetchSectorOptimalPieData(activeTab, {
          force: this.shouldForceReloadSectorOptimalCache(cachedSectorOptimal),
        }),
      ]);

      if (currentSectorResult?.kind !== 'success') {
        this.setState({
          loading: false,
          tipMessage: '',
        });
        return;
      }

      if (sectorOptimalResult?.kind === 'success') {
        const activePortfolioRecord = (this.state.data || []).find(
          (item) => item?.Portfolio === activeTab
        );
        if (!this.hasSavedSectorOptimalResult(activePortfolioRecord)) {
          await this.saveInitialSectorOptimalResult(
            activeTab,
            sectorOptimalResult.cacheEntry,
            activePortfolioRecord
          );
        }

        this.setState((prevState) => ({
          ...commonNextState,
          currentPieView: CURRENT_PIE_VIEW_SECTOR,
          currentSectorPayloadCache: {
            ...prevState.currentSectorPayloadCache,
            [activeTab]: currentSectorResult.payload,
          },
          currentPieData: currentSectorResult.pieData,
          sectorOptimalCache: {
            ...prevState.sectorOptimalCache,
            [activeTab]: sectorOptimalResult.cacheEntry,
          },
          sectorOptimalPieData: sectorOptimalResult.cacheEntry.pieData,
          sectorOptimalMessage: sectorOptimalResult.cacheEntry.message || '',
          loading: false,
          tipMessage: '',
        }));
        return;
      }

      this.setState((prevState) => ({
        ...commonNextState,
        currentPieView: CURRENT_PIE_VIEW_SECTOR,
        currentSectorPayloadCache: {
          ...prevState.currentSectorPayloadCache,
          [activeTab]: currentSectorResult.payload,
        },
        currentPieData: currentSectorResult.pieData,
        sectorOptimalPieData: prevState.optimalPieData,
        sectorOptimalMessage: sectorOptimalResult?.message || '',
        loading: false,
        tipMessage: '',
      }));
      return;
    }

    this.setState({
      ...commonNextState,
      currentPieView: nextView,
      sectorOptimalMessage: '',
    }, () => {
      this.PieSetting(activeTab);
    });
  };


  onChange = activeTab => {
    const { data, currentPieView } = this.state;
    const dataTitle = this.getDataTitlesByView(currentPieView);

    let newActiveTab = activeTab;
    const item = data.filter(v => v.Portfolio === activeTab);
    if (item.length === 0 && data.length > 0) {
      newActiveTab = data[0].Portfolio;
    }

    const nextSectorOptimalCache = currentPieView === CURRENT_PIE_VIEW_SECTOR
      ? this.state.sectorOptimalCache?.[newActiveTab]
      : null;
    const nextSectorOptimalPieData = nextSectorOptimalCache?.status === 'success'
      && !this.shouldForceReloadSectorOptimalCache(nextSectorOptimalCache)
      ? nextSectorOptimalCache.pieData
      : {
          ...this.state.sectorOptimalPieData,
          data: [],
          color: [],
        };

    this.setState({
      activeTab: newActiveTab,
      tableColumnsDisPlay: this.buildTableColumnsDisplay(dataTitle, newActiveTab, data),
      ...(currentPieView === CURRENT_PIE_VIEW_SECTOR
        ? {
            sectorOptimalPieData: nextSectorOptimalPieData,
            sectorOptimalMessage: nextSectorOptimalCache?.message || '',
          }
        : {}),
    }, async () => {
      const currentPortfolio = this.state.data.find(
        (portfolio) => portfolio?.Portfolio === newActiveTab
      );
      const portfolioChildren = Array.isArray(currentPortfolio?.children)
        ? currentPortfolio.children
        : [];
      const optimalPercentTotal = portfolioChildren.reduce(
        (total, child) => total + (Number(child?.OptimalPercent) || 0),
        0
      );

      if (
        newActiveTab
        && optimalPercentTotal <= 0
        && currentPieView !== CURRENT_PIE_VIEW_WORLD_SECTOR
        && currentPieView !== CURRENT_PIE_VIEW_WORLD_LOCATION
      ) {
        await this.handleCalcOptimal();
        return;
      }

      if (
        this.state.currentPieView === CURRENT_PIE_VIEW_WORLD_SECTOR
        || this.state.currentPieView === CURRENT_PIE_VIEW_WORLD_LOCATION
      ) {
        const worldView = this.state.currentPieView;

        await new Promise((resolve) => {
          this.setState((prevState) => ({
            currentPieData: {
              ...prevState.currentPieData,
              data: [],
              color: [],
            },
            loading: true,
            tipMessage: '世界株構成を取得中',
          }), resolve);
        });

        const payload = await this.fetchWorldStockBreakdown(newActiveTab);

        if (payload) {
          const pieData = this.buildWorldStockBreakdownPieData(
            payload,
            worldView
          );

          this.setState({
            currentPieData: pieData,
            loading: false,
            tipMessage: '',
          });
        } else {
          this.setState({
            loading: false,
            tipMessage: '',
          });
        }
      } else if (this.state.currentPieView === CURRENT_PIE_VIEW_SECTOR) {
        await new Promise((resolve) => {
          this.setState((prevState) => ({
            currentPieData: {
              ...prevState.currentPieData,
              data: [],
              color: [],
            },
          }), resolve);
        });

        await this.loadCurrentSectorPieData(newActiveTab);

        const cached = this.state.sectorOptimalCache?.[newActiveTab];
        if (
          cached?.status === 'success'
          && !this.shouldForceReloadSectorOptimalCache(cached)
        ) {
          this.setState({
            sectorOptimalPieData: cached.pieData,
            sectorOptimalMessage: cached.message || '',
          });
        } else {
          await this.loadSectorOptimalPieData(newActiveTab, {
            force: this.shouldForceReloadSectorOptimalCache(cached),
            autoSaveIfMissing: !cached,
          });
        }
      } else {
        this.PieSetting(newActiveTab);
      }
    });
  };

  orderDataTitle = (titles, orderedDataIndexes = []) => {
    if (!Array.isArray(titles) || titles.length === 0) {
      return [];
    }

    const originalOrder = new Map(titles.map((item, index) => [item.dataIndex, index]));
    const rank = new Map((orderedDataIndexes || []).map((dataIndex, index) => [dataIndex, index]));

    return [...titles].sort((a, b) => {
      const rankA = rank.has(a.dataIndex) ? rank.get(a.dataIndex) : Number.MAX_SAFE_INTEGER;
      const rankB = rank.has(b.dataIndex) ? rank.get(b.dataIndex) : Number.MAX_SAFE_INTEGER;
      if (rankA !== rankB) {
        return rankA - rankB;
      }
      return (originalOrder.get(a.dataIndex) ?? 0) - (originalOrder.get(b.dataIndex) ?? 0);
    });
  };

  getDefaultTitleSettingsForView = (view = this.state.currentPieView) => (
    view === CURRENT_PIE_VIEW_SECTOR
      ? cloneTitleSettings(this.defaultSectorDataTitle)
      : cloneTitleSettings(this.defaultAssetDataTitle)
  );

  getColumnPreferenceStorageKeys = (view = this.state.currentPieView) => (
    PORT_COLUMN_SETTINGS_BY_VIEW[view] || PORT_COLUMN_SETTINGS_BY_VIEW[CURRENT_PIE_VIEW_ASSET]
  );

  applySortInfoToTableColumns = (tableColumns = this.state.tableColumns, sortInfo = null) => (
    (tableColumns || []).map((col) => {
      if (!col.sorter) {
        return col;
      }
      return {
        ...col,
        sortOrder: sortInfo && sortInfo.field === col.dataIndex ? sortInfo.order : null,
      };
    })
  );

  getStoredSortInfo = (view = this.state.currentPieView) => {
    const { sort } = this.getColumnPreferenceStorageKeys(view);
    return getCommonStorage(sort);
  };

  normalizeStoredColumnOrder = (storedColumnOrder = [], view = this.state.currentPieView) => {
    if (!Array.isArray(storedColumnOrder)) {
      return null;
    }

    let nextOrder = [...storedColumnOrder];
    if (view === CURRENT_PIE_VIEW_ASSET) {
      if (nextOrder.includes('Value') && !nextOrder.includes('CostBasis')) {
        const valueIndex = nextOrder.indexOf('Value');
        nextOrder = [
          ...nextOrder.slice(0, valueIndex + 1),
          'CostBasis',
          ...nextOrder.slice(valueIndex + 1),
        ];
      }
      if (nextOrder.includes('Cashflow') && !nextOrder.includes('IRRCashflow')) {
        const cashflowIndex = nextOrder.indexOf('Cashflow');
        nextOrder = [
          ...nextOrder.slice(0, cashflowIndex + 1),
          'IRRCashflow',
          ...nextOrder.slice(cashflowIndex + 1),
        ];
      }
    }

    return nextOrder;
  };

  normalizeStoredColumnDisplay = (columnsDisplay = [], view = this.state.currentPieView) => {
    if (!Array.isArray(columnsDisplay)) {
      return null;
    }

    let nextDisplay = [...columnsDisplay];
    if (view === CURRENT_PIE_VIEW_ASSET) {
      if (nextDisplay.includes('Quantity') && !nextDisplay.includes('AdjustedQuantity')) {
        nextDisplay = [...nextDisplay, 'AdjustedQuantity'];
      }
      if (nextDisplay.includes('AvgPrice') && !nextDisplay.includes('AdjustedAvgPrice')) {
        nextDisplay = [...nextDisplay, 'AdjustedAvgPrice'];
      }
      if (nextDisplay.includes('Value') && !nextDisplay.includes('CostBasis')) {
        nextDisplay = [...nextDisplay, 'CostBasis'];
      }
      if (nextDisplay.includes('Cashflow') && !nextDisplay.includes('IRRCashflow')) {
        nextDisplay = [...nextDisplay, 'IRRCashflow'];
      }
    }

    return nextDisplay;
  };

  restoreTitleSettingsForView = (view = this.state.currentPieView) => {
    let nextTitles = this.getDefaultTitleSettingsForView(view);
    const { display, order } = this.getColumnPreferenceStorageKeys(view);
    const storedColumnOrder = this.normalizeStoredColumnOrder(getCommonStorage(order), view);
    const columnsDisplay = this.normalizeStoredColumnDisplay(getCommonStorage(display), view);

    if (storedColumnOrder !== null) {
      nextTitles = this.orderDataTitle(nextTitles, storedColumnOrder);
    }

    if (columnsDisplay !== null) {
      nextTitles = nextTitles.map((item) => ({
        ...item,
        visible: columnsDisplay.includes(item.dataIndex) || ALWAYS_VISIBLE_COLUMNS.includes(item.dataIndex),
      }));
    }

    return nextTitles;
  };

  getDataTitlesByView = (view = this.state.currentPieView, dataTitlesByView = this.state.dataTitlesByView) => (
    cloneTitleSettings(dataTitlesByView?.[view] || this.getDefaultTitleSettingsForView(view))
  );

  syncDataTitleForView = (view = this.state.currentPieView, overrides = {}) => {
    const nextDataTitle = this.getDataTitlesByView(view, overrides.dataTitlesByView);
    const nextTableColumns = this.applySortInfoToTableColumns(
      overrides.tableColumns ?? this.state.tableColumns,
      this.getStoredSortInfo(view)
    );
    return {
      ...overrides,
      dataTitle: nextDataTitle,
      tableColumns: nextTableColumns,
      tableColumnsDisPlay: this.buildTableColumnsDisplay(
        nextDataTitle,
        overrides.activeTab ?? this.state.activeTab,
        overrides.data ?? this.state.data,
        view
      ),
    };
  };

  buildTableColumnsDisplay = (titleSettings = this.state.dataTitle, activeTab = this.state.activeTab, data = this.state.data, view = this.state.currentPieView) => {
    const shouldShowIRRCashflow = this.shouldShowIRRCashflowColumn(this.getActivePortfolioRecord(data, activeTab));
    const blankColumns = this.state.tableColumns.filter((column) => column.dataIndex === '');
    const isSectorLinkedView = view === CURRENT_PIE_VIEW_SECTOR;
    const orderedColumns = (titleSettings || [])
      .filter((item) => item.visible || ALWAYS_VISIBLE_COLUMNS.includes(item.dataIndex))
      .map((item) => this.state.tableColumns.find((column) => column.dataIndex === item.dataIndex))
      .filter(Boolean)
      .filter((column) => shouldShowIRRCashflow || column.dataIndex !== 'IRRCashflow')
      .filter((column) => !isSectorLinkedView || SECTOR_MODE_ALLOWED_COLUMNS.includes(column.dataIndex))
      .map((column) => ({
        ...column,
        fixed: column.dataIndex === 'Asset' ? 'left' : undefined,
      }));

    return [...blankColumns, ...orderedColumns];
  };

  getVisibleTitles = (titles = this.state.dataTitle) => (
    (titles || []).filter((item) => item.visible || ALWAYS_VISIBLE_COLUMNS.includes(item.dataIndex))
  );

  getCurrentSectorPayload = (portfolioName) => this.state.currentSectorPayloadCache?.[portfolioName] || null;

  buildCurrentSectorItemMap = (payload = null) => (
    this.filterSectorModeExcludedCashItems(Array.isArray(payload?.items) ? payload.items : []).reduce((acc, item) => {
      const sectorName = this.getJapanStockSectorFromItem(item);
      acc[sectorName] = item;
      return acc;
    }, {})
  );

  buildOptimalSectorPercentMap = (portfolioName) => (
    this.filterSectorModeExcludedCashItems(Array.isArray(this.state.sectorOptimalCache?.[portfolioName]?.representativeItems)
      ? this.state.sectorOptimalCache[portfolioName].representativeItems
      : []
    ).reduce((acc, item) => {
      acc[this.getJapanStockSectorFromItem(item)] = Number(item?.percentage) || 0;
      return acc;
    }, {})
  );

  collectSectorModeTradeRows = (rows, trades = []) => {
    if (!Array.isArray(rows)) return trades;

    rows.forEach((row) => {
      if (this.isTradeRow(row)) {
        trades.push(row);
        return;
      }
      if (Array.isArray(row?.children) && row.children.length > 0) {
        this.collectSectorModeTradeRows(row.children, trades);
      }
    });

    return trades;
  };

  normalizeInstrumentCodeKey = (code) => {
    const normalizedCode = this.normalizeHierarchyText(code);
    if (!normalizedCode) {
      return null;
    }
    return String(removeTFromCode(normalizedCode)).trim().toUpperCase() || null;
  };

  collectSectorModeHoldingCodeKeys = (rows, values = new Set()) => {
    if (!Array.isArray(rows)) return values;

    rows.forEach((row) => {
      if (this.isCodeRow(row)) {
        const codeKey = this.normalizeInstrumentCodeKey(row?.Code || row?.Asset);
        if (codeKey) {
          values.add(codeKey);
        }
        return;
      }

      if (Array.isArray(row?.children) && row.children.length > 0) {
        this.collectSectorModeHoldingCodeKeys(row.children, values);
      }
    });

    return values;
  };

  extractSectorBreakdownEntries = (entry, inherited = {}) => {
    if (!entry || typeof entry !== 'object') {
      return [];
    }

    const nestedKeys = ['sectorWeights', 'items', 'lookthroughItems', 'breakdowns', 'details'];
    const nestedKey = nestedKeys.find((key) => Array.isArray(entry?.[key]) && entry[key].length > 0);
    if (nestedKey) {
      return entry[nestedKey].flatMap((child) => this.extractSectorBreakdownEntries(child, {
        instrumentCode: entry?.instrumentCode ?? entry?.code ?? entry?.Code ?? inherited.instrumentCode,
        instrumentName: entry?.instrumentName ?? entry?.instrument_name ?? entry?.name ?? inherited.instrumentName,
      }));
    }

    const sectorName = this.getJapanStockSectorLabel(
      entry?.sector_name ?? entry?.sector ?? entry?.Sector
    );
    const instrumentCode = entry?.instrumentCode ?? entry?.code ?? entry?.Code ?? inherited.instrumentCode;
    const normalizedCodeKey = this.normalizeInstrumentCodeKey(instrumentCode);

    if (!normalizedCodeKey || !sectorName) {
      return [];
    }

    return [{
      codeKey: normalizedCodeKey,
      code: String(instrumentCode || '').trim(),
      sectorName,
      marketValue: Number(
        entry?.marketValue
        ?? entry?.market_value
        ?? entry?.value
        ?? entry?.market_value_jpy
        ?? 0
      ) || 0,
      weight: Number(
        entry?.weight
        ?? entry?.ratio
        ?? entry?.percentage
        ?? entry?.share
        ?? 0
      ) || 0,
      instrumentName: entry?.instrumentName ?? entry?.instrument_name ?? entry?.name ?? inherited.instrumentName ?? '',
    }];
  };

  buildSectorBreakdownMap = (payload = null) => {
    const detailArrays = [
      payload?.itemSectorWeights,
      payload?.lookthroughItems,
      payload?.sectorBreakdownItems,
      payload?.lookthroughDetails,
    ].filter(Array.isArray);

    const aggregatedEntries = detailArrays
      .flatMap((entries) => entries.flatMap((entry) => this.extractSectorBreakdownEntries(entry)))
      .reduce((acc, entry) => {
        const entryKey = `${entry.codeKey}@@${entry.sectorName}`;
        const current = acc.get(entryKey) || {
          ...entry,
          marketValue: 0,
          weight: 0,
        };
        current.marketValue += Number(entry.marketValue) || 0;
        current.weight += Number(entry.weight) || 0;
        if (!current.instrumentName && entry.instrumentName) {
          current.instrumentName = entry.instrumentName;
        }
        acc.set(entryKey, current);
        return acc;
      }, new Map());

    return Array.from(aggregatedEntries.values()).reduce((acc, entry) => {
      if (!acc[entry.codeKey]) {
        acc[entry.codeKey] = [];
      }
      acc[entry.codeKey].push(entry);
      return acc;
    }, {});
  };

  scaleSectorModeTradeRow = (tradeRow, allocationRatio = 1, sectorName = tradeRow?.Sector) => {
    const ratio = Number.isFinite(Number(allocationRatio)) ? Number(allocationRatio) : 1;
    const scaleNumericValue = (value) => {
      const numericValue = Number(value);
      if (!Number.isFinite(numericValue)) {
        return value;
      }
      return numericValue * ratio;
    };

    return {
      ...tradeRow,
      Sector: sectorName,
      HierarchySector: sectorName,
      factsheetUrl: tradeRow?.factsheetUrl || tradeRow?.factsheet_url || '',
      factsheet_url: tradeRow?.factsheet_url || tradeRow?.factsheetUrl || '',
      Benchmark: '',
      Value: scaleNumericValue(tradeRow?.Value),
      Cashflow: scaleNumericValue(tradeRow?.Cashflow),
      IRRCashflow: scaleNumericValue(tradeRow?.IRRCashflow),
      ProfitCashflow: scaleNumericValue(tradeRow?.ProfitCashflow),
      CostBasis: scaleNumericValue(tradeRow?.CostBasis),
      Profit: scaleNumericValue(tradeRow?.Profit),
      UnrealizedProfit: scaleNumericValue(tradeRow?.UnrealizedProfit),
      RealizedProfit: scaleNumericValue(tradeRow?.RealizedProfit),
    };
  };

  buildSectorModeCodeRow = (codeRow, sectorName, sectorMetrics = {}, options = {}) => {
    const {
      allocatedValue = Number(codeRow?.Value) || 0,
      allocationRatio = 1,
      benchmark = '',
      factsheetUrl = '',
      portfolioTotalValue = 0,
    } = options;
    const tradeRows = this.collectSectorModeTradeRows(codeRow?.children)
      .slice()
      .sort((a, b) => this.compareTradeRowsForDefaultSort(a, b))
      .map((tradeRow) => {
        const scaledTradeRow = this.scaleSectorModeTradeRow({
          ...tradeRow,
          factsheetUrl,
          factsheet_url: factsheetUrl,
        }, allocationRatio, sectorName);
        const rawTradeValue = tradeRow?.Value;
        const hasValidTradeValue = !(
          rawTradeValue === null
          || rawTradeValue === undefined
          || rawTradeValue === ''
          || rawTradeValue === '-'
          || Number.isNaN(Number(rawTradeValue))
        );
        const tradeValue = Number(scaledTradeRow?.Value);
        const simulationPercent = hasValidTradeValue && Number.isFinite(tradeValue) && portfolioTotalValue > 0
          ? tradeValue / portfolioTotalValue
          : (hasValidTradeValue && Number.isFinite(tradeValue) && tradeValue === 0 ? 0 : undefined);

        return {
          ...scaledTradeRow,
          SimulationPercent: simulationPercent,
        };
      });
    const currentPercent = portfolioTotalValue > 0
      ? allocatedValue / portfolioTotalValue
      : sectorMetrics.currentPercent;
    const percentDiff = (Number(sectorMetrics.optimalPercent) || 0) - (Number(currentPercent) || 0);

    return {
      ...codeRow,
      /*
       * ルックスルーされた同一銘柄は複数業種に表示されるため、
       * 元のKeyをそのまま使うと、業種をまたいで行キーが重複する。
       * 業種名を含む表示用Keyを付与し、各表示行を一意に識別する。
       */
      Key: `sector-code:${sectorName}:${codeRow?.Key ?? codeRow?.Code ?? codeRow?.Asset ?? ''}`,
      children: tradeRows,
      Sector: sectorName,
      HierarchySector: sectorName,
      factsheetUrl,
      factsheet_url: factsheetUrl,
      Value: allocatedValue,
      SimulationPercent: currentPercent,
      OptimalPercent: sectorMetrics.optimalPercent,
      PercentDiff: percentDiff,
      Benchmark: benchmark,
    };
  };

  buildSectorModeRows = (portfolioRecord) => {
    const portfolioName = portfolioRecord?.Portfolio || this.state.activeTab;
    const japanStockRow = (portfolioRecord?.children || []).find((row) => this.isJapanStockAssetRow(row));
    if (!japanStockRow) {
      return [];
    }
    const portfolioTotalValue = (portfolioRecord?.children || [])
      .reduce((sum, row) => sum + (Number(row?.Value) || 0), 0);

    const currentSectorPayload = this.getCurrentSectorPayload(portfolioName);
    const currentSectorItemMap = this.buildCurrentSectorItemMap(currentSectorPayload);
    const optimalSectorPercentMap = this.buildOptimalSectorPercentMap(portfolioName);
    const sectorBreakdownMap = this.buildSectorBreakdownMap(currentSectorPayload);
    const hasResolvedSectorItems = Object.keys(currentSectorItemMap || {}).length > 0;
    const sectorRows = this.ensureJapanStockSectorGroups(Array.isArray(japanStockRow?.children) ? japanStockRow.children : [])
      .filter((row) => this.isSectorRow(row));

    const sourceSectorRowMap = sectorRows.reduce((acc, row) => {
      const sectorName = this.getJapanStockSectorLabel(row?.Sector || row?.Asset);
      acc[sectorName] = row;
      return acc;
    }, {});

    const sectorCodeRowsMap = {};
    const appendSectorCodeRow = (sectorName, codeRow) => {
      if (!sectorCodeRowsMap[sectorName]) {
        sectorCodeRowsMap[sectorName] = [];
      }
      sectorCodeRowsMap[sectorName].push(codeRow);
    };

    sectorRows.forEach((sectorRow) => {
      const fallbackSectorName = this.getJapanStockSectorLabel(sectorRow?.Sector || sectorRow?.Asset);
      (sectorRow?.children || [])
        .filter((row) => this.isCodeRow(row))
        .forEach((codeRow) => {
          const codeKey = this.normalizeInstrumentCodeKey(codeRow?.Code || codeRow?.Asset);
          const breakdownEntries = codeKey ? (sectorBreakdownMap?.[codeKey] || []) : [];

          if (breakdownEntries.length === 0) {
            if (
              hasResolvedSectorItems
              && fallbackSectorName === UNKNOWN_JAPAN_STOCK_SECTOR_LABEL
            ) {
              return;
            }
            appendSectorCodeRow(fallbackSectorName, codeRow);
            return;
          }

          const baseValue = Number(codeRow?.Value) || 0;
          const totalBreakdownValue = breakdownEntries.reduce((sum, entry) => sum + (Number(entry?.marketValue) || 0), 0);

          breakdownEntries.forEach((entry) => {
            const allocatedValue = Number(entry?.marketValue) || 0;
            const allocationRatio = totalBreakdownValue > 0
              ? allocatedValue / totalBreakdownValue
              : (baseValue > 0 && Number(entry?.weight) > 0 ? Number(entry.weight) : 1);

            appendSectorCodeRow(entry.sectorName, this.buildSectorModeCodeRow(codeRow, entry.sectorName, {}, {
              allocatedValue: allocatedValue || (baseValue * allocationRatio),
              allocationRatio,
              portfolioTotalValue,
            }));
          });
        });
    });

    const orderedSectorNames = [
      ...Object.keys(currentSectorItemMap || {}),
      ...Object.keys(sectorCodeRowsMap),
    ].filter((sectorName, index, all) => all.indexOf(sectorName) === index);

    return orderedSectorNames
      .map((sectorName) => {
        const sectorRow = sourceSectorRowMap?.[sectorName] || null;
        const currentSectorItem = currentSectorItemMap?.[sectorName] || null;
        const currentPercent = Number(currentSectorItem?.percentage) || 0;
        const optimalPercent = Number(optimalSectorPercentMap?.[sectorName]) || 0;
        const percentDiff = optimalPercent - currentPercent;
        const factsheetUrl = currentSectorItem?.factsheetUrl || currentSectorItem?.factsheet_url || '';
        const childCodeRows = (sectorCodeRowsMap?.[sectorName] || [])
          .map((row) => this.buildSectorModeCodeRow(row, sectorName, {
            currentPercent,
            optimalPercent,
            percentDiff,
          }, {
            allocatedValue: Number(row?.Value) || 0,
            allocationRatio: 1,
            benchmark: '',
            factsheetUrl,
            portfolioTotalValue,
          }));
        const holdingCodeCount = this.collectSectorModeHoldingCodeKeys(childCodeRows).size;
        const hasMultipleHoldings = holdingCodeCount >= 2;
        const singleHoldingCode = hasMultipleHoldings
          ? ''
          : (this.normalizeHierarchyText(childCodeRows?.[0]?.Code) || '');

        return {
          ...(sectorRow || {}),
          Key: `sector:${portfolioName}:${sectorName}`,
          Asset: sectorName,
          HierarchyLabel: sectorName,
          HierarchyType: 'sector',
          Folder: 3,
          Sector: sectorName,
          Value: Number(currentSectorItem?.market_value) || childCodeRows.reduce((sum, row) => sum + (Number(row?.Value) || 0), 0),
          SimulationPercent: currentPercent,
          OptimalPercent: optimalPercent,
          PercentDiff: percentDiff,
          CurrentPriceDate: this.summarizeDateValue(childCodeRows, 'CurrentPriceDate'),
          Benchmark: currentSectorItem?.instrument_id || '',
          Code: hasMultipleHoldings ? '複数有' : (currentSectorItem?.instrument_id || singleHoldingCode),
          URL: currentSectorItem?.benchmarkInstrumentUrl || currentSectorItem?.benchmark_instrument_url || '',
          Url: currentSectorItem?.benchmarkInstrumentUrl || currentSectorItem?.benchmark_instrument_url || '',
          url: currentSectorItem?.benchmarkInstrumentUrl || currentSectorItem?.benchmark_instrument_url || '',
          instrumentUrl: currentSectorItem?.benchmarkInstrumentUrl || currentSectorItem?.benchmark_instrument_url || '',
          factsheetUrl,
          factsheet_url: factsheetUrl,
          DisableInstrumentLink: hasMultipleHoldings,
          HoldingCodeCount: holdingCodeCount,
          children: childCodeRows,
        };
      })
      .filter((row) => Number(row?.Value) !== 0 || Number(row?.SimulationPercent) !== 0)
      .map((row) => ({
        ...row,
        children: this.sortRowsByDefaultHierarchy(row?.children),
      }))
      .sort((a, b) => this.compareSectorRowsForDefaultSort(a, b));
  };

  getOrderableTitles = (titles = this.state.dataTitle) => (
    this.getVisibleTitles(titles).filter((item) => item.dataIndex !== 'Asset')
  );

  hasColumnPreferenceChanges = (draftTitles = this.state.tmpTitle, baseTitles = this.state.dataTitle) => {
    if (!Array.isArray(draftTitles) || !Array.isArray(baseTitles)) {
      return false;
    }
    if (draftTitles.length !== baseTitles.length) {
      return true;
    }

    return draftTitles.some((item, index) => {
      const baseItem = baseTitles[index];
      return item.dataIndex !== baseItem?.dataIndex || item.visible !== baseItem?.visible;
    });
  };

  getColumnPreferenceActionLabel = (draftTitles = this.state.tmpTitle, baseTitles = this.state.dataTitle) => (
    this.hasColumnPreferenceChanges(draftTitles, baseTitles) ? '適用' : '閉じる'
  );

  getColumnPreferenceBaseTitles = () => {
    const { settingInitialTitle, currentPieView } = this.state;
    return Array.isArray(settingInitialTitle) && settingInitialTitle.length > 0
      ? settingInitialTitle
      : this.getDataTitlesByView(currentPieView);
  };

  applyColumnPreferences = (nextDataTitle) => {
    const currentView = this.state.currentPieView;
    const dataIndexs = nextDataTitle.filter((item) => item.visible).map((item) => item.dataIndex);
    const orderedDataIndexes = nextDataTitle.map((item) => item.dataIndex);
    const tableColumnsDisPlay = this.buildTableColumnsDisplay(nextDataTitle, this.state.activeTab, this.state.data, currentView);
    const nextDataTitlesByView = {
      ...this.state.dataTitlesByView,
      [currentView]: cloneTitleSettings(nextDataTitle),
    };
    const storageKeys = this.getColumnPreferenceStorageKeys(currentView);

    this.setState({
      dataTitlesByView: nextDataTitlesByView,
      dataTitle: nextDataTitle,
      tableColumnsDisPlay,
    });

    saveCommonStorage(storageKeys.display, dataIndexs);
    saveCommonStorage(storageKeys.order, orderedDataIndexes);
  };

  moveOrderItem = (items, fromIndex, toIndex) => {
    if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0 || fromIndex >= items.length || toIndex >= items.length) {
      return items;
    }
    const nextItems = [...items];
    const [movedItem] = nextItems.splice(fromIndex, 1);
    nextItems.splice(toIndex, 0, movedItem);
    return nextItems;
  };

  handleClickOrderSetting = () => {
    this.setState({
      orderVisible:true,
      orderDraft:this.getOrderableTitles(this.getDataTitlesByView(this.state.currentPieView)),
      reorderDragIndex:null,
      reorderDropIndex:null,
    });
  };

  handleOrderMove = (fromIndex, direction) => {
    const toIndex = fromIndex + direction;
    this.setState((prevState) => {
      const nextOrderDraft = this.moveOrderItem(prevState.orderDraft, fromIndex, toIndex);
      return {
        orderDraft: nextOrderDraft,
      };
    });
  };

  commitOrderDraft = () => {
    const orderedVisibleIndexes = ['Asset', ...this.state.orderDraft.map((item) => item.dataIndex)];
    const nextDataTitle = this.orderDataTitle(this.getDataTitlesByView(this.state.currentPieView), orderedVisibleIndexes);
    this.applyColumnPreferences(nextDataTitle);
    message.success('保存しました');
    this.setState({
      orderVisible:false,
      reorderDragIndex:null,
      reorderDropIndex:null,
    });
  };

  closeOrderDrawer = () => {
    this.clearReorderPointerDrag();
    this.commitOrderDraft();
  };

  updateReorderDropIndexFromPoint = (clientX, clientY) => {
    const element = document.elementFromPoint(clientX, clientY);
    const itemElement = element?.closest?.('[data-reorder-index]');
    if (!itemElement) {
      return;
    }
    const nextIndex = Number(itemElement.getAttribute('data-reorder-index'));
    if (!Number.isNaN(nextIndex)) {
      this.setState({ reorderDropIndex: nextIndex });
    }

    const container = this.reorderListRef.current;
    if (container) {
      const rect = container.getBoundingClientRect();
      const threshold = 48;
      if (clientY < rect.top + threshold) {
        container.scrollTop -= 18;
      } else if (clientY > rect.bottom - threshold) {
        container.scrollTop += 18;
      }
    }
  };

  handleReorderPointerMove = (event) => {
    if (this.state.reorderDragIndex === null) {
      return;
    }
    event.preventDefault();
    this.updateReorderDropIndexFromPoint(event.clientX, event.clientY);
  };

  clearReorderPointerDrag = () => {
    window.removeEventListener('pointermove', this.handleReorderPointerMove);
    window.removeEventListener('pointerup', this.handleReorderPointerUp);
    window.removeEventListener('pointercancel', this.handleReorderPointerUp);
    this.setState({
      reorderDragIndex:null,
      reorderDropIndex:null,
      reorderDragOffsetY:0,
      reorderDragStartY:null,
    });
  };

  handleReorderPointerUp = () => {
    this.setState((prevState) => {
      const { reorderDragIndex, reorderDropIndex, orderDraft } = prevState;
      const shouldMove = reorderDragIndex !== null && reorderDropIndex !== null && reorderDragIndex !== reorderDropIndex;
      const nextOrderDraft = shouldMove ? this.moveOrderItem(orderDraft, reorderDragIndex, reorderDropIndex) : orderDraft;
      return {
        orderDraft: nextOrderDraft,
        reorderDragIndex:null,
        reorderDropIndex:null,
      };
    }, () => {
      window.removeEventListener('pointermove', this.handleReorderPointerMove);
      window.removeEventListener('pointerup', this.handleReorderPointerUp);
      window.removeEventListener('pointercancel', this.handleReorderPointerUp);
    });
  };

  handleReorderPointerDown = (index) => (event) => {
    event.preventDefault();
    window.addEventListener('pointermove', this.handleReorderPointerMove, { passive: false });
    window.addEventListener('pointerup', this.handleReorderPointerUp);
    window.addEventListener('pointercancel', this.handleReorderPointerUp);
    this.setState({
      reorderDragIndex:index,
      reorderDropIndex:index,
    });
  };

  moveSettingTitleItem = (items, fromIndex, toIndex) => {
    const fixedItems = (items || []).filter((item) => item.dataIndex === 'Asset');
    const movableItems = (items || []).filter((item) => item.dataIndex !== 'Asset');
    const nextMovableItems = this.moveOrderItem(movableItems, fromIndex, toIndex);
    return [...fixedItems, ...nextMovableItems];
  };

  updateSettingDropIndexFromPoint = (clientX, clientY) => {
    const element = document.elementFromPoint(clientX, clientY);
    const itemElement = element?.closest?.('[data-setting-title-index]');
    if (!itemElement) {
      return;
    }
    const itemIndex = Number(itemElement.getAttribute('data-setting-title-index'));
    if (Number.isNaN(itemIndex)) {
      return;
    }

    const { settingDragIndex, tmpTitle } = this.state;
    const movableCount = (tmpTitle || []).filter((item) => item.dataIndex !== 'Asset').length;
    const rect = itemElement.getBoundingClientRect();
    const isAfterMiddle = clientY > rect.top + rect.height / 2;
    let nextIndex = itemIndex;

    if (settingDragIndex !== null && settingDragIndex < itemIndex) {
      nextIndex = isAfterMiddle ? itemIndex : itemIndex - 1;
    } else if (settingDragIndex !== null && settingDragIndex > itemIndex) {
      nextIndex = isAfterMiddle ? itemIndex + 1 : itemIndex;
    }

    nextIndex = Math.max(0, Math.min(nextIndex, movableCount - 1));
    if (!Number.isNaN(nextIndex)) {
      this.setState({ settingDropIndex: nextIndex });
    }

    const container = this.reorderListRef.current;
    if (container) {
      const rect = container.getBoundingClientRect();
      const threshold = 48;
      if (clientY < rect.top + threshold) {
        container.scrollTop -= 18;
      } else if (clientY > rect.bottom - threshold) {
        container.scrollTop += 18;
      }
    }
  };

  handleSettingTitlePointerMove = (event) => {
    if (this.state.settingDragIndex === null) {
      return;
    }
    event.preventDefault();
    this.updateSettingDropIndexFromPoint(event.clientX, event.clientY);
    this.setState((prevState) => ({
      settingDragOffsetY: prevState.settingDragStartY === null ? 0 : event.clientY - prevState.settingDragStartY,
    }));
  };

  handleSettingTitlePointerUp = () => {
    this.setState((prevState) => {
      const { settingDragIndex, settingDropIndex, tmpTitle } = prevState;
      const baseTitles = (Array.isArray(prevState.settingInitialTitle) && prevState.settingInitialTitle.length > 0)
        ? prevState.settingInitialTitle
        : prevState.dataTitle;
      const shouldMove = settingDragIndex !== null && settingDropIndex !== null && settingDragIndex !== settingDropIndex;
      const nextTitle = shouldMove ? this.moveSettingTitleItem(tmpTitle, settingDragIndex, settingDropIndex) : tmpTitle;
      return {
        tmpTitle: nextTitle,
        currentTitle: 0,
        currentStatus: 'First',
        applyTitleButton: shouldMove
          ? this.getColumnPreferenceActionLabel(nextTitle, baseTitles)
          : prevState.applyTitleButton,
        selectedSettingTitleIndex: shouldMove
          ? settingDropIndex
          : prevState.selectedSettingTitleIndex,
        settingDragIndex:null,
        settingDropIndex:null,
        settingDragOffsetY:0,
        settingDragStartY:null,
      };
    }, () => {
      window.removeEventListener('pointermove', this.handleSettingTitlePointerMove);
      window.removeEventListener('pointerup', this.handleSettingTitlePointerUp);
      window.removeEventListener('pointercancel', this.handleSettingTitlePointerUp);
    });
  };

  handleSettingTitlePointerDown = (index) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    window.addEventListener('pointermove', this.handleSettingTitlePointerMove, { passive: false });
    window.addEventListener('pointerup', this.handleSettingTitlePointerUp);
    window.addEventListener('pointercancel', this.handleSettingTitlePointerUp);
    this.setState({
      settingDragIndex:index,
      settingDropIndex:index,
      settingDragOffsetY:0,
      settingDragStartY:event.clientY,
      selectedSettingTitleIndex:index,
    });
  };

  handleSettingTitleMove = (fromIndex, direction) => {
    const toIndex = fromIndex + direction;
    this.setState((prevState) => {
      const movableCount = (prevState.tmpTitle || []).filter((item) => item.dataIndex !== 'Asset').length;
      if (fromIndex < 0 || toIndex < 0 || fromIndex >= movableCount || toIndex >= movableCount) {
        return {};
      }

      const baseTitles = (Array.isArray(prevState.settingInitialTitle) && prevState.settingInitialTitle.length > 0)
        ? prevState.settingInitialTitle
        : prevState.dataTitle;
      const nextTitle = this.moveSettingTitleItem(prevState.tmpTitle, fromIndex, toIndex);
      return {
        tmpTitle: nextTitle,
        currentTitle: 0,
        currentStatus: 'First',
        applyTitleButton: this.getColumnPreferenceActionLabel(nextTitle, baseTitles),
        selectedSettingTitleIndex: toIndex,
      };
    });
  };

  handleSettingTitleCardClick = (event, index) => {
    const interactiveElement = event.target?.closest?.(
      'button,input,textarea,select,a,.ant-checkbox-wrapper,.ant-checkbox,.ant-btn,.ant-select,[role="button"]'
    );
    if (interactiveElement) {
      return;
    }
    this.setState({ selectedSettingTitleIndex:index });
  };

  onEdit = (targetKey, action) => {
    if (action === 'add') {
      this.add();
    } else {
      return (
        <Popconfirm
          title={targetKey+"を削除しますか？"}
          onConfirm={() => this.remove(targetKey)}
          okText="はい"
          cancelText="いいえ"
        >
          <Button type="link">削除</Button>
        </Popconfirm>
      );
    }
  };

  add = () => {
    this.setState({
      addVisible: true,
      tabInput: '',
      openValSettingHelpKey: 'addPortfolio',
    });
  };

//20251230 UEDA タブの名前を変えただけで時間のかかる最適化計算をしない。
  tabEditApply = async (targetKey) => {
  const { tabEdit, userId, data, activeTab } = this.state;

  try {
    this.setState({ loading: true, tipMessage: '' });

    if (tabEdit.selectValue === 'delete') {
      await reqDelPortfolio(userId, targetKey);

      // 画面のタブ一覧だけ更新（円グラフ更新なし、GetPortfolioなし）
      const newData = (data || []).filter(v => v.Portfolio !== targetKey);

      // 削除したタブが選択中なら、次のタブに切り替える（表示だけ）
      const newActiveTab =
        activeTab === targetKey ? (newData[0]?.Portfolio ?? '') : activeTab;

      this.setState({
        data: newData,
        activeTab: newActiveTab,
        tableColumnsDisPlay: this.buildTableColumnsDisplay(this.state.dataTitle, newActiveTab, newData),
      });

    } else {
      const newName = (tabEdit.inputValue || '').trim();
      if (!newName) return;

      await reqUpdatePortfolioName(userId, targetKey, newName);

      // タブ名だけ差し替え（円グラフ更新なし、GetPortfolioなし）
      const newData = (data || []).map(p =>
        p.Portfolio === targetKey ? { ...p, Portfolio: newName } : p
      );
      const newActiveTab = activeTab === targetKey ? newName : activeTab;

      this.setState({
        data: newData,
        activeTab: newActiveTab,
        tableColumnsDisPlay: this.buildTableColumnsDisplay(this.state.dataTitle, newActiveTab, newData),
      });
    }
  } finally {
    this.setState({ loading: false, tipMessage: '' });
  }
};


  remove = targetTab => {
    const { data, activeTab } = this.state;
    let newActiveTab = activeTab;
    const newData = data.filter(v => v.Portfolio !== targetTab);
    if (newData.length>0) {
      newActiveTab= newData[0].Portfolio
    }
    
    setTimeout(() => {
        this.setState({
        data: newData,
        activeTab: newActiveTab,
        tableColumnsDisPlay: this.buildTableColumnsDisplay(this.state.dataTitle, newActiveTab, newData),
      });
      
    }, 500);
    
  };

  tabEditSelectChange =(e) => { 
    this.setState((prevState) => ({
      tabEdit: {
        ...prevState.tabEdit,
        selectValue: e.target.value,
        inputDisabled:e.target.value==='delete'?true:false,
      },
    }));
  };

  tabEditInputChange =(e) => { 
    this.setState((prevState) => ({
      tabEdit: {
        ...prevState.tabEdit,
        inputValue: e.target.value,
      },
    }));
    
  };
  
  tabEditClick =(title) => { 

    this.setState((prevState) => ({
      tabEdit: {
        ...prevState.tabEdit,
        selectValue: 'update',
        inputDisabled:false,
        inputValue: title,
      },
    }));
    
  };
  handleClickSetting = (event) => {   
    const dataTitle = this.getDataTitlesByView(this.state.currentPieView);
    const tmpTitle = cloneTitleSettings(dataTitle);
    const settingInitialTitle = cloneTitleSettings(dataTitle);
    this.setState({
      settingVisible:true,
      tmpTitle,
      settingInitialTitle,
      applyTitleButton:this.getColumnPreferenceActionLabel(tmpTitle, settingInitialTitle),
      errorMsg:'',
      selectedSettingTitleIndex:null,
      settingDragIndex:null,
      settingDropIndex:null,
      settingDragOffsetY:0,
      settingDragStartY:null,
    });
  };
  handleClickPortfoliaDownload= async() => {
      this.setState({
        loading: true,
        tipMessage:'ダウンロード中'
       });
      try {
        const { data} = this.state;
        
        const result = await reqGetPortfolioFile(data)
        if (result.status===0) {
          const response = await fetch(PRICEDOWNLOAD + result.data);;
          if (!response.ok) {
            this.setState({
              loading: false
             });
             message.error('Download failed')
             return
          }
          const fileBlob = await response.blob();
    
          const url = window.URL.createObjectURL(fileBlob);
          const a = document.createElement('a');
          a.href = url;
          a.download = '保有銘柄一覧表.xlsx';
            document.body.appendChild(a);
          a.click();
    
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }


      } catch (error) {
        message.error('Download failed:', error.message);
      }
      this.setState({
        loading: false
       });
    };
  PieSetting = (selectTab) =>{   
    const { data, currentPieView } = this.state; 
    
    let currentData = data.filter(v => v.Portfolio === selectTab);
    if (currentData.length>0) {
      const portfolioChildren = Array.isArray(currentData[0]?.children) ? currentData[0].children : [];
      const requestedCurrentPieData = currentPieView === CURRENT_PIE_VIEW_SECTOR
        ? this.buildJapanStockSectorPieEntries(portfolioChildren, selectTab)
        : this.buildCurrentAssetPieEntries(portfolioChildren, selectTab);
      const resolvedCurrentPieView = currentPieView === CURRENT_PIE_VIEW_SECTOR && requestedCurrentPieData.length === 0
        ? CURRENT_PIE_VIEW_ASSET
        : currentPieView;
      const currentPieEntries = resolvedCurrentPieView === currentPieView
        ? requestedCurrentPieData
        : this.buildCurrentAssetPieEntries(portfolioChildren, selectTab);
      let PieColor = currentPieEntries.map((item) => item.color);
      const tmpSortPieData = portfolioChildren
        .filter(v => v.OptimalPercent!==0 && v?.BenchmarkBond)
        .slice()
        .sort((a, b) => b.OptimalPercent - a.OptimalPercent)
      let OptimalPieColor = tmpSortPieData.map((item, index) => this.getSafePieColor(item?.BenchmarkBond?.Color, index, {
        portfolio: selectTab,
        type: 'optimal',
        asset: item?.BenchmarkBond?.Asset,
        name: item?.BenchmarkBond?.Name,
        code: item?.Code,
        benchmarkCode: item?.BenchmarkBond?.Code,
      }));
      let tmpOptimalPieData = tmpSortPieData.map((item,index) => ({
        type: `${item?.BenchmarkBond?.Asset || ''} -${index}`,
        code: item?.BenchmarkBond?.Code,
        inceptionDate:item?.BenchmarkBond?.InceptionDate,
        fullName:item?.BenchmarkBond?.Name,
        color:OptimalPieColor[index],
        value: item.OptimalPercent,
      }));
 
      this.setState(prevState => ({
        currentPieView: resolvedCurrentPieView,
        dataTitle: this.getDataTitlesByView(resolvedCurrentPieView),
        currentPieData: {
          ...prevState.currentPieData,
          data: currentPieEntries,
          color:PieColor,
          theme: 'custom-theme'
        },
        optimalPieData: {
          ...prevState.optimalPieData,
          data: tmpOptimalPieData,
          color:OptimalPieColor,
          theme: 'custom-theme'
          },
      }));
    }
    
     
  }

  flattenPortfolioNodes = (items = []) => {
    const rows = [];
    const walk = (nodes, depth = 0, portfolio = '') => {
      (nodes || []).forEach((node) => {
        rows.push({ ...node, __depth: depth, __portfolio: portfolio || node?.Portfolio || '' });
        if (Array.isArray(node?.children)) {
          walk(node.children, depth + 1, portfolio || node?.Portfolio || '');
        }
      });
    };
    walk(items);
    return rows;
  }

  buildPortfolioDebugSummary = (portfolios = []) => {
    const rows = portfolios.flatMap((portfolio) => this.flattenPortfolioNodes(portfolio?.children || [])
      .map((row) => ({ ...row, __portfolio: portfolio?.Portfolio || row.__portfolio || '' })));
    const securityRows = rows.filter((row) => row.Folder === 3 || row.Folder === 9);
    const assetRows = rows.filter((row) => row.Folder === 2);
    const missingValue = (value) => value === null || value === undefined || String(value).trim() === '';

    return {
      portfolioCount: portfolios.length,
      portfolioNames: portfolios.map((item) => item?.Portfolio).filter(Boolean),
      rowCount: rows.length,
      securityRowCount: securityRows.length,
      assetRowsWithoutBenchmark: assetRows
        .filter((row) => missingValue(row.Benchmark))
        .slice(0, 20)
        .map((row) => ({
          portfolio: row.__portfolio,
          asset: row.Asset,
          name: row.Name,
          code: row.Code,
          benchmark: row.Benchmark,
        })),
      securityRowsWithMissingStaticFields: securityRows
        .filter((row) => ['Code', 'Name', 'Asset1', 'Ccy', 'CurrentPriceDate', 'CurrentPrice'].some((field) => missingValue(row[field])))
        .slice(0, 20)
        .map((row) => ({
          portfolio: row.__portfolio,
          asset: row.Asset,
          name: row.Name,
          code: row.Code,
          assetClass: row.Asset1,
          ccy: row.Ccy,
          currentPriceDate: row.CurrentPriceDate,
          currentPrice: row.CurrentPrice,
        })),
    };
  }

  updatePortfolioDebugInfo = (patch) => {
    if (!this.state.debugEnabled) {
      return;
    }
    const nextDebugInfo = {
      ...(this.state.debugInfo || {}),
      ...patch,
      updatedAt: new Date().toISOString(),
    };
    this.setState({ debugInfo: nextDebugInfo });
    console.info('[PORT DEBUG]', nextDebugInfo);
  }

  renderDebugPanel = () => {
    const { debugEnabled, debugInfo, pageError } = this.state;
    if (!debugEnabled) {
      return null;
    }
    const panelData = {
      apiBase: BASE,
      pageError,
      ...(debugInfo || {}),
    };
    return (
      <div className="port-debug-panel">
        <div className="port-debug-title">PORT DEBUG</div>
        <pre>{JSON.stringify(panelData, null, 2)}</pre>
      </div>
    );
  }
  
  GetPortfolio = async (selectTab) => {
    this.setState({
     loading: true,
     tipMessage:'',
     pageError:''
    });
    this.updatePortfolioDebugInfo({
      phase: 'request',
      apiBase: BASE,
      request: {
        uid: this.state.userId,
        isJPYMode: this.state.isJPYMode,
        portfolio: selectTab,
      },
      response: null,
      transformedSummary: null,
    });
    try {
      const result = await reqGetPortfolios(this.state.userId,this.state.isJPYMode,selectTab)
      this.updatePortfolioDebugInfo({
        phase: 'response',
        response: {
          status: result?.status,
          dataType: Array.isArray(result?.data) ? 'array' : typeof result?.data,
          dataLength: Array.isArray(result?.data) ? result.data.length : undefined,
          errorMessage: result?.status === 0 ? '' : extractApiErrorMessage(result, 'ポートフォリオを取得できませんでした。'),
          raw: result?.status === 0 ? undefined : result,
        },
      });
      if (result.status===0) {
        let newData = Array.isArray(result.data) ? result.data : [];


        newData = newData.map(p => ({
          ...p,
          children: this.applyTaxCategoryDisplay(this.transformPortfolioHierarchy(p.children)),
        }));
        this.updatePortfolioDebugInfo({
          phase: 'transformed',
          transformedSummary: this.buildPortfolioDebugSummary(newData),
        });

        let currentTab = selectTab;
        if  (newData.length >0){
          const current = newData.filter(v => v.Portfolio === currentTab);
          if (current.length>0) {
            currentTab= current[0].Portfolio
          }else{
            currentTab= newData[0].Portfolio
          }

        }else{
          currentTab= ''
        }

        this.setState((prevState) => {
          if (!currentTab || !prevState.worldStockBreakdownCache?.[currentTab]) {
            return null;
          }

          const nextWorldStockBreakdownCache = {
            ...prevState.worldStockBreakdownCache,
          };
          delete nextWorldStockBreakdownCache[currentTab];

          return {
            worldStockBreakdownCache: nextWorldStockBreakdownCache,
          };
        });

        const newData1 = [...this.state.data]
        newData.forEach(item2 => {
          const index = newData1.findIndex(item => item.Portfolio === item2.Portfolio)

          if (index !== -1) {
            newData1[index] = item2
          } else {
            newData1.push(item2)
          }
        })

        const tableColumnsDisPlay = this.buildTableColumnsDisplay(this.state.dataTitle, currentTab, newData1);
        const expandedKeys = Array.from(
          this.collectExpandedKeysForClassification(newData1.flatMap((item) => item?.children || []))
        );
        const restoredSectorOptimalCache = this.buildSavedSectorOptimalCache(newData1, this.state.sectorOptimalCache);
        const currentRestoredSectorOptimal = currentTab
          ? restoredSectorOptimalCache?.[currentTab]
          : null;
        this.setState({
          data:newData1,
          activeTab:currentTab,
          tableColumnsDisPlay,
          expandedKeys,
          sectorOptimalCache: {
            ...this.state.sectorOptimalCache,
            ...restoredSectorOptimalCache,
          },
          sectorOptimalPieData: currentRestoredSectorOptimal?.pieData || this.state.sectorOptimalPieData,
          sectorOptimalMessage: currentRestoredSectorOptimal?.message || '',
        }, async () => {
          const currentPortfolio = newData1.find(
            (item) => item?.Portfolio === currentTab
          );
          const portfolioChildren = Array.isArray(currentPortfolio?.children)
            ? currentPortfolio.children
            : [];
          const optimalPercentTotal = portfolioChildren.reduce(
            (total, item) => total + (Number(item?.OptimalPercent) || 0),
            0
          );

          if (currentTab && optimalPercentTotal <= 0) {
            await this.handleCalcOptimal();
            return;
          }

          this.PieSetting(currentTab);
          if (this.state.currentPieView === CURRENT_PIE_VIEW_SECTOR && currentTab) {
            if (!currentRestoredSectorOptimal) {
              await this.loadSectorOptimalPieData(currentTab, {
                autoSaveIfMissing: true,
              });
            }
          }
        })
        
      } else {
        this.setState({
          data: [],
          activeTab: '',
          pageError: extractApiErrorMessage(result, 'ポートフォリオを取得できませんでした。')
        });

      }
    } catch (error) {
      console.error('[PORT] GetPortfolio failed', error);
      this.updatePortfolioDebugInfo({
        phase: 'exception',
        exception: {
          name: error?.name,
          message: error?.message,
          stack: error?.stack,
        },
      });
      this.setState({
        data: [],
        activeTab: '',
        pageError: error?.message || 'ポートフォリオ取得中にエラーが発生しました。'
      });
    } finally {
      this.setState({
        loading: false,
        tipMessage:''
      });
    }
  }


    
  onRowSelect = (record, index)=>{
    return {
        onClick:(e)=>{
            //e.currentTarget.getElementsByClassName("ant-radio-wrapper")[0].click()
        }
    }
};

onCloseCustomer = () => {
  const { tmpTitle } = this.state;
  const baseTitles = this.getColumnPreferenceBaseTitles();
  const hasChanges = this.hasColumnPreferenceChanges(tmpTitle, baseTitles);
  if (hasChanges) {
    this.applyColumnPreferences(tmpTitle);
    message.success('保存しました');
  }
  this.setState({
    settingVisible:false,
    settingInitialTitle:[],
    applyTitleButton:'',
    errorMsg:''
  });
};

onChangeCustomSetting = (dataIndex) => {
  const { tmpTitle } = this.state;
  let message = '';
  const current = tmpTitle.find(v => v.dataIndex === dataIndex);
  const others = tmpTitle.filter(v => v.dataIndex !== dataIndex && v.visible).length;
  if  (others>=99 && !current.visible){
    message='最大三つまで選択可能'
  }else if  (others===0 && current.visible){
    message='一つ以上選択必須'
  }else{
    const updatedDataTitle = tmpTitle.map((item) => {
      if (item.dataIndex === dataIndex) {
        return { ...item, visible: !item.visible };
      } else {
        return item;
      }
    });
    
    this.setState({
      tmpTitle:updatedDataTitle,
      currentTitle: 0,
      currentStatus: 'First',
      applyTitleButton:this.getColumnPreferenceActionLabel(updatedDataTitle, this.getColumnPreferenceBaseTitles())
    })
    
  }
  this.setState({
    errorMsg:message,
  })
  

};

getViewportWidth = () => {
  if (typeof window === 'undefined') {
    return 1280;
  }
  return window.innerWidth || 1280;
};

isTabletViewport = () => {
  const viewportWidth = this.getViewportWidth();
  return !this.state.isNarrowViewport && viewportWidth <= DISPLAY_SETTING_TABLET_MAX_WIDTH;
};

getDisplaySettingDrawerWidth = () => {
  if (this.state.isNarrowViewport) {
    return '100vw';
  }
  if (this.isTabletViewport()) {
    return '90vw';
  }
  return DISPLAY_SETTING_DESKTOP_WIDTH;
};

getDisplaySettingDrawerBodyStyle = () => ({
  padding: this.state.isNarrowViewport ? '12px 12px 20px' : '16px 18px 20px',
  overflowY: 'auto',
  overflowX: 'hidden',
  height: this.state.isNarrowViewport ? 'calc(100vh - 92px)' : 'calc(100vh - 108px)',
});

getDisplaySettingDrawerStyle = () => ({
  borderRadius: this.state.isNarrowViewport ? 0 : '18px 0 0 18px',
  height: '100vh',
  overflow: 'hidden',
});

getConstraintDrawerWidth = () => (
  this.state.isNarrowViewport ? '100vw' : 360
);

getConstraintDrawerBodyStyle = () => ({
  padding: this.state.isNarrowViewport ? '12px 12px 20px' : '16px 18px 20px',
  overflowY: 'auto',
  overflowX: 'hidden',
  height: this.state.isNarrowViewport ? 'calc(100vh - 92px)' : 'calc(100vh - 108px)',
});

getConstraintDrawerStyle = () => ({
  borderRadius: this.state.isNarrowViewport ? 0 : '18px 0 0 18px',
  height: '100vh',
  overflow: 'hidden',
});

getDisplaySettingHeaderTitle = () => (
  <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:'12px',minHeight:'48px'}}>
    <div style={{flex:1,minWidth:0}}>
      <div style={{fontSize:'18px',fontWeight:'bold',textAlign:'left'}}>表示項目</div>
      <div style={{marginTop:'10px',fontSize:'13px',color:'#7f8c8d'}}>表示する項目を選択し、ドラッグまたは上下ボタンで並び替えてください</div>
      <div style={{ color:'red', textAlign:'left', marginTop:this.state.errorMsg ? '6px' : 0}}>{this.state.errorMsg}</div>
    </div>
    <div style={{flexShrink:0}}>
      <ClickButton style={{width:'100px',minHeight:'40px'}} onClick={this.onCloseCustomer}>{this.state.applyTitleButton}</ClickButton>
    </div>
  </div>
);

formatValue = (value, name)  => {
  if (name ==='numFormat') {
    return numFormat(value);    
  }else if (name ==='rateFormat') {
    return rateFormat(value);    
  }else if (name ==='percentFormat') {
    return percentFormat(value);
  } else {
    return value;
  }
}

cacheAssetETFData = (items) => {
  if (!Array.isArray(items) || items.length === 0) {
    return;
  }
  this.setState((prevState) => {
    const nextAssetETFDataMap = new Map(
      (prevState.assetETFData || [])
        .filter((item) => item?.Code)
        .map((item) => [item.Code, item])
    );
    items.forEach((item) => {
      if (item?.Code) {
        nextAssetETFDataMap.set(item.Code, item);
      }
    });
    return {
      assetETFData: Array.from(nextAssetETFDataMap.values()),
    };
  });
}

searchAssetETFData = async (rawKeyword, page = 1, pageSize = this.state.assetSearchPageSize) => {
  const { locale } = this.state;
  const keyword = String(rawKeyword ?? '').trim();
  const requestId = ++this.assetSearchRequestId;
  this.assetSearchKeyword = keyword;
  const isCurrent = () => !this.isUnmounted && requestId === this.assetSearchRequestId;

  if (keyword === '') {
    this.setState({
      assetETFDataStatus: 'idle', assetETFDataError: '', searchResult: [],
      assetSearchTotal: 0, assetSearchPage: 1, assetSearchPerformed: false,
    });
    return false;
  }
  if (!isCurrent()) return false;
  this.setState({
    assetETFDataStatus: 'loading', assetETFDataError: '', searchResult: [],
    assetSearchPage: page, assetSearchPageSize: pageSize, assetSearchPerformed: false,
  });

  let lastResult = null;
  for (let attempt = 1; attempt <= this.assetETFDataMaxAttempts; attempt += 1) {
    if (!isCurrent()) return false;
    try {
      lastResult = await reqSearchETFPage(locale, 'port', keyword, page, pageSize, this.state.assetSearchSortOrder, this.state.assetSearchSortField);
    } catch (error) {
      lastResult = { status: -1 };
    }
    if (!isCurrent()) return false;
    const data = lastResult?.data;
    if (lastResult?.status === 0 && Array.isArray(data?.items)
        && Number.isInteger(data.total) && data.total >= 0) {
      this.cacheAssetETFData(data.items);
      this.setState({
        assetETFDataStatus: 'success', assetETFDataError: '',
        searchResult: data.items, assetSearchTotal: data.total,
        assetSearchPerformed: true,
      });
      return true;
    }
    if (attempt < this.assetETFDataMaxAttempts) {
      await wait(this.assetETFDataRetryDelayMs * attempt);
    }
  }
  if (!isCurrent()) return false;
  console.error('[PORT] SearchETFData failed', lastResult);
  message.error('銘柄検索に失敗しました');
  this.setState({
    assetETFDataStatus: 'error', assetETFDataError: '銘柄検索に失敗しました',
    searchResult: [], assetSearchTotal: 0, assetSearchPerformed: true,
  });
  return false;
}

findCachedAssetETFDataByCode = (code) => {
  const normalizedCode = String(code || '').trim();
  if (normalizedCode === '') {
    return null;
  }
  return (this.state.assetETFData || []).find((item) => item?.Code === normalizedCode) || null;
}

fetchAssetETFDataByCode = async (code) => {
  const normalizedCode = String(code || '').trim();
  if (normalizedCode === '') {
    return null;
  }

  const cachedItem = this.findCachedAssetETFDataByCode(normalizedCode);
  if (cachedItem) {
    return cachedItem;
  }

  const { locale } = this.state;
  const result = await reqSearchETFData(locale, 'port', normalizedCode, 20);
  if (result?.status !== 0) {
    console.error('[PORT] fetchAssetETFDataByCode failed', result);
    return null;
  }

  const nextData = Array.isArray(result?.data) ? result.data : [];
  this.cacheAssetETFData(nextData);
  return (
    nextData.find((item) => item?.Code === normalizedCode)
    || nextData.find((item) => removeTFromCode(item?.Code || '') === removeTFromCode(normalizedCode))
    || nextData[0]
    || null
  );
}


  componentDidMount () {
    this.viewportMediaQueryList = this.createViewportMediaQueryList();
    this.syncViewportMode();
    if (this.viewportMediaQueryList) {
      if (this.viewportMediaQueryList.addEventListener) {
        this.viewportMediaQueryList.addEventListener('change', this.handleViewportChange);
      } else if (this.viewportMediaQueryList.addListener) {
        this.viewportMediaQueryList.addListener(this.handleViewportChange);
      }
    } else if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleViewportChange);
    }

    const assetDataTitle = this.restoreTitleSettingsForView(CURRENT_PIE_VIEW_ASSET);
    const sectorDataTitle = this.restoreTitleSettingsForView(CURRENT_PIE_VIEW_SECTOR);
    const dataTitlesByView = {
      [CURRENT_PIE_VIEW_ASSET]: assetDataTitle,
      [CURRENT_PIE_VIEW_SECTOR]: sectorDataTitle,
    };
    const dataTitle = this.getDataTitlesByView(CURRENT_PIE_VIEW_ASSET, dataTitlesByView);
    const tableColumns = this.applySortInfoToTableColumns(this.state.tableColumns, this.getStoredSortInfo(CURRENT_PIE_VIEW_ASSET));
    this.setState({
      dataTitlesByView,
      dataTitle,
      tableColumns,
      tableColumnsDisPlay: this.buildTableColumnsDisplay(dataTitle, this.state.activeTab, this.state.data, CURRENT_PIE_VIEW_ASSET)
    });
    let loginUser = getLoginFromLocalStorage()
    let userId = ''
    if  (Object.keys(loginUser).length !== 0){
      userId = loginUser.SecurityCode
    }else{
      userId = getDummyFromLocalStorage()
      if  (userId === ''){
        userId= uuidv4()
        saveDummyToLocalStorage(userId)
      }
    }

    this.setState({
      userId: userId
     }, async () => {
      await this.loadUserAccounts(userId);
      await this.GetPortfolio('');
      
      const sortInfo = this.getStoredSortInfo(this.state.currentPieView)
      if  (sortInfo !==null){
        const tableColumns = this.applySortInfoToTableColumns(this.state.tableColumns, sortInfo);
        this.setState({ tableColumns  });
    }
    });
    

    
    
  }

  componentDidUpdate(prevProps, prevState) {
    const { activeTab, data } = this.state;
    if (prevState.activeTab === activeTab && prevState.data === data) {
      return;
    }

    const activeRecord = data.find((item) => item.Portfolio === activeTab);
    if (activeRecord) {
      this.debugPortfolioSummary(activeRecord);
    }
  }

  componentWillUnmount() {
    this.isUnmounted = true;
    if (this.viewportMediaQueryList) {
      if (this.viewportMediaQueryList.removeEventListener) {
        this.viewportMediaQueryList.removeEventListener('change', this.handleViewportChange);
      } else if (this.viewportMediaQueryList.removeListener) {
        this.viewportMediaQueryList.removeListener(this.handleViewportChange);
      }
    } else if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleViewportChange);
    }
    window.removeEventListener('pointermove', this.handleReorderPointerMove);
    window.removeEventListener('pointerup', this.handleReorderPointerUp);
    window.removeEventListener('pointercancel', this.handleReorderPointerUp);
    window.removeEventListener('pointermove', this.handleSettingTitlePointerMove);
    window.removeEventListener('pointerup', this.handleSettingTitlePointerUp);
    window.removeEventListener('pointercancel', this.handleSettingTitlePointerUp);
  }
  generateTableData = () => {
    const { data} = this.state;
    let assetGroups = []
    data.forEach(item => {
      if (assetGroups.length === 0 || assetGroups.filter(v => v.asset===item.asset).length === 0) {
        assetGroups.push({
          asset: item.asset,
          value : item.marketValueJPY,
          price: '-',
          quantity: '-',
          children: [{
            asset: item.code,
            value : item.marketValueJPY,
            price: item.priceJPY,
            quantity: item.quantity,
            children: [{
              asset: item.purchaseDate,
              value : item.marketValueJPY,
              price: item.priceJPY,
              quantity: item.quantity,
              details:item
            }]
          }]
        })
      }else{
        let assetGroup = assetGroups.filter(v => v.asset===item.asset)[0];
        assetGroup.value = assetGroup.value + item.marketValueJPY
        let children = assetGroup.children.filter(v => v.asset===item.code)
        if  (children.length === 0 ){
          children.push({
            asset: item.code,
            value : item.marketValueJPY,
            price: item.priceJPY,
            quantity: item.quantity,
            children: [{
              asset: item.purchaseDate,
              value : item.marketValueJPY,
              price: item.priceJPY,
              quantity: item.quantity,
              details:item
            }]
          })
        }else{
          let total = children[0].children.reduce((s, i) => s + i.price, 0);
          children[0].value = children[0].value + item.marketValueJPY
          children[0].price = (total + item.priceJPY) / (children[0].children.length+1)
          children[0].quantity = children[0].quantity + item.quantity
          children[0].children.push({
            asset: item.purchaseDate,
            value : item.marketValueJPY,
            price: item.priceJPY,
            quantity: item.quantity,
            details:item
          })
        }

      }
      
    });
    this.setState({
      tableData: assetGroups,
    });

    
  }
  handleTabInputChange = (e) => {
    this.setState({
      tabInput: e.target.value,
    });
  };
  
  handleSecItemClick = (value) => {
    
  };
  onPieClick = (e) => {
    
  };

  handleModeChange = (value) => {
    this.setState({
      isJPYMode: value,
      currentTitle: 0,
      currentStatus: 'First'
    },()=>{this.GetPortfolio(this.state.activeTab)});
    
    
  };
  handleExpand = (expanded, record) => {
    const nextChildRowIds = expanded
      ? (record.children || []).map((child) =>
          this.getPortfolioRowVisualId(child)
        )
      : [];

    this.setState((prevState) => ({
      expandedKeys: expanded
        ? Array.from(new Set([...prevState.expandedKeys, record.Key]))
        : prevState.expandedKeys.filter((key) => key !== record.Key),

      /*
       * expandedKeysには画面側の自動展開キーも含まれるため、
       * ユーザーが操作した行と操作内容を別に記録する。
       */
      lastManuallyExpandedRowKey: record.Key,
      lastOpenedChildRowIds: nextChildRowIds,
      lastPortfolioExpandAction: expanded ? 'expand' : 'collapse',
    }), () => {
    });
  };
  titleClick = (isNext) => {
    const { currentTitle,dataTitle } = this.state; 
    
    
    let count = dataTitle.filter(v => v.visible).length;
    let quotient = Math.floor(count / 2);
    if  (count % 2 > 0) {
      quotient = quotient +1;
    }
    let current =currentTitle;    
    let status  = '';
    if  (isNext){
      if  (currentTitle >= quotient-1 ){
        current=quotient-1;
      }else{
        current=current+ 1;
      }
      
      if  (current >= quotient-1 ){
        status  = 'Last';
      }
    }
    else{
      if  (currentTitle <= 1 ){
        current=0;
        status  = 'First';
      }else{
        current=current- 1;
      }
    }
    this.setState({
      currentTitle: current,
      currentStatus : status
    });
  };

  handleClickSelectDelete= (item) => {      
    const { data} = this.state;
    const updatedData = data.filter(v => v.code!==item.code);
    this.setState({ data: updatedData });
  };
  handleTabOkClick = async() => {
    const { data,tabInput } = this.state;
    if  (tabInput === null || tabInput.trim() === ''){
      return;
    }
    let uniqueTabName=tabInput;
    let count = 0; 
    while (true) {
      const currentName = uniqueTabName;
      const isDuplicate = data.some(v => v.Portfolio === currentName);
      if (!isDuplicate) break;

      count += 1;
      uniqueTabName = `${tabInput}(${count})`;
    }
    let activeTab = uniqueTabName;
    await reqAddPortfolioName(this.state.userId,activeTab)
    this.setState({
       activeTab,
       addVisible: false,
       openValSettingHelpKey: '',
    },()=>{this.GetPortfolio(activeTab)});
  };

  handleTabCancelClick = () => {
    this.setState({
      tabInput: '',
      addVisible: false,
      openValSettingHelpKey: '',
    });
  };

  // onReadyLocCol = (plot) => {
  //   plot.on('element:click', (...args) => {
  //     const data = args[0].data?.data;
  //   });
  // };
  onPageChange= (page, pageSize) => {
    this.setState({
      currentPage: page
    });
  };

  handleAssetSearchSort = (field = 'asset') => {
    const sameField = this.state.assetSearchSortField === field;
    const nextOrder = !sameField ? 'asc'
      : this.state.assetSearchSortOrder === '' ? 'asc'
      : this.state.assetSearchSortOrder === 'asc' ? 'desc' : '';

    this.setState({
      assetSearchSortField: field,
      assetSearchSortOrder: nextOrder,
      assetSearchPage: 1,
    }, () => {
      if (this.assetSearchKeyword) {
        this.searchAssetETFData(
          this.assetSearchKeyword, 1, this.state.assetSearchPageSize
        );
      }
    });
  };

  handleAssetSearchPageChange = (page, pageSize) => {
    const nextSize = ASSET_SEARCH_PAGE_SIZES.includes(pageSize)
      ? pageSize : DEFAULT_ASSET_SEARCH_PAGE_SIZE;
    const nextPage = nextSize === this.state.assetSearchPageSize ? page : 1;
    this.setState({ assetSearchPage: nextPage, assetSearchPageSize: nextSize });
    try {
      localStorage.setItem(ASSET_SEARCH_PAGE_SIZE_KEY, String(nextSize));
    } catch {
      // Keep pagination usable when browser storage is unavailable.
    }
    if (this.assetSearchKeyword) {
      return this.searchAssetETFData(this.assetSearchKeyword, nextPage, nextSize);
    }
  };

  handleSettingDragStart = (e, dropIndex) => {
    e.dataTransfer.setData('dropIndex', dropIndex);
  };

  handleSettingDragOver = (e) => {
    e.preventDefault();
  };

  handleSettingDrop = (e, targetIndex) => {
    //e.preventDefault();
    const dropIndex = e.dataTransfer.getData('dropIndex');    
    if  (dropIndex===targetIndex ) return;

    const { tmpTitle } = this.state;
    const newData = [...tmpTitle];   
    const fromItem = newData[dropIndex];;
    const toItem = newData[targetIndex]; 
    newData[dropIndex] = toItem;
    newData[targetIndex] = fromItem; 
    this.setState({ tmpTitle: newData, applyTitleButton:this.getColumnPreferenceActionLabel(newData, this.getColumnPreferenceBaseTitles())});
  };


  handleAddAsset = async() => {
    ++this.assetSearchRequestId;
    this.assetSearchKeyword = "";
    this.setState({
      assetAddFlag:false,
      searchVisible:true,
      searchValue:'',
      searchResult: [],
      assetSearchTotal: 0,
      assetSearchPage: 1,
      assetSearchPerformed:false,
      assetETFDataStatus:'idle',
      assetETFDataError:'',
    });
  };

  openCashTransactionModal = () => {
    const cashInstrumentInfo = this.getCashTransactionInstrumentInfo();
    const defaultAccount = this.getDefaultUserAccount();
    this.setState({
      cashModalVisible: true,
      cashTransactionId: null,
      cashTransactionIsNew: true,
      cashTransactionType: 'DEPOSIT',
      cashTransactionAmount: '',
      cashTransactionAmountFocused: false,
      cashTransactionDate: DateTimeToString(new Date()),
      cashTransactionMemo: '',
      cashTransactionAccountId: defaultAccount?.id ?? null,
      cashTransactionAccount: defaultAccount?.displayName ?? null,
      cashTransactionInstrumentCode: cashInstrumentInfo.Code,
      cashTransactionInstrumentAsset: cashInstrumentInfo.Asset,
      cashTransactionInstrumentName: cashInstrumentInfo.Name,
    });
  };

  closeCashTransactionModal = () => {
    this.setState({
      cashModalVisible: false,
      cashTransactionId: null,
      cashTransactionIsNew: true,
      cashTransactionAmount: '',
      cashTransactionAmountFocused: false,
      cashTransactionMemo: '',
      cashTransactionAccountId: null,
      cashTransactionAccount: null,
      cashTransactionInstrumentCode: DEFAULT_CASH_INSTRUMENT_CODE,
      cashTransactionInstrumentAsset: DEFAULT_CASH_INSTRUMENT_ASSET,
      cashTransactionInstrumentName: DEFAULT_CASH_INSTRUMENT_NAME,
    });
  };

  normalizeCashTransactionAmount = (value) => {
    const halfWidth = String(value ?? '').replace(/[０-９]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0));
    return halfWidth.replace(/[^\d]/g, '');
  };

  handleCashTransactionAmountChange = (e) => {
    const nextAmount = this.normalizeCashTransactionAmount(e?.target?.value);
    this.setState({ cashTransactionAmount: nextAmount });
  };

  onCashTransactionAccountChange = (accountId) => {
    const account = this.state.userAccounts.find((item) => item.id === accountId);
    this.setState({
      cashTransactionAccountId: account?.id ?? null,
      cashTransactionAccount: account?.displayName ?? null,
    });
  };

  submitCashTransaction = async () => {
    const {
      userId,
      activeTab,
      cashTransactionId,
      cashTransactionIsNew,
      cashTransactionType,
      cashTransactionAmount,
      cashTransactionDate,
      cashTransactionMemo,
      cashTransactionAccountId,
      cashTransactionAccount,
    } = this.state;
    const amount = Number(cashTransactionAmount);
    if (!activeTab) {
      message.warning('ポートフォリオを選択してください');
      return;
    }
    if (!Number.isFinite(amount) || amount <= 0) {
      message.warning('金額を入力してください');
      return;
    }

    this.setState({ loading: true });
    const payload = {
      New: cashTransactionIsNew,
      id: cashTransactionId,
      UserId: userId,
      Portfolio: activeTab,
      TradeDate: cashTransactionDate,
      Quantity: 0,
      Price: 0,
      FXRate: 1,
      Ccy: 'JPY',
      Code: CASH_ACCOUNT_CODE,
      Memo: cashTransactionMemo,
      AccountId: cashTransactionAccountId,
      Account: cashTransactionAccount,
      PorS: cashTransactionType === 'DEPOSIT' ? 2 : 1,
      AutoSettleCcy: true,
      SettleCcy: 'JPY',
      AutoQuantity: false,
      AutoPrice: false,
      AutoFxRate: false,
      AutoNotional: false,
      AutoAmount: true,
      Amount: amount,
      Cashflow: amount,
      Notional: amount,
      SettingAmount: 0,
      TaxCategory: 1,
      AutoPlan: false,
      LastDateFlg: false,
      LastPlanDate: '',
      EventType: cashTransactionType,
    };
    const updateResult = await reqUpdateTransaction(payload);
    if (updateResult.status !== 0) {
      this.setState({ loading: false });
      message.error(updateResult?.data?.msg || '入出金の登録に失敗しました');
      return;
    }

    this.closeCashTransactionModal();
    await this.GetPortfolio(activeTab);
    this.setState({ loading: false });
    message.success(
      cashTransactionIsNew
        ? (cashTransactionType === 'DEPOSIT' ? '入金を登録しました' : '出金を登録しました')
        : '入出金を更新しました'
    );
  };

  buildLightweightRecalcRecord = (record, observValue) => ({
    ...record,
    ObservValue: observValue,
    children: (Array.isArray(record?.children) ? record.children : []).map(
      ({ children, ...asset }) => ({
        ...asset,
        children: [],
      })
    ),
  });

  mergeRecalcResult = (record, recalculated) => {
    const originals = Array.isArray(record?.children) ? record.children : [];
    const results = Array.isArray(recalculated?.children) ? recalculated.children : [];
    const merged = originals.map((item) => ({ ...item }));
    const used = new Set();
    const key = (value) => String(value ?? "").trim().toLowerCase();

    results.forEach((result) => {
      const en = key(result?.AssetEn);
      const name = key(result?.Asset);
      const index = originals.findIndex((item, i) =>
        !used.has(i) && (
          (en && key(item?.AssetEn) === en) ||
          (name && key(item?.Asset) === name &&
            (!en || !key(item?.AssetEn) || key(item?.AssetEn) === en))
        )
      );

      if (index < 0) {
        merged.push(result);
        return;
      }
      used.add(index);
      merged[index] = {
        ...originals[index],
        ...result,
        children: originals[index].children,
      };
    });

    return { ...record, ...recalculated, children: merged };
  };

  handleCalcOptimal =async () => {
    const {
      activeTab,
      data,
      newObservValue,
      currentPieView,
      dataTitle,
      currentSectorPayloadCache,
      sectorOptimalCache,
    } = this.state;
    this.setState({
     loading: true,
     tipMessage:'最適化中'
    });
    const record = data.find((item) => item.Portfolio===activeTab);
    if (!record) {
      this.setState({
        loading: false,
        tipMessage:''
      });
      return;
    }

    const requestRecord = this.buildLightweightRecalcRecord(
      record,
      newObservValue
    );
    let reqData = {}
    reqData['uid'] = this.state.userId
    reqData['data'] = requestRecord

    try {
      const result = await reqReCalcOptimalData(reqData)
      if (result.status===0) {
      const updated = data.map((item) =>
        item.Portfolio === activeTab
          ? this.mergeRecalcResult(item, result.data)
          : item
      );
      const updatedRecord = updated.find((item) => item.Portfolio === activeTab);

      if (currentPieView === CURRENT_PIE_VIEW_SECTOR) {
        const previousRepresentativeItems = Array.isArray(sectorOptimalCache?.[activeTab]?.representativeItems)
          ? sectorOptimalCache[activeTab].representativeItems
          : [];
        const [currentSectorResult, sectorOptimalResult] = await Promise.all([
          this.fetchCurrentSectorPieData(activeTab, updatedRecord),
          this.fetchSectorOptimalPieData(activeTab, {
            force: true,
            portfolioRecord: updatedRecord,
            previousRepresentativeItems,
          }),
        ]);

        const nextState = {
          data: updated,
          saveEnabled: true,
          tableColumnsDisPlay: this.buildTableColumnsDisplay(
            dataTitle,
            activeTab,
            updated
          ),
        };

        if (currentSectorResult?.kind === 'success' && sectorOptimalResult?.kind === 'success') {
          nextState.currentPieView = CURRENT_PIE_VIEW_SECTOR;
          nextState.currentSectorPayloadCache = {
            ...currentSectorPayloadCache,
            [activeTab]: currentSectorResult.payload,
          };
          nextState.currentPieData = currentSectorResult.pieData;
          nextState.sectorOptimalCache = {
            ...sectorOptimalCache,
            [activeTab]: sectorOptimalResult.cacheEntry,
          };
          nextState.sectorOptimalPieData = sectorOptimalResult.cacheEntry.pieData;
          nextState.sectorOptimalMessage = sectorOptimalResult.cacheEntry.message || '';
        } else if (sectorOptimalResult?.kind === 'non_success') {
          nextState.sectorOptimalCache = {
            ...sectorOptimalCache,
            [activeTab]: {
              ...sectorOptimalResult.cacheEntry,
              needsRefresh: false,
              fetchedAt: new Date().toISOString(),
              pieData: sectorOptimalCache?.[activeTab]?.pieData || this.state.optimalPieData,
            },
          };
          nextState.sectorOptimalMessage = sectorOptimalResult.message;
        }

        this.setState(nextState);
      } else {
        this.setState({
          data: updated,
          saveEnabled: true,
          tableColumnsDisPlay: this.buildTableColumnsDisplay(
            dataTitle,
            activeTab,
            updated
          ),
          sectorOptimalMessage: '',
        }, () => {
          this.PieSetting(activeTab);
        })
      }
    }
    } finally {
      this.setState({
        loading: false,
        tipMessage:''
      });
    }
  };

  

  handleCalcOptimalSave =async () => {
    const { activeTab,data,currentPieView,sectorOptimalCache } = this.state;
    this.setState({
     loading: true,
     tipMessage:''
    });
    const record = data.filter(v => v.Portfolio===activeTab)[0];
    let reqData = {}
    reqData['uid'] = this.state.userId
    reqData['data'] = record
    if (currentPieView === CURRENT_PIE_VIEW_SECTOR) {
      reqData['optimizationMode'] = 'JP_SECTOR'
      reqData['sectorOptimalItems'] = Array.isArray(sectorOptimalCache?.[activeTab]?.representativeItems)
        ? sectorOptimalCache[activeTab].representativeItems
        : []
    } else {
      reqData['optimizationMode'] = 'ASSET'
    }
    const result = await reqSaveOptimalData(reqData)
    if (result.status===0) {
      const updatedData = data.map(item =>
        item.Portfolio === activeTab? { ...item, reClacFlg: false }: item
      );
      this.setState({data:updatedData})
    }
    this.setState({
      loading: false,
      tipMessage:''
     });
  };


  onChangeConditionExpress = (assetKey) =>(value) => {
    const { ratioSettingList } = this.state;
    const updatedData = ratioSettingList.map(item => {
      if (this.getConstraintAssetKey(item) === assetKey){
        item.Express = normalizeConstraintOperator(value);
      }
      return item;
    });      
    this.setState({ ratioSettingList: updatedData,ratioSelectTitle:'適用' ,settingFlg:true });
};
handleTableChange = (pagination, filters, sorter) => {
  const { currentPieView } = this.state;
  const storageKeys = this.getColumnPreferenceStorageKeys(currentPieView);
  if (sorter.order) {
    const sortInfo = { field: sorter.field, order: sorter.order };
    const tableColumns = this.applySortInfoToTableColumns(this.state.tableColumns, sortInfo);
    this.setState({ tableColumns  });
    saveCommonStorage(storageKeys.sort, sortInfo)
  } else {
    const tableColumns = this.applySortInfoToTableColumns(this.state.tableColumns, null);
    this.setState({ tableColumns });
    saveCommonStorage(storageKeys.sort, null)
  }
};
onChangeConditionExpressValue = (assetKey) =>(value) =>{
    const { ratioSettingList  } = this.state;
    const updatedData = ratioSettingList.map(item => {
      if (this.getConstraintAssetKey(item) === assetKey){
        item.ExpressValue = value;
      }
      return item;
    });
    
    this.setState({ ratioSettingList: updatedData,ratioSelectTitle:'適用',settingFlg:true  });
  
};


  onChangeObservValue = (e) => {

    this.setState({ 
      newObservValue: e.target.value,
      ratioSelectTitle:'適用' ,
      settingFlg:true
     });
  };


  buildAssetConstraintSettings = (items) => {
    const benchmarkChildren = (items?.children || []).filter((item) => item?.BenchmarkBond?.Code || this.isFixedRatioConstraintAsset(item));
    return [
      ...new Map(
        benchmarkChildren
          .map((item) => {
            const constraintItem = this.isFixedRatioConstraintAsset(item)
              ? this.createFixedRatioConstraintItem(item)
              : item?.BenchmarkBond;
            return [
              this.getConstraintAssetKey(constraintItem),
              {
                ...constraintItem,
                Express: normalizeConstraintOperator(constraintItem?.Express) || '=',
              },
            ];
          })
          .filter(([assetKey]) => !!assetKey)
      ).values()
    ];
  };

  buildConstraintLinkRow = (item, instrumentData = null) => {
    const code = String(
      item?.representative_instrument_id
        || item?.Code
        || instrumentData?.Code
        || ''
    ).trim();
    const url = makeURL1({
      Code: code,
      URL: item?.URL || item?.Url || item?.url || item?.instrumentUrl || instrumentData?.URL || '',
      ISIN: item?.ISIN || instrumentData?.ISIN || '',
      Provider: item?.Provider || instrumentData?.Provider || '',
    });

    return {
      ...item,
      representative_instrument_id: item?.representative_instrument_id || code,
      Code: code,
      URL: url,
      Url: url,
      url,
      instrumentUrl: url,
      Provider: item?.Provider || instrumentData?.Provider || '',
      ISIN: item?.ISIN || instrumentData?.ISIN || '',
    };
  };

  fetchInstrumentTableAssetByCode = async (code) => {
    const normalizedCode = String(code || '').trim();
    if (normalizedCode === '') {
      return null;
    }

    const result = await getETFAssetName(normalizedCode);
    if (result?.status !== 0) {
      console.error('[PORT] fetchInstrumentTableAssetByCode failed', result);
      return null;
    }

    return result?.data || null;
  };

  enrichConstraintSettingsWithLinks = async (ratioSettingList = [], options = {}) => {
    const { forceInstrumentTableLookup = false } = options;
    const nextRatioSettingList = await Promise.all(
      ratioSettingList.map(async (item) => {
        if (this.isFixedRatioConstraintAsset(item)) {
          return this.buildConstraintLinkRow(item);
        }

        if (!forceInstrumentTableLookup && this.getInstrumentLinkUrl(item)) {
          return this.buildConstraintLinkRow(item);
        }

        const instrumentData = forceInstrumentTableLookup
          ? await this.fetchInstrumentTableAssetByCode(item?.Code)
          : await this.fetchAssetETFDataByCode(item?.Code);
        return this.buildConstraintLinkRow(item, instrumentData);
      })
    );

    return nextRatioSettingList;
  };

  resolveSectorConstraintValue = (code, constraintMaps = {}) => {
    const normalizedCode = String(code || '').trim();
    const rawWeightLb = constraintMaps?.weightLb?.[normalizedCode];
    const rawWeightUb = constraintMaps?.weightUb?.[normalizedCode];
    const weightLb = Number(rawWeightLb);
    const weightUb = Number(rawWeightUb);
    const hasLb = Number.isFinite(weightLb) && rawWeightLb !== '' && rawWeightLb !== null && rawWeightLb !== undefined;
    const hasUb = Number.isFinite(weightUb) && rawWeightUb !== '' && rawWeightUb !== null && rawWeightUb !== undefined;

    if (hasLb && hasUb && Math.abs(weightLb - weightUb) < 1e-9) {
      return { Express: '=', ExpressValue: weightLb * 100 };
    }
    if (hasLb) {
      return { Express: '>=', ExpressValue: weightLb * 100 };
    }
    if (hasUb) {
      return { Express: '<=', ExpressValue: weightUb * 100 };
    }
    return { Express: '<=', ExpressValue: 100 };
  };

  hasFixedRatioConstraintAssetRow = (portfolioRecord) => (
    Array.isArray(portfolioRecord?.children)
      && portfolioRecord.children.some((item) => this.isFixedRatioConstraintAsset(item))
  );

  buildSectorConstraintSettings = (portfolioRecord, sectorCacheEntry = {}) => {
    const representativeItems = Array.isArray(sectorCacheEntry?.representativeItems)
      ? this.filterSectorModeExcludedCashItems(sectorCacheEntry.representativeItems)
      : [];
    const constraintMaps = sectorCacheEntry?.constraintMaps || {};
    return representativeItems
      .filter((item) => String(item?.instrument_id || '').trim() !== '')
      .map((item) => {
        const representativeInstrumentId = item?.representative_instrument_id || item?.instrument_id || '';
        const { Express, ExpressValue } = this.resolveSectorConstraintValue(representativeInstrumentId, constraintMaps);
        return {
          Asset: this.getJapanStockSectorFromItem(item),
          AssetEn: item?.asset_en || 'JP Stocks',
          SectorCode: item?.sector_code ?? null,
          optimization_mode: 'JP_SECTOR',
          representative_instrument_id: representativeInstrumentId,
          Code: representativeInstrumentId,
          Color: item?.color_hex || '',
          Express,
          ExpressValue,
        };
      });
  };

  cloneConstraintSettings = (ratioSettingList = []) => (
    ratioSettingList.map((item) => ({ ...item }))
  );

  handleRatioSettingOn = async (items) => {
      const ratioSettingMode = this.state.currentPieView === CURRENT_PIE_VIEW_SECTOR
        ? CURRENT_PIE_VIEW_SECTOR
        : CURRENT_PIE_VIEW_ASSET;
      let ratioSettingList = [];

      if (ratioSettingMode === CURRENT_PIE_VIEW_SECTOR) {
        let sectorCacheEntry = this.state.sectorOptimalCache?.[items?.Portfolio];
        if (this.shouldForceReloadSectorOptimalCache(sectorCacheEntry)) {
          sectorCacheEntry = await this.loadSectorOptimalPieData(items?.Portfolio, {
            force: true,
          });
        }
        ratioSettingList = this.buildSectorConstraintSettings(items, sectorCacheEntry);
        ratioSettingList = await this.enrichConstraintSettingsWithLinks(ratioSettingList, { forceInstrumentTableLookup: true });
      } else {
        ratioSettingList = this.buildAssetConstraintSettings(items);
        ratioSettingList = await this.enrichConstraintSettingsWithLinks(ratioSettingList);
      }

      this.setState({settingVisible2:true,
                     settingFlg:false,
                     newObservValue:items?.ObservValue===2?2:1,
                     ratioSettingMode,
                     ratioSettingList,
                     ratioSettingOriginalList:this.cloneConstraintSettings(ratioSettingList),
                     fixedDepositSetting:(items?.RiskFreeRate || 0)*100,
                     ratioSelectTitle:'閉じる'})  
  };

  areConstraintValuesEqual = (left, right) => {
    if (left === right) {
      return true;
    }
    const leftNumber = Number(left);
    const rightNumber = Number(right);
    if (Number.isFinite(leftNumber) && Number.isFinite(rightNumber)) {
      return Math.abs(leftNumber - rightNumber) < 1e-9;
    }
    return String(left ?? '') === String(right ?? '');
  };

  normalizeRiskFreeRatePercent = (value) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return 0;
    }
    return numericValue <= 1 ? numericValue * 100 : numericValue;
  };

 
  handleRatioSettingClose = () => {
    this.setState({
      settingVisible2:false,
      settingFlg:false,
      ratioSelectTitle:'閉じる',
    });
  };

  getConstraintAssetKey = (item) => String(item?.Asset || '').trim();

  isFixedRatioConstraintAsset = (item) => this.getConstraintAssetKey(item) === FIXED_RATIO_CONSTRAINT_ASSET;

  normalizeSectorModeCashIdentifier = (value) => String(value ?? '').trim().toUpperCase();

  isSectorModeExcludedCashIdentifier = (value) => (
    SECTOR_MODE_EXCLUDED_CASH_IDENTIFIERS.has(this.normalizeSectorModeCashIdentifier(value))
  );

  isSectorModeExcludedCashItem = (item) => {
    if (!item || typeof item !== 'object') {
      return false;
    }

    const benchmarkBond = item?.BenchmarkBond;
    return [
      item?.Code,
      item?.Asset,
      item?.Name,
      item?.instrument_id,
      item?.instrument_name,
      benchmarkBond?.Code,
      benchmarkBond?.Asset,
      benchmarkBond?.Name,
    ].some((value) => this.isSectorModeExcludedCashIdentifier(value));
  };

  filterSectorModeExcludedCashItems = (items = []) => (
    (Array.isArray(items) ? items : []).filter((item) => !this.isSectorModeExcludedCashItem(item))
  );

  sanitizeSectorOptimizationRequestNode = (node) => {
    if (!node || typeof node !== 'object') {
      return node;
    }
    if (this.isSectorModeExcludedCashItem(node)) {
      return null;
    }

    const nextNode = { ...node };
    if (this.isSectorModeExcludedCashItem(nextNode?.BenchmarkBond)) {
      delete nextNode.BenchmarkBond;
    }
    if (Array.isArray(nextNode.children)) {
      nextNode.children = nextNode.children
        .map((child) => this.sanitizeSectorOptimizationRequestNode(child))
        .filter(Boolean);
    }
    return nextNode;
  };

  buildSectorOptimizationRequestRecord = (record) => {
    const sanitizedRecord = this.sanitizeSectorOptimizationRequestNode(record);
    if (!sanitizedRecord || typeof sanitizedRecord !== 'object') {
      return record;
    }

    const compactHoldingNode = (node) => {
      if (!node || typeof node !== 'object') {
        return null;
      }

      const compact = {};
      [
        'Asset',
        'AssetEn',
        'Code',
        'Quantity',
      ].forEach((key) => {
        if (node[key] !== undefined) {
          compact[key] = node[key];
        }
      });

      if (Array.isArray(node.children)) {
        compact.children = node.children
          .map(compactHoldingNode)
          .filter(Boolean);
      }

      return compact;
    };

    const japanStockRows = (sanitizedRecord.children || []).filter(
      (row) => row?.Asset === '日本株' || row?.AssetEn === 'JP Stocks'
    );

    return {
      Portfolio: sanitizedRecord.Portfolio,
      RiskFreeRate: sanitizedRecord.RiskFreeRate,
      ObservValue: sanitizedRecord.ObservValue,
      children: japanStockRows.map(compactHoldingNode),
    };
  };

  createFixedRatioConstraintItem = (item) => ({
    ...item?.BenchmarkBond,
    Asset: this.getConstraintAssetKey(item) || FIXED_RATIO_CONSTRAINT_ASSET,
    Code: item?.BenchmarkBond?.Code || DEFAULT_CASH_INSTRUMENT_CODE,
    Color: item?.Color || '#C0C0C0',
    Express: '=',
    ExpressValue: item?.BenchmarkBond?.ExpressValue ?? 5,
    IsFixedConstraint: false,
  });

  getConstraintBenchmarkDisplay = (item) => {
    if (this.isFixedRatioConstraintAsset(item) || item?.IsFixedConstraint) {
      return FIXED_RATIO_CONSTRAINT_BENCHMARK_LABEL;
    }
    return removeTFromCode(item?.Code || '');
  };

  formatConstraintRateValue = (value) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return '';
    }
    return numericValue.toFixed(2).replace(/\.?0+$/, '');
  };

  haveConstraintSettingsChanged = (nextList = [], currentList = []) => {
    if (nextList.length !== currentList.length) {
      return true;
    }

    const currentMap = new Map(
      currentList.map((item) => [this.getConstraintAssetKey(item), item])
    );

    return nextList.some((item) => {
      const currentItem = currentMap.get(this.getConstraintAssetKey(item));
      if (!currentItem) {
        return true;
      }
      return (normalizeConstraintOperator(item?.Express) || '=')
        !== (normalizeConstraintOperator(currentItem?.Express) || '=')
        || !this.areConstraintValuesEqual(item?.ExpressValue, currentItem?.ExpressValue)
        || String(item?.representative_instrument_id || item?.Code || '') !== String(currentItem?.representative_instrument_id || currentItem?.Code || '')
        || String(item?.SectorCode ?? '') !== String(currentItem?.SectorCode ?? '');
    });
  };

  handleRatioSettingApply = async() => {
    const { activeTab,ratioSettingList,ratioSettingOriginalList,data,fixedDepositSetting,newObservValue,ratioSettingMode } = this.state;
    const record = data.filter(v => v.Portfolio===activeTab)[0];    
    let needCalc = this.haveConstraintSettingsChanged(ratioSettingList, ratioSettingOriginalList);
    if  (!this.areConstraintValuesEqual(
      this.normalizeRiskFreeRatePercent(fixedDepositSetting),
      this.normalizeRiskFreeRatePercent(record?.RiskFreeRate)
    )){
      needCalc = true;
    }
    if  (newObservValue !== record.ObservValue){
      needCalc = true;
    }

    if (!needCalc) {
      this.handleRatioSettingClose();
      return;
    }

    const editableRatioSettingList = ratioSettingList
      .filter((item) => !item?.IsFixedConstraint)
      .filter((item) => ratioSettingMode !== CURRENT_PIE_VIEW_SECTOR || !this.isSectorModeExcludedCashItem(item));
    const updateResult = await reqUpdateModelParam(this.state.userId,activeTab,editableRatioSettingList,newObservValue);
    if (updateResult?.status !== 0) {
      message.error('制約条件の保存に失敗しました');
      return;
    }

    await new Promise((resolve) => {
      this.setState({
      settingVisible2:false,
      settingFlg:false,
      ratioSelectTitle:'閉じる',
      ratioSettingOriginalList:this.cloneConstraintSettings(ratioSettingList),
      data
      }, resolve);
    });

    if (ratioSettingMode === CURRENT_PIE_VIEW_SECTOR) {
      this.markSectorOptimalCacheStale(activeTab);
    }

    if (needCalc){
      await this.handleCalcOptimal();
    }
  };


  arraysEqual = (a, b) => {
    if (a.length !== b.length) return false;
    a.sort();
    b.sort();
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  };

  //20251227 UEDA アセットクラスレベルの税区分をドリルダウンした結果で『複数有』か、一つしかないときは、その一つを表示する。
  taxLabel = (v) => {
    // vは "1"〜"7" を想定（数値でも来たら吸収）
    const key = String(v ?? "");
    const map = {
      "1": "特定預り",
      "2": "NISA成長投資枠",
      "3": "NISAつみたて投資枠",
      "4": "旧NISA",
      "5": "iDeCo",
      "6": "企業型DC",
      "7": "一般預り",
    };
    return map[key] ?? null;
  };

  taxLabels = () => (
    Object.values({
      "1": "特定預り",
      "2": "NISA成長投資枠",
      "3": "NISAつみたて投資枠",
      "4": "旧NISA",
      "5": "iDeCo",
      "6": "企業型DC",
      "7": "一般預り",
    })
  );

  isTaxCategoryRow = (row) => {
    if (!row || !Array.isArray(row.children) || row.children.length === 0) return false;
    if (row?.HierarchyType === 'tax') return true;
    const label = this.normalizeHierarchyText(row?.HierarchyLabel ?? row?.Asset);
    return !!label && this.taxLabels().includes(label);
  };

  // node(行)から税区分の「表示文字列」を1つ取り出す（約定行を想定）
  getTaxDisplayFromNode = (node) => {
    // 既にバックエンドが TaxCategoryDisplay を持っているならそれを優先
    if (node?.TaxCategoryDisplay) return node.TaxCategoryDisplay;

    // 末端に TaxCategory が入っている想定（details配下の可能性も吸収）
    const raw = node?.TaxCategory ?? node?.details?.TaxCategory;
    return this.taxLabel(raw);
  };

  getTaxShortDisplayFromNode = (node) => (
    this.normalizeHierarchyText(node?.TaxCategoryShortDisplay ?? node?.details?.TaxCategoryShortDisplay)
    ?? this.normalizeHierarchyText(this.getTaxDisplayFromNode(node))
    ?? '-'
  );

  getHierarchyTaxCategory = (node) => (
    this.normalizeHierarchyText(node?.HierarchyTaxCategory)
    ?? this.normalizeHierarchyText(this.getTaxDisplayFromNode(node))
    ?? '-'
  );

  getTaxGroupingKey = (node) => {
    const taxCategoryCode = this.normalizeHierarchyText(node?.TaxCategory ?? node?.details?.TaxCategory);
    if (taxCategoryCode) {
      return `code:${taxCategoryCode}`;
    }
    return `display:${this.getHierarchyTaxCategory(node)}`;
  };

  getFifoGroupingKey = (trade) => {
    const code = trade?.HierarchyCode ?? trade?.Code ?? '-';
    const taxCategory = this.getTaxGroupingKey(trade);
    return `${code}::${taxCategory}`;
  };

  getEventTypeDisplayFromNode = (node) => {
    if (node?.EventTypeDisplay) return node.EventTypeDisplay;
    const raw = String(node?.EventType ?? node?.details?.EventType ?? 'TRADE').toUpperCase();
    if (raw === 'DIVIDEND') return '配当';
    if (raw === 'DEPOSIT') return '入金';
    if (raw === 'WITHDRAWAL') return '出金';
    return '約定';
  };

  // 配下の約定から税区分の集合を集める（再帰）
  collectTaxSet = (node, set) => {
    if (!node) return;

    // 末端(約定)判定：Folder===9 を使っているのでそれに合わせる
    if (node.Folder === 9) {
      const disp = this.getTaxDisplayFromNode(node);
      if (disp) set.add(disp);
      return;
    }

    if (Array.isArray(node.children)) {
      node.children.forEach((ch) => this.collectTaxSet(ch, set));
    }
  };

// assetクラス行など、表示する行に TaxCategoryDisplay を埋める
applyTaxCategoryDisplay = (rows) => {
  if (!Array.isArray(rows)) return rows;

  return rows.map((row) => {
    // 子も先に加工（全階層に効かせるため）
    const nextChildren = this.applyTaxCategoryDisplay(row.children);

    // ★変更点：資産クラス(Folder===2)に限定せず
    // 「子を持つ行（=集計行）」はすべて TaxCategoryDisplay を付与する
    const hasChildren = Array.isArray(nextChildren) && nextChildren.length > 0;
    const isLeafTrade = row?.Folder === 9;

    if (hasChildren && !isLeafTrade) {
      const s = new Set();
      nextChildren.forEach((ch) => this.collectTaxSet(ch, s));

      let display = "-";
      if (s.size === 1) display = Array.from(s)[0];
      else if (s.size >= 2) display = "複数有";

      return { ...row, children: nextChildren, TaxCategoryDisplay: display };
    }

    return { ...row, children: nextChildren };
  });
};

isTradeRow = (row) => row?.Folder === 9;

isEditableTradeDetailRow = (row) => {
  if (!this.isTradeRow(row)) {
    return false;
  }

  const eventType = String(
    row?.EventType ?? row?.details?.EventType ?? ''
  ).toUpperCase();
  const eventTypeDisplay = String(row?.EventTypeDisplay ?? '').trim();

  if (
    eventType === 'TRADE'
    || eventType === 'DIVIDEND'
    || eventType === 'RESERVED'
    || (eventType === '' && eventTypeDisplay === '約定')
    || (eventType === '' && eventTypeDisplay === '予約')
  ) {
    return true;
  }

  return Boolean(row?.CashAccount)
    && (eventType === 'DEPOSIT' || eventType === 'WITHDRAWAL');
};

isAssetClassRow = (row) => row?.Folder === 2;

hasExpandableChildren = (row) => Array.isArray(row?.children) && row.children.length > 0;

isExpandedRow = (row) => !!row?.Key && this.state.expandedKeys.includes(row.Key);

isSelectedRow = (row) => !!row?.Key && this.state.selectedRowKey === row.Key;

hasActiveTextSelection = () => {
  if (typeof window === 'undefined' || typeof window.getSelection !== 'function') {
    return false;
  }

  const selection = window.getSelection();
  if (!selection) {
    return false;
  }

  return !selection.isCollapsed && String(selection.toString() || '').trim() !== '';
};

getDeepestExpandedChildKeys = (rows) => {
  const keys = new Set();

  const visitExpandedRow = (row) => {
    const children = Array.isArray(row?.children) ? row.children : [];
    const expandedChildren = children.filter((child) => this.isExpandedRow(child));

    if (expandedChildren.length === 0) {
      children.forEach((child) => {
        if (child?.Key) keys.add(child.Key);
      });
      return;
    }

    expandedChildren.forEach(visitExpandedRow);
  };

  (rows || []).forEach((row) => {
    if (this.isExpandedRow(row)) visitExpandedRow(row);
  });

  return keys;
};

findPortfolioRowContextByKey = (rows, key, parent = null) => {
  if (!Array.isArray(rows) || !key) {
    return null;
  }

  for (const row of rows) {
    if (row?.Key === key) {
      return {
        row,
        parent,
      };
    }

    const found = this.findPortfolioRowContextByKey(
      row?.children,
      key,
      row
    );

    if (found) {
      return found;
    }
  }

  return null;
};

getPortfolioRowVisualId = (row) => {
  if (!row) {
    return '';
  }

  return [
    row.Folder,
    row.Key,
    row.HierarchyType,
    row.HierarchySector,
    row.HierarchyCode,
    row.HierarchyTaxCategory,
    row.Asset1,
    row.Asset,
    row.Code,
    row.TradeDate,
    row.Date,
    row.PurchaseDate,
  ]
    .map((value) => String(value ?? '').trim())
    .join('::');
};

getPortfolioTableRowClassName = (record, index, totalRows, tableRows) => {
  const classes = [];

  if (this.isAssetClassRow(record)) {
    classes.push('portfolio-table-row-top-level');
  }

  if (this.isSectorRow(record)) {
    classes.push('portfolio-table-row-sector');
  }

  if (!this.isAssetClassRow(record) && !this.isSectorRow(record)) {
    classes.push('portfolio-table-row-child');
  }

  /*
   * 初期表示では全行を白背景にする。
   * 行を開いた後は、その行の直下の子行だけを白背景にし、
   * それ以外の表示行をすべて薄いブルーにする。
   *
   * Keyだけでは別階層の同一銘柄と重複する可能性があるため、
   * 階層情報を含む複合IDで判定する。
   */
  const whiteRowIds = this.state.lastOpenedChildRowIds;
  const currentRowId = this.getPortfolioRowVisualId(record);

  const isWhiteRow =
    whiteRowIds === null || whiteRowIds.includes(currentRowId);

  classes.push(
    isWhiteRow
      ? 'portfolio-table-row-opened-level'
      : 'portfolio-table-row-other-level'
  );

  if (isWhiteRow && whiteRowIds !== null) {
  }

  if (this.isSelectedRow(record)) {
    classes.push('portfolio-table-row-selected');
  }

  return classes.join(' ');
};

getVisiblePortfolioRowDepthMap = (rows, depth = 0, map = new Map()) => {
  if (!Array.isArray(rows)) {
    return map;
  }

  rows.forEach((row) => {
    if (row?.Key) {
      map.set(row.Key, depth);
    }

    if (this.isExpandedRow(row) && Array.isArray(row?.children) && row.children.length > 0) {
      this.getVisiblePortfolioRowDepthMap(row.children, depth + 1, map);
    }
  });

  return map;
};

getVisiblePortfolioMaxDepth = (rows) => {
  const visibleRowDepthMap = this.getVisiblePortfolioRowDepthMap(rows);
  let maxDepth = 0;

  visibleRowDepthMap.forEach((depth) => {
    if (depth > maxDepth) {
      maxDepth = depth;
    }
  });

  return maxDepth;
};

isLinkableDisplayValue = (value) => {
  const normalized = this.normalizeHierarchyText(value);
  return normalized !== null && normalized !== '複数有';
};

isSafeExternalUrl = (url) => (
  typeof url === 'string' && /^https?:\/\//i.test(url.trim())
);

getInstrumentLinkUrl = (row) => {
  const candidates = [row?.instrumentUrl, row?.URL, row?.Url, row?.url];
  return candidates.find((value) => this.isSafeExternalUrl(value)) ?? '';
};

getSectorFactsheetUrl = (row) => {
  const candidates = [row?.factsheetUrl, row?.factsheet_url];
  return candidates.find((value) => this.isSafeExternalUrl(value)) ?? '';
};

isInstrumentLinkRow = (row, displayValue = undefined) => {
  if (row?.DisableInstrumentLink) {
    return false;
  }
  if (!this.normalizeHierarchyText(row?.Code) || !this.getInstrumentLinkUrl(row)) {
    return false;
  }
  if (displayValue !== undefined) {
    return this.isLinkableDisplayValue(displayValue);
  }
  return true;
};

wrapInstrumentLink = (row, content) => {
  if (!this.isInstrumentLinkRow(row, content)) {
    return content;
  }
  return (
    <a
      href={this.getInstrumentLinkUrl(row)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={this.handleLinkClick}
      style={{ textDecoration: 'underline' }}
    >
      {content}
    </a>
  );
};

wrapSectorFactsheetLink = (row, content) => {
  if (this.state.currentPieView !== CURRENT_PIE_VIEW_SECTOR) {
    return content;
  }

  const factsheetUrl = this.getSectorFactsheetUrl(row);
  if (!factsheetUrl || !this.isLinkableDisplayValue(content)) {
    return content;
  }

  return (
    <a
      href={factsheetUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={this.handleLinkClick}
      style={{ textDecoration: 'underline' }}
    >
      {content}
    </a>
  );
};

isSellTradeRow = (row) => this.isTradeRow(row) && (Number(row?.Quantity) || 0) <= 0;

hasVisibleTradeCostBasis = (row) => (Number(row?.CostBasis) || 0) > 0;

getTradeAggregationCostBasis = (row) => Number(row?.FifoCostBasis ?? row?.CostBasis) || 0;

getOriginalTradeCostBasis = (row) => {
  const cashflow = Number(row?.OrgCashflow ?? row?.Cashflow ?? row?.Amount);
  if (Number.isFinite(cashflow) && cashflow !== 0) {
    return Math.abs(cashflow);
  }
  const quantity = Math.abs(Number(row?.AdjustedQuantity ?? row?.Quantity) || 0);
  const unitPrice = Number(row?.Price ?? row?.AdjustedAvgPrice ?? row?.AvgPrice) || 0;
  return quantity * Math.abs(unitPrice);
};

getTradeAggregationQuantity = (row, weightKey) => {
  if (weightKey === 'RawQuantity') {
    return Number(row?.RawOpenQuantity ?? row?.RawQuantity) || 0;
  }
  return Number(row?.OpenQuantity ?? row?.AdjustedQuantity ?? row?.Quantity) || 0;
};

getCurrentHoldingQuantity = (row) => {
  if (this.isTradeRow(row)) {
    return this.getTradeAggregationQuantity(row, 'AdjustedQuantity');
  }
  return Number(row?.Quantity) || 0;
};

hasCurrentHolding = (row) => Math.abs(this.getCurrentHoldingQuantity(row)) > 0;

isReservedTransactionRow = (row) => (
  this.isTradeRow(row)
  && (
    row?.Reserved === true
    || String(row?.EventType || '').toUpperCase() === 'RESERVED'
  )
);

getQuantityColumnDisplayValue = (record, value) => {
  if (this.isTradeRow(record) && String(record?.EventType || '').toUpperCase() === 'DIVIDEND') {
    return Number(record?.DisplayQuantity ?? record?.DividendEligibleQuantity ?? 0) || 0;
  }
  return Number(record?.RawQuantity ?? value ?? record?.Quantity) || 0;
};

getTradeAggregationAvgPrice = (row, valueKey, fallbackValueKey) => {
  if (valueKey === 'RawAvgPrice') {
    return Number(row?.FifoRawAvgPrice ?? row?.[valueKey] ?? row?.[fallbackValueKey]) || 0;
  }
  return Number(row?.FifoAvgPrice ?? row?.[valueKey] ?? row?.[fallbackValueKey]) || 0;
};

getCostBasisDisplay = (record) => {
  if (this.isReservedTransactionRow(record)) {
    return '-';
  }
  if (!this.isTradeRow(record)) {
    const value = record?.DCcy === 'JPY' ? numFormat(record?.CostBasis ?? 0) : rateFormat(record?.CostBasis ?? 0);
    return value;
  }
  if ((record?.PorS ?? 1) === 1) {
    const originalCostBasis = this.getOriginalTradeCostBasis(record);
    return record?.DCcy === 'JPY' ? numFormat(originalCostBasis) : rateFormat(originalCostBasis);
  }
  const fifoCostBasis = Number(record?.FifoCostBasis) || 0;
  if (fifoCostBasis <= 0) {
    return '-';
  }
  return record?.DCcy === 'JPY' ? numFormat(fifoCostBasis) : rateFormat(fifoCostBasis);
};

getAvgPriceDisplay = (record, aggregateAvgPrice) => {
  if (this.isReservedTransactionRow(record)) {
    return '-';
  }
  if (!this.isTradeRow(record)) {
    if (record.Quantity===0) return '-';
    return record?.DCcy ==='JPY' ? numFormat(aggregateAvgPrice) : rateFormat(aggregateAvgPrice);
  }
  if ((record?.PorS ?? 1) === 1) {
    const tradeAvgPrice = Number(record?.Price ?? record?.AdjustedAvgPrice ?? record?.AvgPrice) || 0;
    return record?.DCcy === 'JPY' ? numFormat(tradeAvgPrice) : rateFormat(tradeAvgPrice);
  }
  const fifoCostBasis = Number(record?.FifoCostBasis) || 0;
  const fifoAvgPrice = Number(record?.FifoAvgPrice) || 0;
  if (fifoCostBasis <= 0 || fifoAvgPrice <= 0) {
    return '-';
  }
  return record?.DCcy === 'JPY' ? numFormat(fifoAvgPrice) : rateFormat(fifoAvgPrice);
};

getUnrealizedProfitDisplay = (record, value) => {
  if (this.isReservedTransactionRow(record)) {
    return '-';
  }
  if (!this.hasCurrentHolding(record)) {
    return '-';
  }
  return record?.DCcy === 'JPY' ? numFormat(value) : rateFormat(value);
};

isCodeRow = (row) => {
  if (!row || row?.Folder !== 3 || !Array.isArray(row.children) || row.children.length === 0) {
    return false;
  }
  if (row?.HierarchyType === 'code') {
    return true;
  }
  if (this.isTaxCategoryRow(row)) {
    return false;
  }
  return row.children.every((child) => this.isTradeRow(child) || this.isTaxCategoryRow(child));
};

isSectorRow = (row) => {
  if (!row) {
    return false;
  }
  if (row?.HierarchyType === 'sector') {
    return true;
  }
  if (row?.Folder !== 3 || !Array.isArray(row.children) || row.children.length === 0) {
    return false;
  }
  return row.children.some((child) => this.isCodeRow(child));
};

normalizeHierarchyText = (value) => {
  const text = String(value ?? '').trim();
  if (text === '' || text === '-' || text === 'None') {
    return null;
  }
  return text;
};

collectDescendantTextValues = (rows, extractor, values = new Set()) => {
  if (!Array.isArray(rows)) return values;

  rows.forEach((row) => {
    const extracted = this.normalizeHierarchyText(extractor(row));
    if (extracted) {
      values.add(extracted);
    }
    if (Array.isArray(row?.children) && row.children.length > 0) {
      this.collectDescendantTextValues(row.children, extractor, values);
    }
  });

  return values;
};

summarizeHierarchyText = (row, extractor) => {
  const selfValue = this.normalizeHierarchyText(extractor(row));
  if (!Array.isArray(row?.children) || row.children.length === 0) {
    return selfValue ?? '-';
  }

  const values = Array.from(this.collectDescendantTextValues(row.children, extractor));
  if (values.length === 0) {
    return '-';
  }
  if (values.length === 1) {
    return values[0];
  }
  return '複数有';
};

normalizeSettingAmountValue = (value) => {
  if (value === null || value === undefined) {
    return null;
  }

  const text = String(value).trim();
  if (text === '' || text === '-' || text === 'None') {
    return null;
  }

  const numericValue = Number(text.replace(/,/g, ''));
  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return null;
  }

  return numericValue;
};

shouldDisplaySettingAmount = (record) => {
  const isMonthlyPlan = record?.AutoPlan === true || record?.AutoPlan === '毎月';
  const hasPlanParent = !!record?.TranId;
  return isMonthlyPlan || hasPlanParent;
};

collectDescendantSettingAmountValues = (rows, values = new Set()) => {
  if (!Array.isArray(rows)) return values;

  rows.forEach((row) => {
    const settingAmount = this.normalizeSettingAmountValue(row?.SettingAmount);
    if (this.shouldDisplaySettingAmount(row) && settingAmount !== null) {
      values.add(settingAmount);
    }

    if (Array.isArray(row?.children) && row.children.length > 0) {
      this.collectDescendantSettingAmountValues(row.children, values);
    }
  });

  return values;
};

formatSettingAmountDisplay = (value, ccy) => (
  String(ccy || '').toUpperCase() === 'JPY' ? numFormat(value) : rateFormat(value)
);

getSettingAmountDisplay = (value, record) => {
  if (Array.isArray(record?.children) && record.children.length > 0) {
    const values = Array.from(this.collectDescendantSettingAmountValues(record.children));
    if (values.length === 0) {
      return '-';
    }
    if (values.length > 1) {
      return '複数有';
    }
    return this.formatSettingAmountDisplay(values[0], record?.DCcy);
  }

  if (record?.Folder !== 9) {
    return '-';
  }
  if (!this.shouldDisplaySettingAmount(record)) {
    return '-';
  }
  if (value === '-') {
    return '-';
  }

  return this.formatSettingAmountDisplay(value ?? 0, record?.DCcy);
};

getClassificationDisplay = (row) => {
  if (this.isTradeRow(row)) {
    return this.getTradeDateDisplay(row);
  }
  if (this.isTaxCategoryRow(row)) {
    return this.getTaxShortDisplayFromNode(row);
  }
  if (row?.HierarchyLabel) {
    return row.HierarchyLabel;
  }
  if (row?.CashAccount && this.isCodeRow(row)) {
    return this.normalizeHierarchyText(row?.Code && removeTFromCode(row.Code)) ?? '-';
  }
  if (this.isCodeRow(row)) {
    return this.summarizeHierarchyText(row, (item) => item?.Code && removeTFromCode(item.Code));
  }
  return this.normalizeHierarchyText(row?.Asset) ?? '-';
};

getCodeRowInstrumentName = (row) => {
  const candidates = [
    row?.instrumentName,
    row?.InstrumentName,
    row?.instrument_name,
    row?.SecurityName,
    row?.securityName,
    row?.Name,
    row?.name,
  ];
  const resolvedName = candidates
    .map((value) => this.normalizeHierarchyText(value))
    .find(Boolean);

  return resolvedName ?? null;
};

getCodeRowClassificationDisplay = (row) => {
  if (row?.CashAccount) {
    const fallbackCode = this.normalizeHierarchyText(row?.Code && removeTFromCode(row.Code)) ?? '-';
    return this.wrapInstrumentLink(row, fallbackCode);
  }

  const instrumentName = this.getCodeRowInstrumentName(row);
  const fallbackCode = this.normalizeHierarchyText(row?.Code && removeTFromCode(row.Code)) ?? '-';

  if (!instrumentName) {
    return this.wrapInstrumentLink(row, fallbackCode);
  }

  return this.wrapInstrumentLink(row, this.renderTruncatedDisplayText(instrumentName));
};

shouldTruncateClassificationParentRow = (row) => (
  this.isSectorRow(row) || this.isAssetClassRow(row)
);

renderTruncatedDisplayText = (text, maxLength = 6) => {
  const normalizedText = this.normalizeHierarchyText(text) ?? '-';
  const truncatedText = truncateDisplayText(normalizedText, maxLength);
  const shouldShowTitle = truncatedText !== normalizedText;

  return (
    <span title={shouldShowTitle ? normalizedText : undefined}>
      {truncatedText}
    </span>
  );
};

getClassificationRenderContent = (row) => {
  if (this.isTradeRow(row)) {
    return this.getTradeDateRenderContent(row);
  }
  if (
    (row?.HierarchyType === 'account' || row?.HierarchyType === 'cashInstrument')
    && row?.HierarchyLabel
  ) {
    return row.HierarchyLabel;
  }
  if (this.isCodeRow(row)) {
    return this.getCodeRowClassificationDisplay(row);
  }
  const classificationDisplay = this.getClassificationDisplay(row);
  const content = this.shouldTruncateClassificationParentRow(row)
    ? this.renderTruncatedDisplayText(classificationDisplay)
    : classificationDisplay;

  if (
    this.state.currentPieView === CURRENT_PIE_VIEW_SECTOR &&
    this.getSectorFactsheetUrl(row)
  ) {
    return this.wrapSectorFactsheetLink(row, content);
  }

  return this.wrapInstrumentLink(row, content);
};

getAssetClassDisplay = (row) =>
  row?.HierarchyAssetClass ?? row?.AssetOptional ?? row?.Asset ?? '-';

getPortfolioBenchmarkDisplay = (row) => {
  if (this.isFixedRatioConstraintAsset(row) || row?.AssetEn === 'JPY Deposits') {
    return FIXED_RATIO_CONSTRAINT_BENCHMARK_LABEL;
  }
  const benchmarkDisplay = String(
    row?.BenchmarkIndex || row?.Benchmark || ''
  ).trim();

  if (!benchmarkDisplay || benchmarkDisplay === '要決定') {
    return '';
  }

  return benchmarkDisplay;
};

getBenchmarkColumnDisplay = (row) => {
  if (this.state.currentPieView === CURRENT_PIE_VIEW_SECTOR) {
    const benchmark = this.normalizeHierarchyText(row?.Benchmark) ?? '-';

    if (!this.isSectorRow(row) || benchmark === '-') {
      return benchmark;
    }

    const url = this.getInstrumentLinkUrl(row);
    if (!url) {
      return benchmark;
    }

    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={this.handleLinkClick}
        style={{ textDecoration: 'underline' }}
      >
        {benchmark}
      </a>
    );
  }

  return this.summarizeHierarchyText(row, (item) => item?.Benchmark);
};

getSectorColumnDisplay = (row) => {
  const sectorLabel = this.summarizeHierarchyText(
    row,
    (item) => item?.Sector ?? item?.HierarchySector ?? (this.isSectorRow(item) ? item?.Asset : null)
  );

  return this.wrapSectorFactsheetLink(row, sectorLabel);
};

getPercentColumnDisplay = (row, value, columnKey = 'SimulationPercent') => {
  if (this.isReservedTransactionRow(row)) {
    return '-';
  }
  if (this.state.currentPieView === CURRENT_PIE_VIEW_SECTOR) {
    if (this.isTradeRow(row) && columnKey !== 'SimulationPercent') {
      return '-';
    }
    if (!this.isSectorRow(row) && (columnKey === 'OptimalPercent' || columnKey === 'PercentDiff')) {
      return '-';
    }
  }

  if (value === null || value === undefined || value === '') {
    return '-';
  }

  if (
    columnKey === 'SimulationPercent'
    && this.isTradeRow(row)
    && ('OpenQuantity' in (row || {}) || 'Quantity' in (row || {}) || 'EventType' in (row || {}))
    && !this.hasCurrentHolding(row)
  ) {
    return '-';
  }

  return percentFormat(value);
};

collectExpandedKeysForClassification = (rows, keys = new Set()) => {
  if (!Array.isArray(rows)) return keys;

  rows.forEach((row) => {
    if (this.getClassificationDisplay(row) === '複数有' && row?.Key) {
      keys.add(row.Key);
    }
    if (Array.isArray(row?.children) && row.children.length > 0) {
      this.collectExpandedKeysForClassification(row.children, keys);
    }
  });

  return keys;
};

collapseSingleCategoryLevels = (rows) => {
  if (!Array.isArray(rows)) return rows;

  const normalizedRows = rows.map((row) => ({
    ...row,
    children: this.collapseSingleCategoryLevels(row?.children),
  }));

  if (normalizedRows.length === 1) {
    const [singleRow] = normalizedRows;
    const keepLevel =
      this.isAssetClassRow(singleRow) ||
      singleRow?.HierarchyType === 'code';

    if (keepLevel) {
      return normalizedRows;
    }
    if (!this.isTradeRow(singleRow)) {
      return Array.isArray(singleRow?.children) ? singleRow.children : [];
    }
  }

  return normalizedRows;
};

collapseSingleDisplayLevels = (rows) => {
  if (!Array.isArray(rows)) {
    return rows;
  }

  const normalizedRows = rows.map((row) => ({
    ...row,
    children: this.collapseSingleDisplayLevels(row?.children),
  }));

  if (normalizedRows.length === 1) {
    const [singleRow] = normalizedRows;

    if (!this.isTradeRow(singleRow)) {
      return Array.isArray(singleRow?.children)
        ? singleRow.children
        : normalizedRows;
    }
  }

  return normalizedRows;
};

buildAssetModeDisplayRows = (portfolioRecord) => {
  const assetRows = Array.isArray(portfolioRecord?.children)
    ? portfolioRecord.children
    : [];

  // Keep the selected top-level classification (asset class) visible.
  // Collapse only single intermediate levels beneath each asset row.
  return assetRows
    .filter((assetRow) => assetRow?.IsOptimizationOnly !== true)
    .map((assetRow) => ({
      ...assetRow,
      children: this.collapseSingleDisplayLevels(assetRow?.children),
    }));
};

getTradeDateDisplay = (row) => this.summarizeHierarchyText(row, (item) => item?.TradeDate ?? (this.isTradeRow(item) ? item?.Asset : null));

handleTradeDateEditClick = (event, row) => {
  event.stopPropagation();
  this.handleRowClick(row);
};

toggleRowExpanded = (record) => {
  if (!this.hasExpandableChildren(record)) {
    return;
  }

  this.setState((prevState) => {
    const expanded = prevState.expandedKeys.includes(record.Key);
    return {
      expandedKeys: expanded
        ? prevState.expandedKeys.filter((key) => key !== record.Key)
        : [...prevState.expandedKeys, record.Key],
    };
  });
};

handleExpandIconClick = (event, record, onExpand) => {
  event.stopPropagation();
  onExpand(record, event);
};

handleTableRowSelection = (event, record) => {
  if (!record?.Key || this.hasActiveTextSelection()) {
    return;
  }

  this.setState((prevState) => ({
    selectedRowKey: prevState.selectedRowKey === record.Key ? '' : record.Key,
  }));
};

getTradeDateRenderContent = (row) => {
  const displayValue = this.getTradeDateDisplay(row);

  if (!this.isEditableTradeDetailRow(row)) {
    return displayValue;
  }

  const normalizedDisplayValue = this.normalizeHierarchyText(displayValue);
  if (!normalizedDisplayValue) {
    return displayValue;
  }

  return (
    <button
      type="button"
      className="portfolio-trade-date-link"
      onClick={(event) => this.handleTradeDateEditClick(event, row)}
    >
      {normalizedDisplayValue}
    </button>
  );
};

collectTradeDates = (rows, values = []) => {
  if (!Array.isArray(rows)) return values;

  rows.forEach((row) => {
    const tradeDate = this.normalizeHierarchyText(row?.TradeDate ?? (this.isTradeRow(row) ? row?.Asset : null));
    if (tradeDate) {
      values.push(tradeDate);
    }
    if (Array.isArray(row?.children) && row.children.length > 0) {
      this.collectTradeDates(row.children, values);
    }
  });

  return values;
};

getStartDateDisplay = (row) => {
  const selfDate = this.normalizeHierarchyText(row?.StartDate ?? (this.isTradeRow(row) ? (row?.TradeDate ?? row?.Asset) : null));
  if (!Array.isArray(row?.children) || row.children.length === 0) {
    return selfDate ?? '-';
  }

  const dates = this.collectTradeDates(row.children).sort();
  if (dates.length === 0) {
    return selfDate ?? '-';
  }
  return dates[0];
};

collectWeightedAverageTotals = (rows, valueKey, weightKey, fallbackValueKey, fallbackWeightKey) => {
  return (rows || []).reduce((acc, row) => {
    if (Array.isArray(row?.children) && row.children.length > 0) {
      const childTotals = this.collectWeightedAverageTotals(row.children, valueKey, weightKey, fallbackValueKey, fallbackWeightKey);
      acc.numerator += childTotals.numerator;
      acc.denominator += childTotals.denominator;
      return acc;
    }

    let rawWeight = row?.[weightKey];
    if (this.isTradeRow(row)) {
      rawWeight = this.getTradeAggregationQuantity(row, weightKey);
    } else if (weightKey === 'Quantity' || weightKey === 'AdjustedQuantity') {
      rawWeight = row?.OpenQuantity ?? rawWeight;
    } else if (weightKey === 'RawQuantity') {
      rawWeight = row?.RawOpenQuantity ?? rawWeight;
    }
    const rawFallbackWeight = fallbackWeightKey ? row?.[fallbackWeightKey] : undefined;
    const resolvedWeight =
      rawWeight === null || rawWeight === undefined || rawWeight === ''
        ? rawFallbackWeight
        : rawWeight;
    const weight = Number(resolvedWeight) || 0;

    let rawValue = row?.[valueKey];
    if (this.isTradeRow(row)) {
      rawValue = this.getTradeAggregationAvgPrice(row, valueKey, fallbackValueKey);
    }
    const rawFallbackValue = fallbackValueKey ? row?.[fallbackValueKey] : undefined;
    const value = Number(
      rawValue === null || rawValue === undefined || rawValue === '' || rawValue === 0
        ? rawFallbackValue
        : rawValue
    );

    if (weight > 0 && Number.isFinite(value)) {
      acc.numerator += value * weight;
      acc.denominator += weight;
    }
    return acc;
  }, { numerator: 0, denominator: 0 });
};

getHierarchyWeightedAverage = (row, valueKey, weightKey, fallbackValueKey, fallbackWeightKey) => {
  // Instrument-level prices come from Backend, not child trade aggregation.
  if (row?.HierarchyType === 'code') {
    return row?.[valueKey] ?? row?.[fallbackValueKey] ?? 0;
  }
  if (!Array.isArray(row?.children) || row.children.length === 0) {
    const ownValue = row?.[valueKey];
    if (ownValue !== null && ownValue !== undefined && ownValue !== '' && ownValue !== 0) {
      return ownValue;
    }
    return row?.[fallbackValueKey] ?? 0;
  }

  const { numerator, denominator } = this.collectWeightedAverageTotals(
    row.children,
    valueKey,
    weightKey,
    fallbackValueKey,
    fallbackWeightKey
  );
  if (denominator === 0) {
    return row?.[valueKey] ?? row?.[fallbackValueKey] ?? 0;
  }
  return Math.abs(numerator / denominator);
};

sumRowValue = (rows, key) => rows.reduce((sum, row) => sum + (Number(row?.[key]) || 0), 0);

sumHierarchyQuantityValue = (rows, key) => rows.reduce((sum, row) => {
  if (this.isTradeRow(row)) {
    if (key === 'AdjustedQuantity') {
      return sum + (Number(row?.OpenQuantity ?? row?.AdjustedQuantity ?? row?.Quantity) || 0);
    }
    if (key === 'RawQuantity') {
      return sum + (Number(row?.RawOpenQuantity ?? row?.RawQuantity ?? row?.Quantity) || 0);
    }
  }
  return sum + (Number(row?.[key]) || 0);
}, 0);

sumCashflowValue = (rows) => rows.reduce((sum, row) => sum + (Number(row?.Cashflow ?? row?.Notional) || 0), 0);

getPortfolioHasManualCashTransactions = (portfolioRecord) => Boolean(portfolioRecord?.HasManualCashTransactions);

getActivePortfolioRecord = (data = this.state.data, activeTab = this.state.activeTab) => (
  Array.isArray(data) ? data.find((item) => item?.Portfolio === activeTab) ?? null : null
);

getCashTransactionInstrumentInfoFromRow = (row) => {
  const code = this.normalizeHierarchyText(row?.Code) || DEFAULT_CASH_INSTRUMENT_CODE;
  const asset = (
    this.normalizeHierarchyText(row?.AssetOptional)
    || this.normalizeHierarchyText(row?.Asset1)
    || (row?.CashAccount && row?.Folder !== 9 ? this.normalizeHierarchyText(row?.Asset) : null)
    || DEFAULT_CASH_INSTRUMENT_ASSET
  );
  const name = this.normalizeHierarchyText(row?.Name) || DEFAULT_CASH_INSTRUMENT_NAME;

  return {
    Code: code,
    Asset: asset,
    Name: name,
  };
};

getCashTransactionInstrumentInfo = (row = null, portfolioRecord = this.getActivePortfolioRecord()) => {
  const portfolioCashRow = Array.isArray(portfolioRecord?.children)
    ? portfolioRecord.children.find((child) => child?.CashAccount)
    : null;
  const candidateRows = [row, portfolioCashRow, portfolioCashRow?.children?.[0]].filter(Boolean);

  for (const candidate of candidateRows) {
    const info = this.getCashTransactionInstrumentInfoFromRow(candidate);
    if (
      info.Code !== DEFAULT_CASH_INSTRUMENT_CODE
      || info.Asset !== DEFAULT_CASH_INSTRUMENT_ASSET
      || info.Name !== DEFAULT_CASH_INSTRUMENT_NAME
    ) {
      return info;
    }
  }

  return this.getCashTransactionInstrumentInfoFromRow(candidateRows[0] || null);
};

shouldShowIRRCashflowColumn = (portfolioRecord = this.getActivePortfolioRecord()) => (
  this.getPortfolioHasManualCashTransactions(portfolioRecord)
);

getRowMarketValue = (row) => Number(row?.Value) || 0;

getDisplayedRowMarketValue = (row) => {
  if ((Number(row?.Quantity) || 0) === 0) {
    return 0;
  }
  return this.getRowMarketValue(row);
};

summarizeDateValue = (rows, key) => {
  const values = [...new Set(
    (rows || [])
      .map((row) => this.normalizeHierarchyText(row?.[key]))
      .filter((value) => value !== null)
  )];
  if (values.length === 0) return '-';
  if (values.includes('複数有')) return '複数有';
  if (values.length === 1) return values[0];
  return '複数有';
};

isCashAccountTradeOrDividendRow = (row) => {
  if (!row?.CashAccount || row?.Folder !== 9) {
    return false;
  }
  const eventType = String(row?.EventType || '').toUpperCase();
  return eventType === 'TRADE' || eventType === 'DIVIDEND';
};

collectPortfolioSummaryRows = (rows, collected = []) => {
  if (!Array.isArray(rows)) {
    return collected;
  }

  rows.forEach((row) => {
    if (this.isCashAccountTradeOrDividendRow(row)) {
      return;
    }

    if (Array.isArray(row?.children) && row.children.length > 0) {
      this.collectPortfolioSummaryRows(row.children, collected);
      return;
    }

    collected.push(row);
  });

  return collected;
};

buildPortfolioMarketValueSummary = (rows, options = {}) => {
  const summaryRows = Array.isArray(rows) ? rows : [];
  const hasManualCashTransactions = Boolean(options?.hasManualCashTransactions);
  const quantity = this.sumRowValue(summaryRows, 'Quantity');
  const marketValue = summaryRows.reduce((sum, row) => sum + this.getDisplayedRowMarketValue(row), 0);
  const profit = this.sumRowValue(summaryRows, 'Profit');
  const unrealizedProfit = this.sumRowValue(summaryRows, 'UnrealizedProfit');
  const realizedProfit = this.sumRowValue(summaryRows, 'RealizedProfit');
  const summaryLeafRows = this.collectPortfolioSummaryRows(summaryRows);
  const hasCurrentHoldings = summaryLeafRows.some((row) => this.hasCurrentHolding(row));
  const cumulativeInvestmentAmount = hasManualCashTransactions
    ? summaryLeafRows.reduce((sum, row) => {
        if (!row?.CashAccount) {
          return sum;
        }
        const irrCashflow = Number(row?.IRRCashflow) || 0;
        return sum + irrCashflow;
      }, 0) * -1
    : summaryLeafRows.reduce((sum, row) => sum + (Number(row?.CostBasis) || 0), 0);
  const totalProfitRate = cumulativeInvestmentAmount === 0 ? 0 : (profit / cumulativeInvestmentAmount);

  return {
    quantity,
    marketValue,
    profit,
    unrealizedProfit,
    realizedProfit,
    cumulativeInvestmentAmount,
    totalProfitRate,
    hasCurrentHoldings,
  };
};

debugPortfolioSummary = (record) => {
  if (!record || !Array.isArray(record.children)) {
    return;
  }

  const topLevelRows = record.children.map((row) => ({
    Key: row?.Key ?? '',
    Code: row?.Code ?? '',
    Asset: row?.Asset ?? '',
    EventType: row?.EventType ?? '',
    CashAccount: Boolean(row?.CashAccount),
    Folder: row?.Folder ?? '',
    Quantity: Number(row?.Quantity) || 0,
    MarketValue: this.getRowMarketValue(row),
    Profit: Number(row?.Profit) || 0,
    UnrealizedProfit: Number(row?.UnrealizedProfit) || 0,
    RealizedProfit: Number(row?.RealizedProfit) || 0,
  }));

  const summaryLeafRows = this.collectPortfolioSummaryRows(record.children).map((row) => ({
    Key: row?.Key ?? '',
    Code: row?.Code ?? '',
    Asset: row?.Asset ?? '',
    EventType: row?.EventType ?? '',
    CashAccount: Boolean(row?.CashAccount),
    Folder: row?.Folder ?? '',
    Quantity: Number(row?.Quantity) || 0,
    MarketValue: this.getRowMarketValue(row),
    Profit: Number(row?.Profit) || 0,
    UnrealizedProfit: Number(row?.UnrealizedProfit) || 0,
    RealizedProfit: Number(row?.RealizedProfit) || 0,
  }));

  const signature = JSON.stringify({
    portfolio: record?.Portfolio ?? '',
    topLevelRows: topLevelRows.map((row) => [row.Key, row.MarketValue, row.Profit, row.UnrealizedProfit, row.RealizedProfit]),
    summaryLeafRows: summaryLeafRows.map((row) => [row.Key, row.MarketValue, row.Profit, row.UnrealizedProfit, row.RealizedProfit]),
  });

  if (signature === this.lastPortfolioSummaryDebugSignature) {
    return;
  }

  this.lastPortfolioSummaryDebugSignature = signature;

  // console.group(`[PORT] Summary MarketValue dump: ${record?.Portfolio ?? ''}`);
  // console.table(topLevelRows);
  // console.table(summaryLeafRows);
  // console.log('topLevelMarketValueTotal', topLevelRows.reduce((sum, row) => sum + row.MarketValue, 0));
  // console.log('summaryLeafMarketValueTotal', summaryLeafRows.reduce((sum, row) => sum + row.MarketValue, 0));
  // console.groupEnd();
};

getSingleInstrumentMetadata = (rows) => {
  const unique = new Map();

  (rows || []).forEach((row) => {
    const code = this.normalizeHierarchyText(row?.Code);
    const url = this.getInstrumentLinkUrl(row);
    if (!code || !url) {
      return;
    }
    const key = `${code}@@${url}`;
    if (!unique.has(key)) {
      unique.set(key, {
        Code: code,
        URL: url,
        Name: this.normalizeHierarchyText(row?.Name) ?? '',
      });
    }
  });

  if (unique.size !== 1) {
    return null;
  }

  return Array.from(unique.values())[0];
};

buildHierarchyGroupRow = (label, childRows, overrides = {}) => {
  const base = childRows[0] || {};
  const singleInstrument = this.getSingleInstrumentMetadata(childRows);
  const quantity = this.sumRowValue(childRows, 'Quantity');
  const rawQuantity = this.sumHierarchyQuantityValue(childRows, 'RawQuantity');
  const adjustedQuantity = this.sumHierarchyQuantityValue(childRows, 'AdjustedQuantity');
  const openQuantity = this.sumRowValue(childRows, 'OpenQuantity');
  const rawOpenQuantity = this.sumRowValue(childRows, 'RawOpenQuantity');
  const marketValue = childRows.reduce((sum, row) => sum + this.getRowMarketValue(row), 0);
  const cashflow = this.sumCashflowValue(childRows);
  const irrCashflow = this.sumRowValue(childRows, 'IRRCashflow');
  const profitCashflow = this.sumRowValue(childRows, 'ProfitCashflow');
  const costBasis = childRows.reduce((sum, row) => sum + (this.isTradeRow(row) ? this.getTradeAggregationCostBasis(row) : (Number(row?.CostBasis) || 0)), 0);
  const unrealizedProfit = this.sumRowValue(childRows, 'UnrealizedProfit');
  const realizedProfit = this.sumRowValue(childRows, 'RealizedProfit');
  const profit = this.sumRowValue(childRows, 'Profit');

  return {
    ...base,
    ...overrides,
    Folder: 3,
    Key: overrides?.Key ?? `${overrides?.HierarchyType ?? 'group'}:${label}:${base?.Key ?? childRows.length}`,
    HierarchyLabel: label,
    HierarchyType: overrides?.HierarchyType ?? base?.HierarchyType ?? 'group',
    Asset: overrides?.Asset ?? label,
    Name: overrides?.Name ?? singleInstrument?.Name ?? base?.Name ?? '-',
    Code: overrides?.Code ?? singleInstrument?.Code ?? '',
    URL: overrides?.URL ?? singleInstrument?.URL ?? '',
    Url: overrides?.Url ?? overrides?.URL ?? singleInstrument?.URL ?? '',
    url: overrides?.url ?? overrides?.URL ?? singleInstrument?.URL ?? '',
    instrumentUrl:
      overrides?.instrumentUrl
      ?? overrides?.URL
      ?? singleInstrument?.URL
      ?? '',
    TaxCategory: overrides?.TaxCategory ?? base?.TaxCategory ?? '-',
    TradeDate: overrides?.TradeDate ?? base?.TradeDate ?? '',
    children: childRows,
    Value: marketValue,
    Cashflow: cashflow,
    IRRCashflow: irrCashflow,
    Notional: cashflow,
    ProfitCashflow: profitCashflow,
    CostBasis: costBasis,
    Quantity: quantity,
    RawQuantity: rawQuantity,
    AdjustedQuantity: adjustedQuantity,
    OpenQuantity: openQuantity,
    RawOpenQuantity: rawOpenQuantity,
    Profit: profit,
    UnrealizedProfit: unrealizedProfit,
    RealizedProfit: realizedProfit,
    ProfitRate: costBasis === 0 ? 0 : (profit / costBasis),
    IRR: overrides?.IRR ?? '-',
    SimulationPercent: this.sumRowValue(childRows, 'SimulationPercent'),
    CurrentPrice: quantity === 0 ? 0 : (
      singleInstrument
        ? (() => {
            // A single instrument already has a quoted unit price.
            // Preserve that price instead of dividing market value by units.
            const findQuotedPrice = (rows) => {
              for (const row of rows) {
                if (Array.isArray(row?.children) && row.children.length > 0) {
                  const nestedPrice = findQuotedPrice(row.children);
                  if (nestedPrice !== null) return nestedPrice;
                }
                const price = Number(row?.CurrentPrice);
                if (Number.isFinite(price) && price > 0) return price;
              }
              return null;
            };
            return findQuotedPrice(childRows) ?? 0;
          })()
        : Math.abs(marketValue / quantity)
    ),
    CurrentPriceDate: this.summarizeDateValue(childRows, 'CurrentPriceDate'),
    AvgPrice: adjustedQuantity === 0 ? 0 : Math.abs(costBasis / adjustedQuantity),
    RawAvgPrice: rawOpenQuantity === 0 ? 0 : Math.abs(costBasis / rawOpenQuantity),
    AdjustedAvgPrice: adjustedQuantity === 0 ? 0 : Math.abs(costBasis / adjustedQuantity),
  };
};

buildCodeRowFromTrades = (codeRow, tradeRows) => {
  const tradesByTax = {};

  (tradeRows || []).forEach((trade) => {
    const taxGroupKey = this.getTaxGroupingKey(trade);
    if (!tradesByTax[taxGroupKey]) {
      tradesByTax[taxGroupKey] = {
        display: this.getTaxDisplayFromNode(trade) || '-',
        shortDisplay: this.getTaxShortDisplayFromNode(trade),
        trades: [],
      };
    }
    tradesByTax[taxGroupKey].trades.push(trade);
  });

  const taxRows = Object.values(tradesByTax).map(({ display: taxKey, shortDisplay: taxShortDisplay, trades: taxTrades }) =>
    this.buildHierarchyGroupRow(taxKey, taxTrades, {
      ...codeRow,
      children: taxTrades,
      HierarchyType: 'tax',
      Asset: taxKey,
      Name: codeRow?.Name,
      Code: codeRow?.Code,
      Sector: this.summarizeHierarchyText({ children: taxTrades }, (item) => item?.Sector ?? item?.HierarchySector),
      TradeDate: '',
      TaxCategoryDisplay: taxKey,
      TaxCategoryShortDisplay: taxShortDisplay,
      EventTypeDisplay: this.summarizeHierarchyText({ children: taxTrades }, (item) => item?.EventTypeDisplay ?? this.getEventTypeDisplayFromNode(item)),
    })
  );

  const codeGroup = this.buildHierarchyGroupRow(codeRow?.Code || codeRow?.Asset, taxRows, {
    ...codeRow,
    children: taxRows,
    HierarchyType: 'code',
    Asset: codeRow?.Code || codeRow?.Asset,
    Name: codeRow?.Name,
    Code: codeRow?.Code,
    Sector: this.summarizeHierarchyText({ children: taxRows }, (item) => item?.Sector ?? item?.HierarchySector),
    TradeDate: '',
    TaxCategoryDisplay: this.summarizeHierarchyText({ children: taxRows }, (item) => item?.TaxCategoryDisplay),
    TaxCategoryShortDisplay: this.summarizeHierarchyText({ children: taxRows }, (item) => this.getTaxShortDisplayFromNode(item)),
    EventTypeDisplay: this.summarizeHierarchyText({ children: taxRows }, (item) => item?.EventTypeDisplay),
  });

  // Preserve Backend's instrument-level prices. Do not recalculate them
  // from monetary values divided by mutual-fund units.
  return {
    ...codeGroup,
    CurrentPrice: codeRow?.CurrentPrice ?? codeGroup.CurrentPrice,
    AvgPrice: codeRow?.AvgPrice ?? codeGroup.AvgPrice,
    AdjustedAvgPrice: codeRow?.AdjustedAvgPrice ?? codeRow?.AvgPrice ?? codeGroup.AdjustedAvgPrice,
  };
};

buildSectorRow = (sector, codeRows) => this.buildHierarchyGroupRow(
  this.getJapanStockSectorLabel(sector),
  codeRows,
  {
    Sector: this.getJapanStockSectorLabel(sector),
    HierarchyType: 'sector',
  }
);

toHierarchySourceRow = (row) => {
  if (!row || typeof row !== 'object') return null;
  const { children, ...sourceRow } = row;
  return sourceRow;
};

createHierarchyTradeRow = (trade, assetLabel, sectorLabel = null, sourceRows = {}) => ({
  ...trade,
  Sector: this.normalizeHierarchyText(trade?.Sector ?? sectorLabel) ?? '',
  HierarchyAssetClass: this.normalizeHierarchyText(assetLabel ?? trade?.AssetOptional ?? trade?.Asset) ?? '-',
  HierarchySector: this.normalizeHierarchyText(trade?.Sector ?? sectorLabel) ?? '',
  HierarchyCode: this.normalizeHierarchyText(trade?.Code) ?? this.normalizeHierarchyText(trade?.Asset) ?? '-',
  HierarchyTaxCategory: this.getHierarchyTaxCategory(trade),
  HierarchyTradeDate: this.normalizeHierarchyText(trade?.TradeDate ?? trade?.Asset) ?? '-',
  HierarchySourceSectorRow: sourceRows?.sectorRow ?? null,
  HierarchySourceCodeRow: sourceRows?.codeRow ?? null,
});

collectTradeRowsFromHierarchy = (rows, assetLabel, inheritedSector = null, trades = [], sourceRows = {}) => {
  if (!Array.isArray(rows)) return trades;

  rows.forEach((row) => {
    const nextSector = this.normalizeHierarchyText(row?.Sector) ?? inheritedSector;
    const nextSourceRows = {
      sectorRow: this.isSectorRow(row) ? this.toHierarchySourceRow(row) : sourceRows?.sectorRow ?? null,
      codeRow: this.isCodeRow(row) ? this.toHierarchySourceRow(row) : sourceRows?.codeRow ?? null,
    };
    if (this.isTradeRow(row)) {
      if (row?.CashAccount) {
        return;
      }
      trades.push(this.createHierarchyTradeRow(row, assetLabel, nextSector, nextSourceRows));
      return;
    }
    if (Array.isArray(row?.children) && row.children.length > 0) {
      this.collectTradeRowsFromHierarchy(row.children, assetLabel, nextSector, trades, nextSourceRows);
    }
  });

  return trades;
};

applyFifoCostBasisToTrades = (trades) => {
  if (!Array.isArray(trades) || trades.length === 0) {
    return trades;
  }

  const groupedTrades = trades.reduce((acc, trade) => {
    const fifoGroupKey = this.getFifoGroupingKey(trade);
    if (!acc[fifoGroupKey]) {
      acc[fifoGroupKey] = [];
    }
    acc[fifoGroupKey].push(trade);
    return acc;
  }, {});

    return Object.values(groupedTrades).flatMap((codeTrades) => {
    const orderedTrades = [...codeTrades].sort((a, b) => {
      const dateA = String(a?.TradeDate ?? a?.Asset ?? '');
      const dateB = String(b?.TradeDate ?? b?.Asset ?? '');
      if (dateA !== dateB) {
        return dateA.localeCompare(dateB);
      }
      return Number(a?.Id ?? 0) - Number(b?.Id ?? 0);
    });

    const adjustedLots = [];
    const rawLots = [];
    const adjustedState = new Map();
    const rawState = new Map();
    let currentAdjustedQuantity = 0;
    let currentRawQuantity = 0;

    const getLotNetQuantity = (lots) => lots.reduce((sum, lot) => sum + (Number(lot?.qty) || 0), 0);

    const applyLotDelta = (lots, lotState, trade, quantity, unitPrice) => {
      let remaining = quantity;
      while (remaining !== 0 && lots.length > 0 && Math.sign(lots[0].qty) !== Math.sign(remaining)) {
        const lot = lots[0];
        const closed = Math.min(Math.abs(remaining), Math.abs(lot.qty));
        lot.qty += lot.qty > 0 ? -closed : closed;
        remaining += remaining > 0 ? -closed : closed;
        if (Math.abs(lot.qty) < 1e-9) {
          lots.shift();
        }
      }
      if (Math.abs(remaining) >= 1e-9) {
        lots.push({ tradeId: trade.Id, qty: remaining, unitPrice });
      }
      const nextState = new Map();
      lots.forEach((lot) => {
        const current = nextState.get(lot.tradeId) || { qty: 0, costBasis: 0 };
        current.qty += lot.qty;
        current.costBasis += Math.abs(lot.qty) * Math.abs(lot.unitPrice);
        nextState.set(lot.tradeId, current);
      });
      lotState.clear();
      nextState.forEach((value, key) => lotState.set(key, value));
    };

    orderedTrades.forEach((trade) => {
      if (String(trade?.EventType ?? 'TRADE').toUpperCase() === 'DIVIDEND') {
        trade.AdjustedQuantity = currentAdjustedQuantity;
        trade.RawQuantity = currentRawQuantity;
        return;
      }
      const adjustedQuantity = Number(trade?.AdjustedQuantity ?? trade?.Quantity) || 0;
      const rawQuantity = Number(trade?.RawQuantity ?? trade?.Quantity) || 0;
      const adjustedUnitPrice = Number(trade?.AdjustedAvgPrice ?? trade?.AvgPrice) || 0;
      const rawUnitPrice = Number(trade?.RawAvgPrice ?? trade?.AvgPrice) || 0;
      applyLotDelta(adjustedLots, adjustedState, trade, adjustedQuantity, adjustedUnitPrice);
      applyLotDelta(rawLots, rawState, trade, rawQuantity, rawUnitPrice);
      currentAdjustedQuantity = getLotNetQuantity(adjustedLots);
      currentRawQuantity = getLotNetQuantity(rawLots);
    });

    const tradesWithFifo = orderedTrades.map((trade) => {
      if (String(trade?.EventType ?? 'TRADE').toUpperCase() === 'DIVIDEND') {
        return {
          ...trade,
          OpenQuantity: 0,
          RawOpenQuantity: 0,
          FifoCostBasis: 0,
          FifoAvgPrice: 0,
          FifoRawAvgPrice: 0,
        };
      }

      const adjusted = adjustedState.get(trade.Id) || { qty: 0, costBasis: 0 };
      const raw = rawState.get(trade.Id) || { qty: 0, costBasis: 0 };
      const adjustedAvgPrice = adjusted.qty === 0 ? 0 : Math.abs(adjusted.costBasis / adjusted.qty);
      const rawAvgPrice = raw.qty === 0 ? 0 : Math.abs(raw.costBasis / raw.qty);

      return {
        ...trade,
        OpenQuantity: adjusted.qty,
        RawOpenQuantity: raw.qty,
        FifoCostBasis: adjusted.costBasis,
        FifoAvgPrice: adjustedAvgPrice,
        FifoRawAvgPrice: rawAvgPrice,
      };
    });

    return tradesWithFifo.sort((a, b) => {
      const dateA = String(a?.TradeDate ?? a?.Asset ?? '');
      const dateB = String(b?.TradeDate ?? b?.Asset ?? '');
      if (dateA !== dateB) {
        return dateB.localeCompare(dateA);
      }
      return Number(b?.Id ?? 0) - Number(a?.Id ?? 0);
    });
  });
};

getCashAccountInfo = (row) => {
  const rawAccountId = row?.AccountId ?? null;
  const rawAccountName = this.normalizeHierarchyText(row?.Account);

  const matchedById = rawAccountId != null
    ? this.state.userAccounts.find(
        (account) => String(account?.id ?? '') === String(rawAccountId)
      )
    : null;

  const matchedByName = !matchedById && rawAccountName
    ? (() => {
        const matches = this.state.userAccounts.filter(
          (account) =>
            this.normalizeHierarchyText(account?.displayName) === rawAccountName
        );
        return matches.length === 1 ? matches[0] : null;
      })()
    : null;

  const matchedAccount = matchedById || matchedByName;

  return {
    accountId: matchedAccount?.id ?? rawAccountId,
    accountName:
      this.normalizeHierarchyText(matchedAccount?.displayName)
      || rawAccountName
      || '口座未設定',
    institutionType:
      this.normalizeHierarchyText(matchedAccount?.financialInstitutionType)
      || '',
  };
};

getCashHierarchyInstrumentInfo = (row) => {
  const originalCode = this.normalizeHierarchyText(row?.Code) || '';
  const { institutionType } = this.getCashAccountInfo(row);

// MRF is a real JPY-deposit instrument. Preserve its identity even when
// the row also carries CashAccount metadata.
if (/^MRF\d+$/i.test(originalCode)) {
  return {
    code: originalCode,
    label: this.normalizeHierarchyText(row?.Name) || originalCode,
  };
}


  // CashAccount rows represent cash movements. The original Code/Name is
  // the source security of the settlement, not a cash instrument.
  if (row?.CashAccount) {
    if (institutionType === 'BANK') {
      return {
        code: DEFAULT_CASH_INSTRUMENT_CODE,
        label: '普通預金',
      };
    }

    return {
      code: DEFAULT_CASH_INSTRUMENT_CODE,
      label: '現金残高',
    };
  }

  // Ordinary JPY deposit holdings such as JPYCASH and MRF keep their
  // instrument identity.
  if (originalCode === DEFAULT_CASH_INSTRUMENT_CODE) {
    if (institutionType === 'BANK') {
      return { code: originalCode, label: '普通預金' };
    }
    if (institutionType === 'BROKER') {
      return { code: originalCode, label: '現金残高' };
    }
    return {
      code: originalCode,
      label: DEFAULT_CASH_INSTRUMENT_NAME,
    };
  }

  return {
    code: originalCode,
    label:
      this.normalizeHierarchyText(row?.Name)
      || originalCode,
  };
};

collectCashDetailRows = (rows, collected = [], indexById = new Map()) => {
  if (!Array.isArray(rows)) return collected;

  rows.forEach((row) => {
    if (row?.Folder === 9) {
      const rowId = row?.Id ?? null;

      if (rowId === null) {
        collected.push(row);
        return;
      }

      if (!indexById.has(rowId)) {
        indexById.set(rowId, collected.length);
        collected.push(row);
        return;
      }

      const existingIndex = indexById.get(rowId);
      const existingRow = collected[existingIndex];

      // The same transaction can appear once as the ordinary JPY-deposit
      // holding and once as its generated cash movement. Prefer the ordinary
      // holding row so JPYCASH/MRF is not displayed twice.
      if (existingRow?.CashAccount && !row?.CashAccount) {
        collected[existingIndex] = row;
      }
      return;
    }

    if (Array.isArray(row?.children) && row.children.length > 0) {
      this.collectCashDetailRows(row.children, collected, indexById);
    }
  });

  return collected;
};

buildCashHierarchyChildren = (cashAssetRow) => {
  const detailRows = this.collectCashDetailRows(cashAssetRow?.children);

  if (detailRows.length === 0) {
    return [];
  }

  const accountGroups = new Map();

  detailRows.forEach((row) => {
    const accountInfo = this.getCashAccountInfo(row);
    const accountKey = accountInfo.accountId != null
      ? `id:${accountInfo.accountId}`
      : `name:${accountInfo.accountName}`;

    if (!accountGroups.has(accountKey)) {
      accountGroups.set(accountKey, {
        ...accountInfo,
        rows: [],
      });
    }

    accountGroups.get(accountKey).rows.push(row);
  });

  const accountRows = Array.from(accountGroups.values()).map((accountGroup) => {
    const instrumentGroups = new Map();

    accountGroup.rows.forEach((row) => {
      const instrumentInfo = this.getCashHierarchyInstrumentInfo(row);
      const instrumentKey = instrumentInfo.code || instrumentInfo.label;

      if (!instrumentGroups.has(instrumentKey)) {
        instrumentGroups.set(instrumentKey, {
          ...instrumentInfo,
          rows: [],
        });
      }

      instrumentGroups.get(instrumentKey).rows.push(row);
    });

    const instrumentRows = Array.from(instrumentGroups.values()).map((instrumentGroup) => {

      return this.buildHierarchyGroupRow(
        instrumentGroup.label,
        instrumentGroup.rows,
        {
          HierarchyType: 'cashInstrument',
          HierarchyLabel: instrumentGroup.label,
          Asset: instrumentGroup.label,
          Code: instrumentGroup.code,
          Name: instrumentGroup.label,
          CashAccount: true,
          TradeDate: '',
        }
      );
    });

    // Only one cash instrument in this account:
    // omit the instrument level and show the movement history directly.
    const accountChildren = instrumentRows.length === 1
      ? (instrumentRows[0]?.children || [])
      : instrumentRows;

    return this.buildHierarchyGroupRow(
      accountGroup.accountName,
      accountChildren,
      {
        HierarchyType: 'account',
        HierarchyLabel: accountGroup.accountName,
        Asset: accountGroup.accountName,
        Account: accountGroup.accountName,
        AccountId: accountGroup.accountId,
        CashAccount: true,
        Code: '',
        Name: accountGroup.accountName,
        TradeDate: '',
      }
    );
  });

  // Only one account in 日本円預金:
  // omit the account level too.
  if (accountRows.length === 1) {
    return accountRows[0]?.children || [];
  }

  return accountRows;
};

buildHierarchyLevelRows = (rows, levels) => {
  if (!Array.isArray(rows) || rows.length === 0) return [];
  if (!Array.isArray(levels) || levels.length === 0) return rows;

  const [level, ...restLevels] = levels;
  const groups = rows.reduce((acc, row) => {
    const key = level.getKey(row);
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(row);
    return acc;
  }, {});

  return Object.entries(groups).map(([groupKey, groupRows]) => {
    const childRows = this.buildHierarchyLevelRows(groupRows, restLevels);
    return this.buildHierarchyGroupRow(level.getLabel(groupRows[0], groupKey), childRows, {
      ...level.getOverrides(groupRows[0], groupKey, childRows),
      children: childRows,
    });
  });
};

buildAssetHierarchyChildren = (assetRow) => {
  const trades = this.applyFifoCostBasisToTrades(this.collectTradeRowsFromHierarchy(assetRow?.children, assetRow?.Asset));
  const levels = [
    {
      getKey: (row) => row?.HierarchyCode ?? '-',
      getLabel: (_, key) => key || '-',
      getOverrides: (row, key) => ({
        ...(row?.HierarchySourceCodeRow || {}),
        HierarchyType: 'code',
        Code: row?.HierarchySourceCodeRow?.Code ?? row?.Code ?? key ?? '',
        Name: row?.HierarchySourceCodeRow?.Name ?? row?.Name,
      }),
    },
    {
      getKey: (row) => row?.HierarchyTaxCategory ?? '-',
      getLabel: (_, key) => key || '-',
      getOverrides: (_, key) => ({ HierarchyType: 'tax', TaxCategoryDisplay: key || '-' }),
    },
  ];

  return this.collapseSingleCategoryLevels(this.buildHierarchyLevelRows(trades, levels));
};

groupCodeRowsByTaxCategory = (codeRows) => {
  const codeGroups = {};

  (codeRows || []).forEach((codeRow) => {
    const trades = Array.isArray(codeRow?.children) ? codeRow.children.filter((child) => this.isTradeRow(child)) : [];
    if (trades.length === 0) return;

    const codeKey = this.normalizeHierarchyText(codeRow?.Code) || this.normalizeHierarchyText(codeRow?.Asset) || '-';
    if (!codeGroups[codeKey]) {
      codeGroups[codeKey] = { codeRow, trades: [] };
    }
    codeGroups[codeKey].trades.push(...trades);
  });

  return Object.values(codeGroups).map(({ codeRow, trades }) => this.buildCodeRowFromTrades(codeRow, trades));
};

groupJapanStockCodeRows = (codeRows) => {
  const codeGroups = {};

  (codeRows || []).forEach((codeRow) => {
    const trades = Array.isArray(codeRow?.children) ? codeRow.children.filter((child) => this.isTradeRow(child)) : [];
    if (trades.length === 0) return;

    const codeKey = this.normalizeHierarchyText(codeRow?.Code) || this.normalizeHierarchyText(codeRow?.Asset) || '-';
    if (!codeGroups[codeKey]) {
      codeGroups[codeKey] = { codeRow, trades: [] };
    }
    codeGroups[codeKey].trades.push(...trades);
  });

  return Object.values(codeGroups).map(({ codeRow, trades }) => this.buildCodeRowFromTrades(codeRow, trades));
};

ensureJapanStockSectorGroups = (rows) => {
  if (!Array.isArray(rows)) return rows;

  if (rows.some((row) => this.isSectorRow(row))) {
    return rows;
  }

  if (!rows.every((row) => this.isCodeRow(row))) {
    return rows;
  }

  const groups = rows.reduce((acc, row) => {
    const sector = row?.Sector || '';
    if (!acc[sector]) {
      acc[sector] = [];
    }
    acc[sector].push(row);
    return acc;
  }, {});

  return Object.entries(groups).map(([sector, codeRows]) => this.buildSectorRow(sector, codeRows));
};

transformPortfolioHierarchy = (rows) => {
  if (!Array.isArray(rows)) return rows;

  const transformedRows = rows.map((row) => {
    if (
      row?.CashAccount
      || (row?.Folder === 2 && row?.AssetEn === 'JPY Deposits')
    ) {
      const rebuiltChildren = this.buildCashHierarchyChildren(row);

      return {
        ...row,
        children: rebuiltChildren,
      };
    }

    if (row?.Folder === 2) {
      const rebuiltChildren = this.buildAssetHierarchyChildren(row);
      const aggregatedRow = this.buildHierarchyGroupRow(row?.Asset, rebuiltChildren, {
        ...row,
        children: rebuiltChildren,
        HierarchyType: 'asset',
      });
      return {
        ...aggregatedRow,
        ...row,
        children: rebuiltChildren,
        Folder: 2,
        Asset: row?.Asset,
        Code: row?.Code || aggregatedRow?.Code || '',
        URL: row?.URL || row?.Url || row?.url || row?.instrumentUrl || aggregatedRow?.URL || '',
        Url: row?.Url || row?.URL || row?.url || row?.instrumentUrl || aggregatedRow?.URL || '',
        url: row?.url || row?.URL || row?.Url || row?.instrumentUrl || aggregatedRow?.URL || '',
        instrumentUrl: row?.instrumentUrl || row?.URL || row?.Url || row?.url || aggregatedRow?.URL || '',
        Name: row?.Name || aggregatedRow?.Name || '-',
        Key: row?.Key,
        HierarchyType: 'asset',
      };
    }

    return {
      ...row,
      children: this.transformPortfolioHierarchy(row.children),
    };
  });

  return this.sortRowsByDefaultHierarchy(
    this.collapseSingleCategoryLevels(transformedRows)
  );
};



getStockPrice = async (code) => {
  
  const { currentAssetItem } = this.state;
  if  (currentAssetItem.AutoPrice){
    const formatDate = currentAssetItem.TradeDate.split("-").join("");
    const result = await reqPrice(code,formatDate)
    if (result.status===0) {
      if  (result.data ===0){
        //message.error("価格取得に失敗しました。")  
      }
      currentAssetItem.Price = result.data
      this.setState({
        currentAssetItem,
        ...this.getTradeNumericDraftState(currentAssetItem, true),
      },()=>{this.recalculateTradeDraft()});
    }
  }  
}


  
getFxRate = async (tradeDate) => {  
  const { currentAssetItem } = this.state;
  if  (currentAssetItem.AutoFxRate){
    const formatDate = tradeDate.split("-").join("");
    const fxResult = await reqGetFXRate('usdjpy',formatDate)  
    if (fxResult.status===0) {
      if  (fxResult.data ===0){
        //message.error("為替レート取得に失敗しました。")  
      }
      currentAssetItem.FXRate = fxResult.data      
    }
  }
  this.setState({
    currentAssetItem,
    ...this.getTradeNumericDraftState(currentAssetItem, true),
  },()=>{this.recalculateTradeDraft()});
}

isDividendEditorItem = (item = this.state.currentAssetItem) => (
  String(item?.EventType || '').toUpperCase() === 'DIVIDEND'
)

buildDividendPreviewPayload = (item) => ({
  id: item?.id,
  New: item?.New,
  EventType: 'DIVIDEND',
  TradeDate: item?.TradeDate,
  TaxCategory: item?.TaxCategory,
  Memo: item?.DividendMemo ?? item?.Memo ?? '',
  Ccy: item?.DividendCcy ?? item?.Ccy,
  SettleCcy: item?.DividendSettleCcy ?? item?.SettleCcy,
  FXRate: item?.DividendFxRate ?? item?.FXRate,
  DividendQuantity: item?.DividendQuantity ?? 0,
  DividendExDate: item?.DividendExDate,
  DividendPerShare: item?.DividendPerShare,
})

syncDividendPreview = async (overrides = {}) => {
  const { currentAssetItem } = this.state;
  const draftItem = {
    ...currentAssetItem,
    ...overrides,
  };
  if (!this.isDividendEditorItem(draftItem)) {
    return;
  }

  const requestId = ++this.dividendPreviewRequestId;
  const previewResult = await reqPreviewDividend(this.buildDividendPreviewPayload(draftItem));
  if (requestId !== this.dividendPreviewRequestId || this.isUnmounted) {
    return;
  }
  if (previewResult.status !== 0) {
    message.error(previewResult?.data?.msg || '配当情報の取得に失敗しました');
    return;
  }

  this.setState((prevState) => ({
    currentAssetItem: {
      ...prevState.currentAssetItem,
      ...draftItem,
      ...(previewResult.data || {}),
      Changed: true,
    }
  }));
}

onDividendTaxCategoryChange = (value) => {
  const { currentAssetItem } = this.state;
  const nextItem = {
    ...currentAssetItem,
    TaxCategory: value,
    Changed: true,
  };
  this.setState({ currentAssetItem: nextItem }, () => {
    this.syncDividendPreview({ TaxCategory: value });
  });
}

onDividendTradeDateChange = (_, dateString) => {
  const { currentAssetItem } = this.state;
  const nextItem = {
    ...currentAssetItem,
    TradeDate: dateString,
    Changed: true,
  };
  this.setState({ currentAssetItem: nextItem }, () => {
    this.syncDividendPreview({ TradeDate: dateString });
  });
}

onDividendPerShareChange = (value) => {
  const { currentAssetItem } = this.state;
  const nextDividendPerShare = value ?? 0;
  this.setState({
    currentAssetItem: {
      ...currentAssetItem,
      DividendPerShare: nextDividendPerShare,
      Changed: true,
    }
  });
}

onDividendPerShareBlur = () => {
  const { currentAssetItem } = this.state;
  this.syncDividendPreview({ DividendPerShare: currentAssetItem?.DividendPerShare ?? 0 });
}

recalculateTradeDraft = ()=> {
  if (this.calcQuantityFromSettingAmount()) {
    return;
  }
  if (this.calcPriceOrFxRate()) {
    return;
  }
  this.calcSettlementAmount();
}

syncSettingAmountFromCashflow = (currentAssetItem) => {
  if (!currentAssetItem?.AutoAmount) {
    return;
  }
  const settlementAmount = Number(currentAssetItem.Amount ?? currentAssetItem.Cashflow ?? currentAssetItem['Notional'] ?? 0);
  currentAssetItem.SettingAmount = Number.isFinite(settlementAmount) ? settlementAmount : 0;
}

calcQuantityFromSettingAmount = ()=> {
  const { currentAssetItem } = this.state;
  const settingAmount = Number(currentAssetItem.SettingAmount ?? 0);
  if (!currentAssetItem.AutoQuantity || !Number.isFinite(settingAmount) || settingAmount <= 0 || currentAssetItem.Price === 0) {
    return false;
  }

  const navBaseUnits = getInstrumentNavBaseUnits(currentAssetItem);
  let quantity = settingAmount * navBaseUnits / currentAssetItem.Price;
  if (currentAssetItem.FXRate !== 0){
    if (currentAssetItem.Ccy === 'JPY' && currentAssetItem.SettleCcy === 'USD'){
      quantity = quantity * currentAssetItem.FXRate;
    } else if (currentAssetItem.Ccy === 'USD' && currentAssetItem.SettleCcy === 'JPY'){
      quantity = quantity / currentAssetItem.FXRate;
    }
  }

  const decimalPlaces = currentAssetItem.QuantityDecimalPlaces === '' ? 0 : currentAssetItem.QuantityDecimalPlaces;
  const factor = Math.pow(10, decimalPlaces);
  const maxSteps = Math.floor(quantity * factor + 1e-9);
  const adjustedSteps = Math.max(0, maxSteps - 1);
  const adjustedQuantity = adjustedSteps / factor;
  const fixed = Number(adjustedQuantity).toFixed(decimalPlaces);

  if (`${currentAssetItem.Quantity}` === fixed) {
    this.calcSettlementAmount();
    return true;
  }

  currentAssetItem.Quantity = fixed;
  this.setState({
    currentAssetItem,
    ...this.getTradeNumericDraftState(currentAssetItem, true),
  },()=>{this.calcSettlementAmount()});
  return true;
}
calcPriceOrFxRate= ()=> {  
  const { currentAssetItem } = this.state;
  if  (currentAssetItem.AutoQuantity && currentAssetItem.Price !==0){
      const cashflow = Number(currentAssetItem.Cashflow ?? currentAssetItem.Amount ?? currentAssetItem['Notional'] ?? 0);
      if (!Number.isFinite(cashflow) || cashflow <= 0) {
        return false;
      }
      const navBaseUnits = getInstrumentNavBaseUnits(currentAssetItem);
      let quantity = cashflow * navBaseUnits / currentAssetItem.Price;
      if  (currentAssetItem.FXRate !== 0){
        if  (currentAssetItem.Ccy === 'JPY' && currentAssetItem.SettleCcy === 'USD'){
          quantity = quantity * currentAssetItem.FXRate
        }else if  (currentAssetItem.Ccy === 'USD' && currentAssetItem.SettleCcy === 'JPY'){
          quantity = quantity / currentAssetItem.FXRate
        }
      }
      const fixed = Number(quantity).toFixed(currentAssetItem.QuantityDecimalPlaces===''?0:currentAssetItem.QuantityDecimalPlaces);
      currentAssetItem.Quantity = fixed
      this.setState({
        currentAssetItem,
        ...this.getTradeNumericDraftState(currentAssetItem, true),
      });
      return true;
  }

  if (currentAssetItem.AutoPrice && !currentAssetItem.AutoQuantity && !currentAssetItem.AutoNotional) {
      const quantity = Number(currentAssetItem.Quantity ?? 0);
      const cashflow = Number(currentAssetItem.Cashflow ?? currentAssetItem.Amount ?? currentAssetItem['Notional'] ?? 0);

      if (!Number.isFinite(quantity) || quantity <= 0 || !Number.isFinite(cashflow) || cashflow < 0) {
        return false;
      }

      let price = cashflow;
      if (currentAssetItem.FXRate !== 0){
        if  (currentAssetItem.Ccy === 'JPY' && currentAssetItem.SettleCcy === 'USD'){
          price = price * currentAssetItem.FXRate
        }else if  (currentAssetItem.Ccy === 'USD' && currentAssetItem.SettleCcy === 'JPY'){
          price = price / currentAssetItem.FXRate
        }
      }
      price = price * getInstrumentNavBaseUnits(currentAssetItem) / quantity;
      if (!Number.isFinite(price)) {
        return false;
      }

      currentAssetItem.Price = price;
      this.setState({
        currentAssetItem,
        ...this.getTradeNumericDraftState(currentAssetItem, true),
      });
      return true;
  }
  return false;
}

// 20251231 UEDA Settlement amount (gross, unsigned).
// Calculated from Quantity × Price with FX conversion.
// Cashflow is still used as display / legacy field.
calcSettlementAmount = ()=> {  
  const { currentAssetItem } = this.state;
  if  (currentAssetItem.AutoNotional || this.shouldInitializeSettlementAmount(currentAssetItem)){
    const navBaseUnits = getInstrumentNavBaseUnits(currentAssetItem);
    let settlementAmount = currentAssetItem.Quantity * currentAssetItem.Price / navBaseUnits;
    if  (currentAssetItem.FXRate !== 0){
      if  (currentAssetItem.Ccy === 'JPY' && currentAssetItem.SettleCcy === 'USD'){
        settlementAmount = settlementAmount / currentAssetItem.FXRate
      }else if  (currentAssetItem.Ccy === 'USD' && currentAssetItem.SettleCcy === 'JPY'){
        settlementAmount = settlementAmount * currentAssetItem.FXRate
      }
    }
    currentAssetItem.Amount = settlementAmount
    currentAssetItem.Cashflow = settlementAmount
    currentAssetItem['Notional'] = currentAssetItem.Cashflow // legacy alias
    this.syncSettingAmountFromCashflow(currentAssetItem);
    this.setState({
      currentAssetItem,
      ...this.getTradeNumericDraftState(currentAssetItem, true),
      settingAmountDraft: this.formatSettingAmountDraft(currentAssetItem.SettingAmount),
    });
  }
  
}
handleLinkClick = (e) => {
  e.stopPropagation();
};

renderAssetClassificationEvidence = (item) => {
  const evidence = item.AssetClassificationEvidence;
  if (typeof evidence?.reason !== 'string' || !evidence.reason.trim()) return null;

  const officialURLs = (evidence.official_urls || []).filter(
    (url) => typeof url === 'string' && /^https?:\/\//i.test(url)
  );
  return (
    <span onClick={this.handleLinkClick}>
      <Popover
        trigger="click"
        title="資産区分の判定根拠"
        zIndex={3100}
        content={
          <div style={{maxWidth:'min(420px, calc(100vw - 64px))', maxHeight:'60vh', overflowY:'auto', overflowWrap:'anywhere'}} onClick={this.handleLinkClick}>
            <div><strong>資産区分：</strong>{item.Asset}（{evidence.asset_en}）</div>
            <div><strong>判定状態：</strong>{evidence.status || '—'}</div>
            <div><strong>理由コード：</strong>{evidence.reason_code || '—'}</div>
            <div><strong>判定理由：</strong></div>
            <div style={{whiteSpace:'pre-wrap'}}>{evidence.reason}</div>
            {officialURLs.length > 0 && (
              <div style={{marginTop:8}}>
                <strong>参照資料URL：</strong>
                {officialURLs.map((url) => (
                  <div key={url}>
                    <a href={url} target="_blank" rel="noopener noreferrer" onClick={this.handleLinkClick}>{url}</a>
                  </div>
                ))}
              </div>
            )}
            <div style={{marginTop:8}}>
              <strong>レビュー日時：</strong>
              <time dateTime={evidence.reviewed_at}>{moment(evidence.reviewed_at).format('YYYY-MM-DD HH:mm:ss Z')}</time>
            </div>
          </div>
        }
      >
        <button type="button" className="val-setting-help-icon-button" aria-label={`${item.Asset}の判定根拠を表示`} style={{marginLeft:4}} onClick={this.handleLinkClick}>
          <QuestionCircleOutlined style={{color:'#1677ff', fontSize:14}} />
        </button>
      </Popover>
    </span>
  );
};

toggleValSettingHelp = (helpKey, event) => {
  event?.stopPropagation();
  this.setState((prevState) => ({
    openValSettingHelpKey: prevState.openValSettingHelpKey === helpKey ? '' : helpKey,
  }));
};

renderValSettingHelpContent = (helpKey, content) => (
  this.state.openValSettingHelpKey === helpKey ? (
    <div className='portfolio-section-accordion-content val-setting-help-content'>
      {content}
    </div>
  ) : null
);

renderSearchHeaderHelpIcon = (helpKey) => {
  const isOpen = this.state.openValSettingHelpKey === helpKey;

  return (
    <button
      type="button"
      className="val-setting-help-icon-button"
      aria-label="説明を表示"
      aria-expanded={isOpen}
      onClick={(event) => this.toggleValSettingHelp(helpKey, event)}
    >
      <QuestionCircleOutlined style={{ color: '#1677ff', fontSize: 14 }} />
    </button>
  );
};

renderValSettingHelpIcon = (helpKey) => {
  const isOpen = this.state.openValSettingHelpKey === helpKey;

  return (
    <button
      type='button'
      className='val-setting-help-icon-button'
      aria-expanded={isOpen}
      onClick={(event) => this.toggleValSettingHelp(helpKey, event)}
    >
      <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 14, marginLeft: 5 }} />
    </button>
  );
};

loadUserAccounts = async (userId = this.state.userId) => {
  if (!userId) return [];
  const result = await reqGetUserAccounts(userId);
  if (!result || result.status !== 0) {
    message.error(result?.data?.msg || '口座一覧の取得に失敗しました');
    return [];
  }
  const userAccounts = result.data || [];
  await new Promise((resolve) => {
    this.setState({ userAccounts }, resolve);
  });
  return userAccounts;
};

getDefaultUserAccount = (accounts = this.state.userAccounts) => (
  accounts.find((account) => account.isDefault) || null
);

onTradeAccountChange = (accountId) => {
  const account = this.state.userAccounts.find((item) => item.id === accountId);
  this.onAssetItemChange(account?.displayName || null, 'Account');
  this.onAssetItemChange(account?.id || null, 'AccountId');
};

openAccountManager = async () => {
  const { userId } = this.state;
  const [accountsResult, institutionsResult] = await Promise.all([
    reqGetManagedUserAccounts(userId),
    reqGetFinancialInstitutions(),
  ]);
  if (accountsResult.status !== 0 || institutionsResult.status !== 0) {
    message.error('口座管理情報の取得に失敗しました');
    return;
  }
  this.setState({
    accountManagerVisible:true,
    userAccounts: (accountsResult.data || []).filter((account) => account.isActive),
    managedUserAccounts: accountsResult.data || [],
    financialInstitutions: institutionsResult.data || [],
    accountDraft:null,
  });
};

getFinancialInstitutionDisplayName = (name = '') => (
  String(name)
    .normalize('NFKC')
    .replace(/^株式会社/, '')
    .replace(/株式会社$/, '')
    .trim()
);

normalizeFinancialInstitutionSearchText = (value = '') => (
  String(value)
    .normalize('NFKC')
    .toLowerCase()
    .replace(/\s+/g, '')
);

startNewAccount = () => {
  const firstInstitution = this.state.financialInstitutions[0];
  this.setState({
    accountDraft: {
      financialInstitutionId: firstInstitution?.id,
      displayName: this.getFinancialInstitutionDisplayName(firstInstitution?.name),
      isDefault: this.state.userAccounts.length === 0,
      isActive: true,
    },
  });
};

saveManagedAccount = async () => {
  const { accountDraft, userId } = this.state;
  if (!accountDraft?.financialInstitutionId) {
    message.warning('金融機関を選択してください');
    return;
  }
  const result = await reqSaveUserAccount({ ...accountDraft, UserId: userId });
  if (result.status !== 0) {
    message.error(result?.data?.msg || '口座の保存に失敗しました');
    return;
  }
  const managedResult = await reqGetManagedUserAccounts(userId);
  const managedUserAccounts = managedResult.status === 0 ? managedResult.data || [] : this.state.managedUserAccounts;
  const userAccounts = managedUserAccounts.filter((account) => account.isActive);
  const currentAssetItem = { ...this.state.currentAssetItem };
  if (currentAssetItem.New && result.data?.isDefault) {
    currentAssetItem.AccountId = result.data.id;
    currentAssetItem.Account = result.data.displayName;
  }
  this.setState({ userAccounts, managedUserAccounts, currentAssetItem, accountDraft:null });
};



handleClickAssetEdit = (item) => {
  const { userId, activeTab } = this.state;

  // 参照コピーではなく、必ずコピーして編集する
  let tmpAsset = { ...item };

  tmpAsset.UserId = userId;
  tmpAsset.Portfolio = activeTab;

  tmpAsset.TaxCategory = tmpAsset.TaxCategory ?? '1';
  tmpAsset.TradeDate = tmpAsset.TradeDate ?? DateTimeToString(new Date());
  tmpAsset.PorS = tmpAsset.PorS ?? 1;

  // 既存値を潰さない
  tmpAsset.Quantity = tmpAsset.Quantity ?? 100;
  tmpAsset.Ccy = tmpAsset.Ccy ?? item.Ccy;
  tmpAsset.Price = tmpAsset.Price ?? 0;
  tmpAsset.PriceEnabled = tmpAsset.PriceEnabled ?? false;
  tmpAsset.FXRate = tmpAsset.FXRate ?? 0;
  tmpAsset.FxRateEnabled = tmpAsset.FxRateEnabled ?? false;

  tmpAsset.New = true;
  tmpAsset.SettleCcy = tmpAsset.SettleCcy ?? 'JPY';
  tmpAsset.AutoSettleCcy = tmpAsset.AutoSettleCcy ?? true;
  tmpAsset.AutoQuantity = tmpAsset.AutoQuantity ?? true;
  tmpAsset.AutoPrice = tmpAsset.AutoPrice ?? true;
  tmpAsset.AutoFxRate = tmpAsset.AutoFxRate ?? true;
  tmpAsset.AutoNotional = tmpAsset.AutoNotional ?? true;
  tmpAsset.AutoAmount = tmpAsset.AutoAmount ?? false;

  // Cashflow normalize。ただし既存値を後で 0 に潰さない
  tmpAsset.Cashflow = tmpAsset.Amount ?? tmpAsset.Cashflow ?? tmpAsset['Notional'] ?? 0;
  tmpAsset.Amount = tmpAsset.Cashflow;
  tmpAsset['Notional'] = tmpAsset.Cashflow;

  tmpAsset.AutoPlan = tmpAsset.AutoPlan ?? false;
  tmpAsset.LastDateFlg = tmpAsset.LastDateFlg ?? false;
  tmpAsset.LastPlanDate = tmpAsset.LastPlanDate ?? DateTimeToString(AddMonths(new Date(), 60));
  const defaultAccount = this.getDefaultUserAccount();
  tmpAsset.AccountId = tmpAsset.AccountId ?? defaultAccount?.id ?? null;
  tmpAsset.Account = tmpAsset.Account ?? defaultAccount?.displayName ?? null;

  tmpAsset.SettingAmount = tmpAsset.SettingAmount ?? 0;
  tmpAsset.Title = tmpAsset.Title ?? item.Asset;
  tmpAsset.SubCode = tmpAsset.SubCode ?? removeTFromCode(item.Code);
  tmpAsset.SubTitle = tmpAsset.SubTitle ?? item.Name;
  tmpAsset.Changed = false;

  // 重要：Memo を空文字で潰さない
  // tmpAsset.Memo = tmpAsset.Memo ?? '';
  // 新規約定では instruments.Memo を引き継がない
  tmpAsset.Memo = '';

  tmpAsset.URL = resolvePortInstrumentUrl(tmpAsset);

  console.log("tmpAsset before setState", tmpAsset);

  this.setState({
    assetEditVisible: true,
    currentAssetItem: tmpAsset,
    ...this.getTradeNumericDraftState(tmpAsset, false),
    settingAmountDraft: this.formatSettingAmountDraft(tmpAsset.SettingAmount),
    settingAmountSnapshot: null,
    assetNumericFieldInFocus: null,
  }, () => {
    this.getStockPrice(item.Code);
    this.getFxRate(tmpAsset.TradeDate);
  });
};



  handleClickAssetDelete = async(deleteScope = 'single') => {
    const { currentAssetItem } = this.state;
     this.setState({ 
        loading:true,
        assetEditVisible:false,
        searchVisible:false,
      });
    const delResult = await reqDelTransaction(currentAssetItem.id, deleteScope)
    if (delResult.status !== 0) {
      this.setState({ loading:false });
      message.error(delResult?.data?.msg || '削除に失敗しました');
      return;
    }
    await this.GetPortfolio(this.state.activeTab)
    this.setState({
      currentAssetItem:{},
      loading:false,
    });
  }

  sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  waitForPlanJob = async (tranId) => {
    if (!tranId) {
      return true;
    }
    const toastKey = `plan-job-${tranId}`;
    message.loading({ content: '毎月約定作成中', key: toastKey, duration: 0 });
    const maxPollCount = 120; // 2 sec x 120 = 4 min
    for (let i = 0; i < maxPollCount; i++) {
      if (this.isUnmounted) {
        return false;
      }
      const statusResult = await reqGetTransactionPlanStatus(tranId);
      if (statusResult.status === 0 && statusResult.data) {
        const status = `${statusResult.data.status || ''}`.toLowerCase();
        if (status === 'done') {
          message.success({ content: '毎月約定完了', key: toastKey, duration: 2 });
          return true;
        }
        if (status === 'failed') {
          const msg = statusResult.data.message ? `毎月約定作成失敗: ${statusResult.data.message}` : '毎月約定作成失敗';
          message.error({ content: msg, key: toastKey, duration: 4 });
          return false;
        }
      }
      await this.sleep(2000);
    }
    message.warning({ content: '毎月約定作成は継続中です。しばらくして再読み込みしてください。', key: toastKey, duration: 4 });
    return false;
  }
  
  handleClickAssetEditApply = async(updateScope = 'single') => {
    const { currentAssetItem } = this.state;
    const effectiveUpdateScope =
      currentAssetItem.RecurringEndDateChanged ? 'all' : updateScope;
      if (!currentAssetItem.New && !currentAssetItem.Changed) {
message.warning('変更がありません');
return;
}
      this.setState({ 
        loading:true,
      });

    // Send both Cashflow (new) and Notional (legacy) for compatibility
    const payload = {
      ...currentAssetItem,
      Amount: (currentAssetItem.Amount ?? currentAssetItem.Cashflow ?? currentAssetItem['Notional'] ?? 0),
      Cashflow: (currentAssetItem.Amount ?? currentAssetItem.Cashflow ?? currentAssetItem['Notional'] ?? 0),
      Notional: (currentAssetItem.Amount ?? currentAssetItem.Cashflow ?? currentAssetItem['Notional'] ?? 0),
      AutoAmount: (currentAssetItem.AutoAmount ?? currentAssetItem.AutoNotional),
      UpdateScope: effectiveUpdateScope,
    };
    const updateResult = await reqUpdateTransaction(payload);
    if (updateResult.status !== 0) {
      this.setState({ loading: false });
      message.error(updateResult?.data?.msg || '更新に失敗しました');
      return;
    }
    const updateData = updateResult.data || {};

    this.setState({
        assetEditVisible:false,
        searchVisible:false,
        loading:false,
    });

    if (updateData?.planJob?.status && updateData.planJob.status !== 'done') {
      await this.waitForPlanJob(updateData.tranId || updateData.planJob.tranId);
    }

    await this.GetPortfolio(this.state.activeTab)
    this.setState({ 
      assetAddFlag:currentAssetItem.New?true:false,
      currentAssetItem:{},
      loading:false,
      quantityDraft:'',
      priceDraft:'',
      fxRateDraft:'',
      cashflowDraft:'',
      assetNumericFieldInFocus:null,
    });
  }
  getRecurringUpdateMenu = () => {
    const restrictToAll = Boolean(this.state.currentAssetItem?.RecurringEndDateChanged);

    return (
      <Menu onClick={({ key }) => this.handleClickAssetEditApply(key)}>
        <Menu.Item key="single" disabled={restrictToAll}>本約定のみ更新</Menu.Item>
        <Menu.Item key="forward" disabled={restrictToAll}>本約定とその後</Menu.Item>
        <Menu.Item key="all">過去も含む全て</Menu.Item>
      </Menu>
    );
  }

  getDeleteScopeMenuItems = (item = this.state.currentAssetItem) => {
    if (this.isDividendEditorItem(item)) {
      return [
        { key: 'single', label: '本配当のみ削除' },
        { key: 'forward', label: '本配当とその後の配当を削除' },
        { key: 'all', label: '過去も含むすべての配当を削除' },
      ];
    }

    return [
      { key: 'single', label: '本約定のみ削除' },
      { key: 'forward', label: '本約定とその後' },
      { key: 'all', label: '過去も含むすべて' },
    ];
  }

  supportsScopedDeleteSelection = (item = this.state.currentAssetItem) => {
    if (!item || item.New) {
      return false;
    }
    if (this.isDividendEditorItem(item)) {
      return true;
    }
    return !!(item.TranId && item.TranId.length > 0);
  }

  getRecurringDeleteMenu = (item = this.state.currentAssetItem) => (
    <Menu onClick={({ key }) => this.handleClickAssetDelete(key)}>
      {this.getDeleteScopeMenuItems(item).map((menuItem) => (
        <Menu.Item key={menuItem.key}>{menuItem.label}</Menu.Item>
      ))}
    </Menu>
  )
  handleClickAssetEditCancel = (item) => {

    this.setState({ 
      assetEditVisible:false,
      currentAssetItem:{},
      settingAmountDraft:'',
      settingAmountSnapshot:null,
      quantityDraft:'',
      priceDraft:'',
      fxRateDraft:'',
      cashflowDraft:'',
      assetNumericFieldInFocus:null,
    });

  }
  
  handleClickSearchFinish = () => {
    ++this.assetSearchRequestId;
    this.assetSearchKeyword = "";
    const { assetAddFlag } = this.state;

    this.setState({
      searchVisible:false,
      searchValue:'',
      searchResult: [],
      assetSearchTotal: 0,
      assetSearchPage: 1,
      assetSearchPerformed:false,
      assetETFDataStatus:'idle',
      assetETFDataError:'',
      }, () => {
        if  (assetAddFlag){
          this.GetPortfolio(this.state.activeTab)
        }
        

    });
  }

  onSelectTaxCategory= (value) => {
    const { currentAssetItem} = this.state;
    currentAssetItem.TaxCategory = value;
    currentAssetItem.Changed = true;
    this.setState({
      currentAssetItem
    });
  };
  toHalfWidth= (v) => {
    return v.replace(/[０-９．]/g, (s) => (s === '．' ? '.' : String.fromCharCode(s.charCodeAt(0) - 0xFEE0)));
  }

  normalizeNumericInput = (value) => {
    if (value === '' || value === undefined || value === null) return '';
    return String(value)
      .replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
      .replace(/[，,]/g, '')
      .replace(/[．]/g, '.');
  }

  formatSettingAmountDraft = (value) => {
    return numFormat(value ?? 0);
  }

  formatGroupedNumericString = (value) => {
    const normalized = this.normalizeNumericInput(value);
    if (normalized === '') return '';
    const sign = normalized.startsWith('-') ? '-' : '';
    const unsigned = sign ? normalized.slice(1) : normalized;
    const [intPart, decimalPart] = unsigned.split('.');
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalPart !== undefined ? `${sign}${formattedInt}.${decimalPart}` : `${sign}${formattedInt}`;
  }

  getTradeFieldDraftName = (fieldName) => ({
    Quantity: 'quantityDraft',
    Price: 'priceDraft',
    FXRate: 'fxRateDraft',
    Cashflow: 'cashflowDraft',
  }[fieldName] ?? '')

  getTradeFieldValue = (currentAssetItem, fieldName) => (
    fieldName === 'Cashflow'
      ? (currentAssetItem?.Cashflow ?? currentAssetItem?.Amount ?? currentAssetItem?.['Notional'] ?? 0)
      : currentAssetItem?.[fieldName]
  )

  formatTradeFieldDraft = (fieldName, value = this.getTradeFieldValue(this.state.currentAssetItem, fieldName)) => {
    if (value === '' || value === undefined || value === null) return '';
    return this.formatGroupedNumericString(value);
  }

  getTradeNumericDraftState = (currentAssetItem = this.state.currentAssetItem, preserveFocused = true) => {
    const focusedField = preserveFocused ? this.state.assetNumericFieldInFocus : null;
    const nextState = {};
    ['Quantity', 'Price', 'FXRate', 'Cashflow'].forEach((fieldName) => {
      const draftName = this.getTradeFieldDraftName(fieldName);
      nextState[draftName] = focusedField === fieldName
        ? this.state[draftName]
        : this.formatTradeFieldDraft(fieldName, this.getTradeFieldValue(currentAssetItem, fieldName));
    });
    return nextState;
  }

  getTradeFieldEditableValue = (fieldName, currentAssetItem = this.state.currentAssetItem) => {
    const value = this.getTradeFieldValue(currentAssetItem, fieldName);
    if (value === '' || value === undefined || value === null) return '';
    return this.normalizeNumericInput(String(value));
  }

  normalizeTradeFieldBlurValue = (fieldName, normalizedValue, currentAssetItem = this.state.currentAssetItem) => {
    const numericValue = Number(normalizedValue);
    if (!Number.isFinite(numericValue)) {
      return null;
    }

    if (fieldName === 'Quantity') {
      const decimalPlaces = currentAssetItem.QuantityDecimalPlaces === '' ? 0 : Number(currentAssetItem.QuantityDecimalPlaces ?? 0);
      const factor = Math.pow(10, decimalPlaces);
      return Math.floor(numericValue * factor) / factor;
    }

    if (fieldName === 'FXRate') {
      return Number(numericValue.toFixed(2));
    }

    if (fieldName === 'Cashflow') {
      const precision = currentAssetItem.SettleCcy === 'USD' ? 2 : 0;
      return Number(numericValue.toFixed(precision));
    }

    return numericValue;
  }

  applyAssetItemFieldChange = (currentAssetItem, value, fieldName) => {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return false;
    }
    if  (fieldName ==='Quantity' &&  currentAssetItem.QuantityDecimalPlaces >0){
      const factor = Math.pow(10, currentAssetItem.QuantityDecimalPlaces);
      value = Math.floor(value * factor) / factor;        
    }
    currentAssetItem[fieldName] = value;
    currentAssetItem.Changed = true;
    if (fieldName === 'Cashflow') {
      currentAssetItem.Amount = value;
      currentAssetItem['Notional'] = value;
      currentAssetItem.AutoAmount = true;
      this.syncSettingAmountFromCashflow(currentAssetItem);
    }
    return true;
  }

  onTradeFieldFocus = (fieldName) => {
    const draftName = this.getTradeFieldDraftName(fieldName);
    this.setState({
      assetNumericFieldInFocus: fieldName,
      [draftName]: this.getTradeFieldEditableValue(fieldName),
    });
  }

  onTradeFieldDraftChange = (fieldName, e) => {
    const draftName = this.getTradeFieldDraftName(fieldName);
    this.setState({ [draftName]: e.target.value });
  }

  onTradeFieldBlur = (fieldName) => {
    const { currentAssetItem } = this.state;
    const draftName = this.getTradeFieldDraftName(fieldName);
    const normalized = this.normalizeNumericInput(this.state[draftName]);

    if (normalized === '') {
      this.setState({
        assetNumericFieldInFocus: null,
        ...this.getTradeNumericDraftState(currentAssetItem, false),
      });
      return;
    }

    const nextValue = this.normalizeTradeFieldBlurValue(fieldName, normalized, currentAssetItem);
    if (nextValue === null || !this.applyAssetItemFieldChange(currentAssetItem, nextValue, fieldName)) {
      this.setState({
        assetNumericFieldInFocus: null,
        ...this.getTradeNumericDraftState(currentAssetItem, false),
      });
      return;
    }

    this.setState({
      currentAssetItem,
      assetNumericFieldInFocus: null,
      ...this.getTradeNumericDraftState(currentAssetItem, false),
      settingAmountDraft: fieldName === 'Cashflow'
        ? this.formatSettingAmountDraft(currentAssetItem.SettingAmount)
        : this.state.settingAmountDraft,
    },()=>{
      if  (fieldName ==='Cashflow'){
        this.calcPriceOrFxRate()
      }else{
        this.recalculateTradeDraft()
      }
    });
  }


  onAssetItemChange= (value,fieldName) => {
    const { currentAssetItem} = this.state;
    if (this.applyAssetItemFieldChange(currentAssetItem, value, fieldName)) {
      this.setState({
        currentAssetItem,
        ...this.getTradeNumericDraftState(currentAssetItem, true),
        settingAmountDraft: fieldName === 'Cashflow'
          ? this.formatSettingAmountDraft(currentAssetItem.SettingAmount)
          : this.state.settingAmountDraft
      },()=>{
        if  (fieldName ==='Cashflow'){
          this.calcPriceOrFxRate()
        }else{
          if  (fieldName ==='Quantity' || 
            fieldName ==='Price'  || 
            fieldName ==='SettleCcy'  || 
            fieldName ==='FXRate' ){
              this.recalculateTradeDraft()
            }
        }
      });
    }

  };

  onSettingAmountBlur = () => {
    const { currentAssetItem, settingAmountSnapshot, settingAmountDraft } = this.state;
    const normalized = this.normalizeNumericInput(settingAmountDraft);
    const settingAmount = Number(normalized);
    const enabled = Number.isFinite(settingAmount) && settingAmount > 0;

    // Guard: avoid destructive zeroing while user is editing/replacing values.
    // If finalized value is non-positive, restore previous draft snapshot.
    if (!enabled) {
      if (settingAmountSnapshot) {
        const restored = {
          ...currentAssetItem,
          SettingAmount: settingAmountSnapshot.SettingAmount,
          Quantity: settingAmountSnapshot.Quantity,
          Amount: settingAmountSnapshot.Amount,
          Cashflow: settingAmountSnapshot.Cashflow,
          Notional: settingAmountSnapshot.Cashflow,
          AutoQuantity: settingAmountSnapshot.AutoQuantity,
          AutoNotional: settingAmountSnapshot.AutoNotional,
          AutoAmount: settingAmountSnapshot.AutoAmount,
        };
        this.setState({
          currentAssetItem: restored,
          ...this.getTradeNumericDraftState(restored, false),
          settingAmountSnapshot: null,
          settingAmountDraft: this.formatSettingAmountDraft(settingAmountSnapshot.SettingAmount),
        });
      } else {
        this.setState({
          ...this.getTradeNumericDraftState(currentAssetItem, false),
          settingAmountSnapshot: null,
          settingAmountDraft: this.formatSettingAmountDraft(currentAssetItem.SettingAmount),
        });
      }
      return;
    }

    currentAssetItem.SettingAmount = settingAmount;
    currentAssetItem.AutoAmount = false;
    currentAssetItem.AutoQuantity = true;
    currentAssetItem.AutoNotional = true;
    currentAssetItem.Changed = true;
    this.setState({
      currentAssetItem,
      settingAmountSnapshot: null,
      settingAmountDraft: this.formatSettingAmountDraft(settingAmount),
    }, () => {
      this.recalculateTradeDraft();
    });
  };

  onSettingAmountFocus = () => {
    const { currentAssetItem } = this.state;
    this.setState({
      settingAmountDraft: `${currentAssetItem.SettingAmount ?? ''}`,
      settingAmountSnapshot: {
        SettingAmount: currentAssetItem.SettingAmount,
        Quantity: currentAssetItem.Quantity,
        Amount: currentAssetItem.Amount ?? currentAssetItem.Cashflow ?? currentAssetItem['Notional'] ?? 0,
        Cashflow: currentAssetItem.Cashflow ?? currentAssetItem.Amount ?? currentAssetItem['Notional'] ?? 0,
        AutoQuantity: currentAssetItem.AutoQuantity,
        AutoNotional: currentAssetItem.AutoNotional,
        AutoAmount: currentAssetItem.AutoAmount,
      }
    });
  };

  onSettingAmountDraftChange = (e) => {
    this.setState({ settingAmountDraft: e.target.value });
  };
  
  onChangeTradeDate= (date, dateString) => {
    const { currentAssetItem} = this.state;
    currentAssetItem.TradeDate = dateString;
    currentAssetItem.Changed = true;
    
    this.setState({
      currentAssetItem
    },()=>{      
      this.getStockPrice(currentAssetItem.Code)
      this.getFxRate(currentAssetItem.TradeDate)
    });
    
  };

  onChangeLastDateFlg = (value) => {
    const { currentAssetItem } = this.state;

    currentAssetItem.LastDateFlg = value;
    currentAssetItem.Changed = true;
    currentAssetItem.RecurringEndDateChanged = true;

    if (value) {
      const lastPlanDate = currentAssetItem.LastPlanDate;
      const isUnset =
        !lastPlanDate ||
        lastPlanDate === '1970-01-01' ||
        !moment(lastPlanDate, 'YYYY-MM-DD', true).isValid();

      if (isUnset) {
        currentAssetItem.LastPlanDate = DateTimeToString(new Date());
      }
    }

    this.setState({
      currentAssetItem
    });
  };

  onChangeLastPlanDate= (date, dateString) => {
    const { currentAssetItem} = this.state;
    currentAssetItem.LastPlanDate = dateString;
    currentAssetItem.Changed = true;
    currentAssetItem.RecurringEndDateChanged = true;
    this.setState({
      currentAssetItem
    });
    
  };

  onChangePorS= (event) => {
    const { currentAssetItem} = this.state;
    if  (event!==null ){
      let value = event.target.value
      currentAssetItem.PorS = value;
      currentAssetItem.Changed = true;
      this.setState({
        currentAssetItem
      });
    }
    
  };
  
  onChangeEnabled= (value,name) => {
    const { currentAssetItem} = this.state;
    currentAssetItem[name] = !currentAssetItem[name];
    if  (name ==='AutoSettleCcy' && currentAssetItem[name]){
      currentAssetItem.SettleCcy = currentAssetItem.Ccy;
    }else if  (name ==='AutoPrice' && currentAssetItem[name]){
      this.getStockPrice(currentAssetItem.Code)
    }else if  (name ==='AutoFxRate' && currentAssetItem[name]){
      this.getFxRate(currentAssetItem.TradeDate)
    }else if  (name ==='AutoAmount' && currentAssetItem[name]){
      this.syncSettingAmountFromCashflow(currentAssetItem);
    }
    
    currentAssetItem.Changed = true;
    this.setState({
      currentAssetItem,
      ...this.getTradeNumericDraftState(currentAssetItem, true),
      settingAmountDraft: name === 'AutoAmount' && currentAssetItem[name]
        ? this.formatSettingAmountDraft(currentAssetItem.SettingAmount)
        : this.state.settingAmountDraft
    },()=>{this.recalculateTradeDraft()});
  };

  handleNumberPaste = (e,name) => {
    const { currentAssetItem} = this.state;
    if ((name==='Cashflow' && currentAssetItem.AutoNotional) ||
        (name==='Price' && currentAssetItem.AutoPrice)){
        return;
    }
    e.preventDefault();
    e.target.value = '';
    const clipboard = e.clipboardData.getData("text");
    const normalized = clipboard.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 65248)).replace(/[，,]/g, "").replace(/[．]/g, ".");
    
    const num = parseFloat(normalized);
    if (!isNaN(num)) {
      this.onAssetItemChange(num, name);
    }
  };

  handleCashTransactionMemoPaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text').replace(/[\r\n]+$/, '');
    const target = e.target;
    const selectionStart = target.selectionStart ?? 0;
    const selectionEnd = target.selectionEnd ?? selectionStart;
    const currentValue = this.state.cashTransactionMemo || '';
    const nextValue =
      currentValue.slice(0, selectionStart) +
      pastedText +
      currentValue.slice(selectionEnd);

    this.setState({ cashTransactionMemo: nextValue }, () => {
      const caretPosition = selectionStart + pastedText.length;
      if (typeof target.setSelectionRange === 'function') {
        target.setSelectionRange(caretPosition, caretPosition);
      }
    });
  };

  retryAssetETFData = async () => {
    await this.searchAssetETFData(this.assetSearchKeyword || this.state.searchValue, this.state.assetSearchPage);
  };

  handleSearchAsset = (event) => {
    if  (event!==null ){
      ++this.assetSearchRequestId;
      this.assetSearchKeyword = "";
      const value1 = event.target.value;
      this.setState({
        searchValue:value1,
        searchResult: [],
        assetSearchTotal: 0,
        assetSearchPage: 1,
        assetSearchPerformed:false,
        assetSearchSortOrder: '', assetSearchSortField: 'asset',
        assetETFDataError:'',
        assetETFDataStatus:'idle',
      });
    }
  };

  handleSearchAssetSubmit = async () => {
    await this.searchAssetETFData(this.state.searchValue);
  };
  
  handleRowClick = async (record) => {
    // if (clickTimer) {
    //   clearTimeout(clickTimer);
    //   clickTimer = null;
    //   if (record.PorS !== undefined) {
    //     let tmpAsset = {
    //       ...record,
    //       AutoPrice: false,
    //       AutoFxRate: false,
    //       New : false,
    //       Title : record.Asset1 + ' ' + removeTFromCode(record.Code)  + ' ' +  record.Name,
    //       Changed : false,
    //       TradeDate : record.Asset
    //     }
    //     this.setState({ 
    //       assetEditVisible:true,
    //       currentAssetItem:tmpAsset
    //     });
    //   }
    // } else {
    //   clickTimer = setTimeout(() => {
    //     clickTimer = null;
    //   }, 300);
    // }

    if (!record || record?.Folder !== 9) {
      return;
    }

    if (
      record?.CashAccount &&
      record?.Folder === 9 &&
      ['DEPOSIT', 'WITHDRAWAL'].includes(String(record?.EventType || '').toUpperCase())
    ) {
      const cashInstrumentInfo = this.getCashTransactionInstrumentInfo(record);
      this.setState({
        loading: true,
        cashTransactionInstrumentCode: cashInstrumentInfo.Code,
        cashTransactionInstrumentAsset: cashInstrumentInfo.Asset,
        cashTransactionInstrumentName: cashInstrumentInfo.Name,
      });
      const result = await reqGetPortfolio(record.Id);
      if (result.status === 0) {
        const data = result.data || {};
        const eventType = String(data.EventType || 'DEPOSIT').toUpperCase();
        this.setState({
          cashModalVisible: true,
          cashTransactionId: data.id,
          cashTransactionIsNew: false,
          cashTransactionType: eventType === 'WITHDRAWAL' ? 'WITHDRAWAL' : 'DEPOSIT',
          cashTransactionAmount: this.normalizeCashTransactionAmount(data.Amount ?? data.Cashflow ?? data.Notional ?? ''),
          cashTransactionAmountFocused: false,
          cashTransactionDate: DateTimeToString(new Date(data.TradeDate)),
          cashTransactionMemo: data.Memo || '',
          cashTransactionAccountId: data.AccountId ?? null,
          cashTransactionAccount: data.Account ?? null,
          loading: false,
        });
      } else {
        this.setState({ loading: false });
        message.error(result?.data?.msg || '入出金データの取得に失敗しました');
      }
      return;
    }

    if (record.Folder === 9) {
      this.setState({ 
        loading:true,
      });
        const result = await reqGetPortfolio(record.Id)
        if (result.status===0) {
          let QuantityDecimalPlaces = 0;
          let NavBaseUnits = 1;
          let Provider=""
          let ExchangeTypeEn=""
          let URL=""
          const etf = await this.fetchAssetETFDataByCode(record.Code);
          if (etf) {
            QuantityDecimalPlaces = etf.QuantityDecimalPlaces
            NavBaseUnits = getInstrumentNavBaseUnits(etf)
            Provider = etf.Provider
            ExchangeTypeEn = etf.ExchangeTypeEn
            URL = resolvePortInstrumentUrl(etf)
          }

          console.log('etf',etf)
          console.log('URL',URL)
          let tmpAsset = {
            ...result.data,
            QuantityDecimalPlaces,
            NavBaseUnits,
            Provider,
            ExchangeTypeEn,
            New : false,
            SubCode :  removeTFromCode(record.Code),
            Title : record.Asset1,
            SubTitle : record.Name,
            Changed : false,
            TradeDate : DateTimeToString(new Date(result.data.TradeDate)),
            LastPlanDate : DateTimeToString(new Date(result.data.LastPlanDate)),
            URL
          }

          // Normalize Amount/Cashflow/Notional for the editor state.
          tmpAsset.Cashflow = (tmpAsset.Amount ?? tmpAsset.Cashflow ?? tmpAsset['Notional'] ?? 0);
          tmpAsset.Amount = tmpAsset.Cashflow;
          tmpAsset.AutoAmount = (tmpAsset.AutoAmount ?? tmpAsset.AutoNotional);
          tmpAsset['Notional'] = tmpAsset.Cashflow;
          tmpAsset.SettingAmount = (tmpAsset.SettingAmount ?? 0);
          tmpAsset.TaxCategory = String(tmpAsset.TaxCategory ?? '1');
          // Child recurring rows still have AutoPlan=false in DB.
          // For editor display, treat rows with TranId as recurring.
          tmpAsset.AutoPlan = !!(tmpAsset.AutoPlan || (tmpAsset.TranId && tmpAsset.TranId.length > 0));
          console.log(tmpAsset)
          this.setState({ 
            assetEditVisible:true,
            currentAssetItem:tmpAsset,
            ...this.getTradeNumericDraftState(tmpAsset, false),
            settingAmountDraft:this.formatSettingAmountDraft(tmpAsset.SettingAmount),
            settingAmountSnapshot:null,
            assetNumericFieldInFocus:null,
          });
        }
        this.setState({ 
          loading:false,
        });
    }
  };

  render() {
    const headerTitleElement = typeof document === 'undefined' ? null : document.getElementById('page-header-title');
    const { activeTab,searchColumns,data,addVisible ,ratioSettingList,settingVisible2,loading,tipMessage,expandedKeys,
            tabInput,searchVisible,searchValue,searchResult,newObservValue,tmpTitle,errorMsg,
            assetETFDataStatus,assetETFDataError,assetSearchPerformed,
            fixedDepositSetting,isJPYMode,settingVisible,orderVisible,orderDraft,reorderDragIndex,reorderDropIndex,selectedSettingTitleIndex,
            settingDragIndex,settingDropIndex,settingDragOffsetY,
            tabEdit,currentPieData,optimalPieData,sectorOptimalPieData,currentPieView,sectorOptimalMessage,currentAssetItem,assetEditVisible,settingFlg,pageError} = this.state;
    const hasJapanStockSectorData = this.hasJapanStockSectorPieData(activeTab);
    const isSectorLinkedView = currentPieView === CURRENT_PIE_VIEW_SECTOR;
    const isWorldBreakdownView = (
      currentPieView === CURRENT_PIE_VIEW_WORLD_SECTOR
      || currentPieView === CURRENT_PIE_VIEW_WORLD_LOCATION
    );
    const displayedOptimalPieData = isSectorLinkedView ? sectorOptimalPieData : optimalPieData;
    const responsiveCurrentPieData = this.getResponsivePieData(currentPieData, 'current');
    const responsiveOptimalPieData = this.getResponsivePieData(displayedOptimalPieData, 'optimal');
    const narrowCurrentPieLabels = this.getNarrowPieLabels(currentPieData);
    const narrowOptimalPieLabels = this.getNarrowPieLabels(displayedOptimalPieData);
    const isDividendEditor = this.isDividendEditorItem(currentAssetItem);
    const isAssetETFDataLoading = assetETFDataStatus === 'loading';
    const hasAssetETFDataError = assetETFDataStatus === 'error';
    const searchInputPlaceholder = '銘柄名などをスペース区切りで入力';
    const normalizedSearchValue = String(searchValue ?? '').trim();
    const orderableSettingTitles = tmpTitle.filter((title) => title.dataIndex !== 'Asset');
    const displaySettingDrawerWidth = this.getDisplaySettingDrawerWidth();
    const displaySettingDrawerBodyStyle = this.getDisplaySettingDrawerBodyStyle();
    const displaySettingDrawerStyle = this.getDisplaySettingDrawerStyle();
    const constraintDrawerWidth = this.getConstraintDrawerWidth();
    const constraintDrawerBodyStyle = this.getConstraintDrawerBodyStyle();
    const constraintDrawerStyle = this.getConstraintDrawerStyle();
    let searchEmptyText = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="銘柄検索キーワードを入力" />;
    if (isAssetETFDataLoading) {
      searchEmptyText = '検索中...';
    } else if (hasAssetETFDataError) {
      searchEmptyText = assetETFDataError || '銘柄検索に失敗しました';
    } else if (assetSearchPerformed && normalizedSearchValue !== '') {
      searchEmptyText = '該当する銘柄が見つかりませんでした';
    }
    const computedTableColumnsDisplay = this.buildTableColumnsDisplay(this.state.dataTitle, activeTab, data);
    const autoTableColumnsDisplay = computedTableColumnsDisplay.map((column) => {
      const headerCellProps = column.onHeaderCell ? column.onHeaderCell() : {};
      const bodyCellProps = column.onCell ? column.onCell() : {};
      const columnWidth = PORTFOLIO_COLUMN_WIDTHS[column.dataIndex] ?? column.width;
      const isExpandColumn = column.dataIndex === '';
      const isAssetColumn = column.dataIndex === 'Asset';
      const spacedColumn = {
        ...column,
        onHeaderCell: () => ({
          ...headerCellProps,
          style: {
            ...(headerCellProps.style || {}),
            whiteSpace: 'nowrap',
            textAlign: 'center',
            paddingLeft: isExpandColumn ? 6 : isAssetColumn ? 4 : 20,
            paddingRight: isExpandColumn ? 2 : 20,
          },
        }),
        onCell: () => ({
          ...bodyCellProps,
          style: {
            ...(bodyCellProps.style || {}),
            whiteSpace: 'nowrap',
            paddingLeft: isExpandColumn ? 6 : isAssetColumn ? 4 : 20,
            paddingRight: isExpandColumn ? 2 : 20,
          },
        }),
        width: columnWidth,
      };

      if (column.dataIndex === '') {
        return { ...spacedColumn, width: PORTFOLIO_COLUMN_WIDTHS[''] };
      }
      return spacedColumn;
    });
    return (
      <div className='body portfolio-page'>
          {loading && <div style={spinStyle}>
                  <Spin spinning={loading} size="large" tip={tipMessage} />
                </div>}
        <div style={{ pointerEvents: loading?'none':'auto',width:'100%'}}>
          {headerTitleElement && ReactDOM.createPortal(
            <h1 className='portfolio-page-main-heading' style={{ pointerEvents: loading ? 'none' : 'auto' }}>
              <span>次に買う銘柄</span>
              {this.renderValSettingHelpIcon('portfolioManagement')}
            </h1>,
            headerTitleElement
          )}
          {!headerTitleElement && <div className='title'>
            <div className='center-menu' style={{ display: 'inline-flex', alignItems: 'center' }}>
              <h1 className='portfolio-page-main-heading'>
                <span>次に買う銘柄</span>
                {this.renderValSettingHelpIcon('portfolioManagement')}
              </h1>
            </div>
          </div>}
          {this.renderValSettingHelpContent('portfolioManagement', PORTFOLIO_MANAGEMENT_HELP_MESSAGE)}
          {this.renderDebugPanel()}
          {!loading && data.length === 0 && (
            <div style={{ padding: '48px 16px' }}>
              <Empty
                description={pageError || '表示するポートフォリオがありません'}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            </div>
          )}
          <div className='portfolio-add-tab-wrapper'>
            {addVisible && (
              <div className='portfolio-add-tab-help'>
                {this.renderValSettingHelpIcon('addPortfolio')}
                {this.renderValSettingHelpContent('addPortfolio', (
                  <div>
                    <Input placeholder="Enter text" value={tabInput} onChange={this.handleTabInputChange} />
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                      <Button size="small" onClick={this.handleTabCancelClick}>
                        Cancel
                      </Button>
                      <Button className="portfolio-primary-button" size="small" type="primary" onClick={this.handleTabOkClick} style={{ marginLeft: 8 }}>
                        OK
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          <Tabs
          style={{ backgroundColor:"white",width:'100%',height:loading?'400px':'auto'}}
          type="editable-card"
          onChange={this.onChange}
          activeKey={activeTab}
          onEdit={this.onEdit}
        >
          {data.map(record => {
            const portfolioMarketValueSummary = this.buildPortfolioMarketValueSummary(record.children, {
              hasManualCashTransactions: this.getPortfolioHasManualCashTransactions(record),
            });
            const displayedOptimalStats = this.getDisplayedOptimalStats(record);
            const hasPortfolioSummary = Array.isArray(record.children) && record.children.length > 0;
            const tableDataSource = isSectorLinkedView
              ? this.buildSectorModeRows(record)
              : this.buildAssetModeDisplayRows(record);
            const isTabDisabled = Boolean(record.disabled);
            const tabIconColor = isTabDisabled ? '#a6a6a6' : '#1890ff';

            const displayedSummaryMarketValue = isSectorLinkedView
              ? tableDataSource.reduce((sum, row) => sum + (Number(row?.Value) || 0), 0)
              : portfolioMarketValueSummary.marketValue;

            return (
            <TabPane  tab={<div>
                              <span style={{marginRight:'10px'}}>{record.Portfolio} </span>
                              <Popconfirm
                              title={
                                <div  style={{width:'200px'}}> 
                                <Radio.Group value={tabEdit.selectValue} onChange={this.tabEditSelectChange}>
                                  <Radio value="update">変更</Radio>
                                  <Radio value="delete">削除</Radio>
                                </Radio.Group>
                                <Input style={{ fontSize:'16px'}} value={tabEdit.inputValue} onChange={this.tabEditInputChange} disabled={tabEdit.inputDisabled}
                                  placeholder="新たなシナリオ名称"
                                />
                              </div>
                              }
                              onConfirm={() => this.tabEditApply(record.Portfolio)} 
                              okText="適用"
                              okButtonProps={{ className: 'portfolio-primary-button' }}
                              cancelText="キャセル"
                              icon={null}>
                              <FormOutlined onClick={()=>this.tabEditClick(record.Portfolio)} 
                                style={{fontSize:'12px',paddingTop:'3px',marginLeft:'0px',marginRight:'0px',color:tabIconColor}} />
                            </Popconfirm></div>} key={record.Portfolio} closable={false}>
                            
              <>
              
              <div style={{ height:'2px'}}></div>
              
                  <div className='summary'>
                      <div className='detail'>
                        <div className='detail-header'>
                          <span>評価</span>
                          {this.renderValSettingHelpIcon('rating')}
                        </div>
                        <span className='detail-text' ><Rate style={{ direction: 'rtl' }} allowClear={false} value={record.RateLevel} count={3} onChange={() => {}}/></span>
                      </div>
                      {this.renderValSettingHelpContent('rating', '評価は、あなたの収益率と最適ポートフォリオの収益率との差で判定します。差が 1%未満なら ★★★、2%未満なら ★★、3%未満なら ★、3%以上なら 要検討 です。')}
                    <div className='detail'>
                        <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                          <span>あなたの収益率</span>
                          {this.renderValSettingHelpIcon('topIrr')}
                        </span>
                        <span className='detail-text'>{percentFormat(record.IRR)} </span>
                    </div>
                    {this.renderValSettingHelpContent('topIrr', IRR_HELP_MESSAGE)}
                      <div className='detail'>
                        <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                          <span>最適ポートフォリオの収益率</span>
                          {this.renderValSettingHelpIcon('topExpectedReturn')}
                        </span>
                        <span className='detail-text'>{rateFixed(displayedOptimalStats.Return, 2)}%</span>
                    </div>
                    {this.renderValSettingHelpContent('topExpectedReturn', EXPECTED_RETURN_HELP_MESSAGE)}
                    </div>
              {record.children.length >0 && <div style={{ display:'flex',marginTop:'10px'}}>
                <div style={{ flex: 1,fontSize:'15px',color:'#a6a6a6',display:'flex',justifyContent: 'center', alignItems:'center'}}><div>あなたのポートフォリオ</div></div>                
                <div style={{ flex: 1,fontSize:'15px',color:'#a6a6a6',display:'flex',justifyContent: 'center', alignItems:'center'}} >
                  <div>最適ポートフォリオ</div>
                  <Button type="link" onClick={()=>this.handleRatioSettingOn(record)} icon={<SettingOutlined style={{ fontSize: '100%'}}/>}></Button>
                </div>
                
              </div>}
              {record.children.length >0 && <div style={{ display:'flex',marginTop:'-5px',marginBottom:'-6px',position:'relative',zIndex:1}}>
                <div style={{ flex: 1,height:140,position:'relative',zIndex:1}}>
                  <Pie {...responsiveCurrentPieData} />
                  {this.renderNarrowPieLegend(narrowCurrentPieLabels)}
                </div>
                {!isWorldBreakdownView && (
                  <div style={{ flex: 1,height:140,position:'relative',zIndex:1}} >
                    <Pie {...responsiveOptimalPieData} onSliceClick={this.onPieClick}/>
                    {this.renderNarrowPieLegend(narrowOptimalPieLabels)}
                  </div>
                )}
              </div>}
              {record.children.length >0 && <div style={{ display:'flex', alignItems:'center', marginTop:'2px', marginBottom:'6px', position:'relative', zIndex:5 }}>
                <div style={{ flex: 1, display:'flex', justifyContent:'center', alignItems:'center', position:'relative', zIndex:5 }}>
                  <div style={{ display:'inline-flex', alignItems:'center', height:PIE_CONTROL_HEIGHT, position:'relative', zIndex:5 }}>
                    <span style={{ marginRight:'8px', fontSize:'12px', color:'#5f6b76', whiteSpace:'nowrap' }}>
                      表示分類
                    </span>
                    <Select
                      className="portfolio-display-category-select"
                      value={currentPieView}
                      size="small"
                      style={{ width:'120px', fontSize:'12px' }}
                      dropdownMatchSelectWidth={false}
                      onChange={this.handleCurrentPieViewChange}
                    >
                      <Option value={CURRENT_PIE_VIEW_ASSET}>
                        資産区分
                      </Option>
                      <Option
                        value={CURRENT_PIE_VIEW_SECTOR}
                        disabled={!hasJapanStockSectorData}
                      >
                        日本株業種
                      </Option>
                      <Option value={CURRENT_PIE_VIEW_WORLD_SECTOR}>
                        世界株業種
                      </Option>
                      <Option value={CURRENT_PIE_VIEW_WORLD_LOCATION}>
                        世界株地域
                      </Option>
                    </Select>
                  </div>
                </div>
                <div style={{ flex: 1, display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column', position:'relative', zIndex:5 }} >
                  {!isWorldBreakdownView && (
                    <div style={{display:'inline-flex', alignItems:'center', height:PIE_CONTROL_HEIGHT, position:'relative', zIndex:5}}>
                      <ClickButton style={{minWidth:'60px',position: 'relative',boxSizing:'border-box',height:PIE_CONTROL_HEIGHT,lineHeight:PIE_CONTROL_LINE_HEIGHT,padding:'0 10px',fontSize:'12px',zIndex:3,marginRight:'10px'}} onClick={() => {
this.handleCalcOptimal();
                      }} >再計算</ClickButton>
                      <ClickButton style={{minWidth:'60px',position: 'relative',boxSizing:'border-box',height:PIE_CONTROL_HEIGHT,lineHeight:PIE_CONTROL_LINE_HEIGHT,padding:'0 10px',fontSize:'12px',zIndex:3}} onClick={()=>this.handleCalcOptimalSave()} disabled={!record.reClacFlg}>保存</ClickButton>
                    </div>
                  )}
                  {isSectorLinkedView && sectorOptimalMessage && (
                    <div style={{marginTop:'6px', fontSize:'11px', color:'#8c8c8c'}}>
                      {sectorOptimalMessage}
                    </div>
                  )}
                </div>
              </div>}
              <div style={{ height:'2px'}}></div>
              <div style={{height:'60px',marginLeft:'20px',marginTop:'15px',marginRight:'20px',display:'flex',gap:'10px'}}>
                <ClickButton
                  style={{width:'110px',height:'32px',fontSize:'12px'}}
                  onClick={this.openCashTransactionModal}
                >
                  入出金
                </ClickButton>
                <ClickButton style={{flex:1,height:'32px'}}
                          onClick={()=>this.handleAddAsset()} ><FormOutlined style={{marginRight:'5px'}}/> 約定登録</ClickButton>
              </div>
              <div className='detal-tag'>

              <div style={{display:'flex' ,justifyContent:'space-between',paddingBottom:'5px',paddingLeft:'2px',paddingRight:'2px',marginRight:'10px'}} >
                      {/* <Select defaultValue={displayMode} style={{width: 120}} size="small" onChange={this.handleModeChange}>
                        <Option title="円換算" value="JPY">円換算</Option>
                        <Option title="ドル換算" value="USD">ドル換算</Option>
                      </Select> */}
                      <div style={{color:'#a6a6a6',fontSize:'15px',marginLeft:'10px'}}>保有銘柄一覧</div>
                      <div style={{display:'flex',justifyContent:'flex-end'}}>
                        <Switch style={{ marginRight:'10px',marginLeft:'10px',}}checkedChildren="円換算" unCheckedChildren="ドル換算" checked={isJPYMode} onChange={this.handleModeChange}/>                      
                        <ClickButton style={{minWidth:'60px',height:'25px',fontSize:'12px',marginTop:'-1px',marginRight:'6px'}} onClick={this.handleClickSetting}>表示項目</ClickButton>
                        <Button style={{ marginTop:'-3px'}} type="link" onClick={this.handleClickPortfoliaDownload} icon={<DownloadOutlined style={{ fontSize: '100%'}}/>}></Button>
                      </div>
              </div>

                <Table className="portfolio-table-main" style={{ margin:'10px',marginBottom:'10px'}}
                  indentSize={5} 
                  columns={autoTableColumnsDisplay}
                  dataSource={tableDataSource}
                  tableLayout="fixed"
                  scroll={{ x: 'max-content' }}
                  pagination={false}
                  onChange={this.handleTableChange}
                  rowKey="Key"
                  rowClassName={(record, index) => (
                    this.getPortfolioTableRowClassName(record, index, tableDataSource.length, tableDataSource)
                  )}
                  onRow={(record) => ({
                    onClick: (event) => this.handleTableRowSelection(event, record),
                  })}
                  expandable={{
                    expandedRowKeys: expandedKeys,
                    onExpand: this.handleExpand,
                    expandIcon: ({ expanded, onExpand, record }) =>{
                      if (record.Folder === 9 || !this.hasExpandableChildren(record)) {
                        return <span style={{ display: 'inline-block', width: 10 }} />;
                      }else{
                        return (
                          <button
                            type="button"
                            className={`portfolio-expand-icon-button${expanded ? ' is-expanded' : ''}`}
                            aria-label={expanded ? 'collapse row' : 'expand row'}
                            onClick={(event) => this.handleExpandIconClick(event, record, onExpand)}
                          >
                            {expanded ? <DownOutlined /> : <CaretRightOutlined />}
                          </button>)
                      }
                    }
                  }}
                />

               <Row style={{ marginTop:'10px',marginBottom:'40px'}}>
                <Col span={24}   >
                  <div className='summary'>
                    <div className='detail'>
                      <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span>時価額</span>
                        {this.renderValSettingHelpIcon('marketValue')}
                      </span>
                      <span className='detail-text'>{hasPortfolioSummary ? `￥${numFormat(displayedSummaryMarketValue)}` : '-'}</span>
                    </div>
                    {this.renderValSettingHelpContent('marketValue', MARKET_VALUE_HELP_MESSAGE)}
                    <div className='detail'>
                      <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span>総合益</span>
                        {this.renderValSettingHelpIcon('totalProfit')}
                      </span>
                      <span className='detail-text'>{hasPortfolioSummary ? `￥${numFormat(portfolioMarketValueSummary.profit)}` : '-'}</span>
                    </div>
                    {this.renderValSettingHelpContent('totalProfit', TOTAL_PROFIT_HELP_MESSAGE)}
                    <div className='detail'>
                      <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span>評価益</span>
                        {this.renderValSettingHelpIcon('unrealizedProfit')}
                      </span>
                      <span className='detail-text'>{hasPortfolioSummary ? (portfolioMarketValueSummary.hasCurrentHoldings ? (isJPYMode ? `￥${numFormat(portfolioMarketValueSummary.unrealizedProfit)}` : `＄${rateFormat(portfolioMarketValueSummary.unrealizedProfit)}`) : '-') : '-'}</span>
                    </div>
                    {this.renderValSettingHelpContent('unrealizedProfit', UNREALIZED_PROFIT_HELP_MESSAGE)}
                    <div className='detail'>
                      <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span>実現益</span>
                        {this.renderValSettingHelpIcon('realizedProfit')}
                      </span>
                      <span className='detail-text'>{hasPortfolioSummary ? (isJPYMode ? `￥${numFormat(portfolioMarketValueSummary.realizedProfit)}` : `＄${rateFormat(portfolioMarketValueSummary.realizedProfit)}`) : '-'}</span>
                    </div>
                    {this.renderValSettingHelpContent('realizedProfit', REALIZED_PROFIT_HELP_MESSAGE)}
                    <div className='detail'>
                      <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span>累計投資額</span>
                        {this.renderValSettingHelpIcon('cumulativeInvestment')}
                      </span>
                      <span className='detail-text'>{hasPortfolioSummary ? `￥${numFormat(portfolioMarketValueSummary.cumulativeInvestmentAmount)}` : '-'}</span>
                    </div>
                    {this.renderValSettingHelpContent('cumulativeInvestment', CUMULATIVE_INVESTMENT_HELP_MESSAGE)}
                    <div className='detail'>
                      <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span>総合益率</span>
                        {this.renderValSettingHelpIcon('totalProfitRate')}
                      </span>
                      <span className='detail-text'>{hasPortfolioSummary ? `${rateFixed(portfolioMarketValueSummary.totalProfitRate || 0, 2)}%` : '-'}</span>
                    </div>
                    {this.renderValSettingHelpContent('totalProfitRate', TOTAL_PROFIT_RATE_HELP_MESSAGE)}
                    <div className='detail'>
                      <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span>あなたの収益率</span>
                        {this.renderValSettingHelpIcon('summaryIrr')}
                      </span>
                      <span className='detail-text'>{percentFormat(record.IRR)} </span>
                    </div>
                    {this.renderValSettingHelpContent('summaryIrr', IRR_HELP_MESSAGE)}
                    <div className='detail'>
                        <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                          <span>最適ポートフォリオの収益率</span>
                          {this.renderValSettingHelpIcon('summaryExpectedReturn')}
                        </span>
                        <span className='detail-text'>{rateFixed(displayedOptimalStats.Return, 2)}%</span>
                    </div>
                    {this.renderValSettingHelpContent('summaryExpectedReturn', EXPECTED_RETURN_HELP_MESSAGE)}
                    <div className='detail'>
                      <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span>想定リスク</span>
                        {this.renderValSettingHelpIcon('expectedRisk')}
                      </span>
                      <span className='detail-text'>{rateFixed(displayedOptimalStats.Vol, 2)}%</span>
                    </div>
                    {this.renderValSettingHelpContent('expectedRisk', EXPECTED_RISK_HELP_MESSAGE)}
                    <div className='detail'>
                      <span className='detail-header' style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span>シャープレシオ</span>
                        {this.renderValSettingHelpIcon('sharpeRatio')}
                      </span>
                      <span className='detail-text'>{rateFixed1(displayedOptimalStats.Sharpe, 2)}</span>
                    </div>     
                    {this.renderValSettingHelpContent('sharpeRatio', SHARPE_RATIO_HELP_MESSAGE)}
                  </div>
                </Col>
              </Row>
                    <Drawer 
                      title={this.getDisplaySettingHeaderTitle()}
                      visible={settingVisible}
                      placement="right" 
                      closable={false}
                      width={displaySettingDrawerWidth}
                      drawerStyle={displaySettingDrawerStyle}
                      bodyStyle={displaySettingDrawerBodyStyle}
                      contentWrapperStyle={{maxWidth:'100vw'}}
                      onClose={this.onCloseCustomer}
                    >
                    <Row
                      ref={this.reorderListRef}
                      style={{maxHeight:'100%',overflowY:'auto',overflowX:'hidden',margin:0}}
                    >
                      {orderableSettingTitles.map((title, index) => {
                          const isDragging = settingDragIndex === index;
                          const rowShift = 40;
                          const isSelected = selectedSettingTitleIndex === index || isDragging;
                          const shouldShiftUp = settingDragIndex !== null && settingDropIndex !== null && settingDragIndex < settingDropIndex && index > settingDragIndex && index <= settingDropIndex;
                          const shouldShiftDown = settingDragIndex !== null && settingDropIndex !== null && settingDragIndex > settingDropIndex && index >= settingDropIndex && index < settingDragIndex;
                          const moveTransform = isDragging
                            ? `translateY(${settingDragOffsetY - 3}px) scale(1.025)`
                            : shouldShiftUp
                              ? `translateY(-${rowShift}px)`
                              : shouldShiftDown
                                ? `translateY(${rowShift}px)`
                                : 'translateY(0) scale(1)';
                          return <Col 
                                    key={title.dataIndex || index}
                                    span={24}
                                    style={{marginBottom:'8px',paddingRight:0}}>
                                      <div
                                        data-setting-title-index={index}
                                        data-testid={`display-setting-row-${title.dataIndex}`}
                                        onClick={(event) => this.handleSettingTitleCardClick(event, index)}
                                        style={{
                                          position:'relative',
                                          display:'flex',
                                          flexWrap:'wrap',
                                          alignItems:'center',
                                          width:'100%',
                                          minHeight:'60px',
                                          gap:'8px',
                                          padding:'8px 10px',
                                          border:isSelected ? '1px solid #1890ff' : '1px solid #e8ecef',
                                          borderRadius:'8px',
                                          background:isSelected ? '#eef6ff' : '#f7f9fb',
                                          boxShadow:isDragging ? '0 0 0 3px rgba(24, 144, 255, 0.16), 0 12px 26px rgba(9, 132, 227, 0.26), 0 6px 14px rgba(0, 0, 0, 0.12)' : isSelected ? '0 0 0 2px rgba(24, 144, 255, 0.12), 0 2px 8px rgba(24, 144, 255, 0.12)' : '0 1px 4px rgba(0, 0, 0, 0.06)',
                                          opacity:isDragging ? 0.94 : 1,
                                          transform:moveTransform,
                                          transition:isDragging ? 'box-shadow 0.16s ease, opacity 0.16s ease, background 0.16s ease' : 'box-shadow 0.16s ease, opacity 0.16s ease, transform 0.18s ease, background 0.16s ease',
                                          zIndex:isDragging ? 2 : 1,
                                          pointerEvents:isDragging ? 'none' : 'auto'
                                        }}
                                      >
                                      <div
                                        data-testid={`display-setting-handle-${title.dataIndex}`}
                                        style={{display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,width:'64px',minWidth:'64px'}}
                                      >
                                        <div
                                          onPointerDown={this.handleSettingTitlePointerDown(index)}
                                          style={{
                                            width:'40px',
                                            minWidth:'40px',
                                            height:'40px',
                                            display:'flex',
                                            alignItems:'center',
                                            justifyContent:'center',
                                            borderRadius:'10px',
                                            background:isDragging ? '#0984e3' : '#eef6ff',
                                            color:isDragging ? '#ffffff' : '#0984e3',
                                            cursor:isDragging ? 'grabbing' : 'grab',
                                            touchAction:'none',
                                            boxShadow:isDragging ? '0 4px 10px rgba(9, 132, 227, 0.32)' : 'inset 0 0 0 1px rgba(9, 132, 227, 0.12)',
                                            transition:'background 0.16s ease, color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease',
                                            transform:isDragging ? 'scale(1.08)' : 'scale(1)'
                                          }}
                                        >
                                          <UnorderedListOutlined style={{fontSize:'14px'}} />
                                        </div>
                                        {this.renderValSettingHelpIcon(`dragSetting-${title.dataIndex}`)}
                                      </div>
                                      <div
                                        data-testid={`display-setting-move-buttons-${title.dataIndex}`}
                                        style={{display:'flex',gap:'6px',flexShrink:0}}
                                      >
                                        <Button
                                          aria-label={`${title.name} を上へ移動`}
                                          onClick={() => this.handleSettingTitleMove(index, -1)}
                                          disabled={index === 0}
                                          style={{width:'40px',minWidth:'40px',height:'40px',padding:0,borderRadius:'10px',fontSize:'18px',lineHeight:1,flexShrink:0}}
                                        >
                                          ↑
                                        </Button>
                                        <Button
                                          aria-label={`${title.name} を下へ移動`}
                                          onClick={() => this.handleSettingTitleMove(index, 1)}
                                          disabled={index === orderableSettingTitles.length - 1}
                                          style={{width:'40px',minWidth:'40px',height:'40px',padding:0,borderRadius:'10px',fontSize:'18px',lineHeight:1,flexShrink:0}}
                                        >
                                          ↓
                                        </Button>
                                      </div>
                                      <div
                                        data-testid={`display-setting-checkbox-${title.dataIndex}`}
                                        style={{display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,width:'24px',minWidth:'24px'}}
                                      >
                                        <Checkbox
                                          checked={title.visible}
                                          onChange={() => this.onChangeCustomSetting(title.dataIndex)}
                                          disabled={title.disabled}
                                        />
                                      </div>
                                      <div
                                        data-testid={`display-setting-title-${title.dataIndex}`}
                                        style={{flex:1,minWidth:0,overflow:'hidden'}}
                                      >
                                        <div
                                          style={{
                                            whiteSpace:'nowrap',
                                            overflow:'hidden',
                                            textOverflow:'ellipsis',
                                            fontSize:'14px',
                                            lineHeight:'1.4'
                                          }}
                                        >
                                          {title.name}
                                        </div>
                                      </div>
                                      <div style={{display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,width:'28px',minWidth:'28px'}}>
                                        {this.renderValSettingHelpIcon(`displaySetting-${title.dataIndex}`)}
                                      </div>
                                      {this.renderValSettingHelpContent(`dragSetting-${title.dataIndex}`, 'ドラッグして並び替え')}
                                      {this.renderValSettingHelpContent(`displaySetting-${title.dataIndex}`, title.helpMessage)}
                                      </div>
                                  </Col>                          
                      })}
                    </Row>
                         
                    </Drawer >
                    <Drawer
                      title={<div style={{position:'relative',minHeight:'28px'}}>
                                <div style={{fontSize:'18px',fontWeight:'bold',textAlign:'left'}}>並び順</div>
                                <div style={{position:'absolute',top:0,right:0}}>
                                  <ClickButton style={{width:'100px'}} onClick={this.commitOrderDraft}>閉じる</ClickButton>
                                </div>
                             </div>}
                      visible={orderVisible}
                      placement="bottom"
                      closable={false}
                      height={Math.min(window.innerHeight * 0.82, 640)}
                      onClose={this.closeOrderDrawer}
                    >
                      <div style={{display:'flex',flexDirection:'column',height:'100%'}}>
                        <div style={{color:'#7f8c8d',fontSize:'13px',marginBottom:'12px'}}>表示中の項目を、ドラッグまたは上下ボタンで並び替えできます。</div>
                        <div ref={this.reorderListRef} style={{flex:1,overflowY:'auto'}}>
                          {orderDraft.map((title, index) => {
                            const isDragging = reorderDragIndex === index;
                            const showDropLine = reorderDragIndex !== null && reorderDropIndex === index && reorderDragIndex !== index;
                            return (
                              <div
                                key={title.dataIndex}
                                data-reorder-index={index}
                                style={{
                                  position:'relative',
                                  marginBottom:'10px',
                                  borderRadius:'14px',
                                  background:'#ffffff',
                                  boxShadow:isDragging ? '0 10px 24px rgba(0, 0, 0, 0.16)' : '0 2px 10px rgba(0, 0, 0, 0.08)',
                                  opacity:isDragging ? 0.78 : 1,
                                  transform:isDragging ? 'scale(1.01)' : 'scale(1)',
                                  transition:'box-shadow 0.15s ease, opacity 0.15s ease, transform 0.15s ease',
                                  minHeight:'56px',
                                  border:'1px solid #e8ecef',
                                }}
                              >
                                {showDropLine && <div style={{position:'absolute',top:'-6px',left:'14px',right:'14px',height:'3px',borderRadius:'999px',background:'#1890ff'}} />}
                                <div style={{display:'flex',alignItems:'center',padding:'12px 14px',gap:'12px'}}>
                                  <div
                                    onPointerDown={this.handleReorderPointerDown(index)}
                                    style={{
                                      width:'40px',
                                      minWidth:'40px',
                                      height:'40px',
                                      display:'flex',
                                      alignItems:'center',
                                      justifyContent:'center',
                                      borderRadius:'10px',
                                      background:'#f5f7fa',
                                      color:'#5f6c7b',
                                      cursor:'grab',
                                      touchAction:'none',
                                    }}
                                  >
                                    <MenuOutlined />
                                  </div>
                                  <div style={{flex:1,fontSize:'16px',fontWeight:600,color:'#2d3436'}}>{title.name}</div>
                                  <div style={{display:'flex',gap:'8px'}}>
                                    <Button
                                      aria-label={`${title.name} を上へ移動`}
                                      onClick={() => this.handleOrderMove(index, -1)}
                                      disabled={index === 0}
                                      style={{width:'44px',height:'44px',borderRadius:'12px'}}
                                      icon={<ArrowUpOutlined />}
                                    />
                                    <Button
                                      aria-label={`${title.name} を下へ移動`}
                                      onClick={() => this.handleOrderMove(index, 1)}
                                      disabled={index === orderDraft.length - 1}
                                      style={{width:'44px',height:'44px',borderRadius:'12px'}}
                                      icon={<ArrowDownOutlined />}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </Drawer>
                    <Drawer
                      title={null}
                      placement="left"
                      closable={false}
                      onClose={()=>this.setState({searchVisible:false})}
                      visible={searchVisible}
                      width="100%"
                      bodyStyle={{padding:'12px'}}
                      style={{ position: 'fixed', top: 0, left: 0 }} 
                    >
                      <div style={{ display: 'flex', flexDirection: 'column'}}>
                      <div >
                        <div className="portfolio-asset-search-controls">
                          <div className="portfolio-asset-search-header">
                            <div
                              className="portfolio-asset-search-label"
                              style={{
                                color:'#a6a6a6',
                                fontSize:'15px',
                                marginLeft:'10px',
                                whiteSpace:'nowrap'
                              }}
                            >
                              銘柄検索
                            </div>

                            <ClickButton
                              className="portfolio-asset-search-close"
                              style={{
                                width:'72px',
                                fontSize:14,
                                flex:'0 0 72px'
                              }}
                              onClick={()=>this.handleClickSearchFinish()}
                            >
                              閉じる
                            </ClickButton>
                          </div>

                          <div className="portfolio-asset-search-query">
                            <Input
                              className="portfolio-asset-search-input"
                              style={{
                                borderRadius:'10px',
                                minWidth:0,
                                flex:1
                              }}
                              size={'large'}
                              value={searchValue}
                              allowClear={true}
                              placeholder={searchInputPlaceholder}
                              onChange={this.handleSearchAsset}
                              onPressEnter={this.handleSearchAssetSubmit}
                            />

                            <ClickButton
                              className="portfolio-asset-search-submit"
                              style={{
                                width:'72px',
                                fontSize:14,
                                flex:'0 0 72px'
                              }}
                              onClick={this.handleSearchAssetSubmit}
                              disabled={isAssetETFDataLoading}
                            >
                              {isAssetETFDataLoading ? '検索中...' : '検索'}
                            </ClickButton>
                          </div>
                        </div>
                          {hasAssetETFDataError && (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                margin: '0 10px 10px 10px',
                                padding: '10px 12px',
                                borderRadius: '10px',
                                backgroundColor: hasAssetETFDataError ? '#fff2f0' : '#f5f5f5',
                                color: hasAssetETFDataError ? '#cf1322' : '#595959',
                              }}
                            >
                              <span>
                                {assetETFDataError || '銘柄検索に失敗しました'}
                              </span>
                              <Button type="link" onClick={this.retryAssetETFData}>
                                再試行
                              </Button>
                            </div>
                          )}
                          <div style={{height:'10px' }}><span></span></div>
                        </div>
                        <div className="portfolio-asset-search-top-pagination">
                          <Pagination
                            total={this.state.assetSearchTotal}
                            current={this.state.assetSearchPage}
                            pageSize={this.state.assetSearchPageSize}
                            pageSizeOptions={ASSET_SEARCH_PAGE_SIZES.map(String)}
                            showSizeChanger={true}
                            hideOnSinglePage={false}
                            locale={{ items_per_page: '件 / ページ' }}
                            showTotal={(total) => `全${total}件`}
                            onChange={this.handleAssetSearchPageChange}
                          />
                        </div>
                        <div style={{minWidth:0, fontSize:12, marginTop:'10px'}}>
                          <div style={{display:'flex', alignItems:'start'}}>
                            <div style={{flex:'0 0 30px', width:30}}></div>
                            <div
                              style={{
                                display:'grid',
                                gridTemplateColumns:'116px 120px minmax(0, 1fr)',
                                columnGap:'8px',
                                alignItems:'start',
                                marginLeft:'10px',
                                marginRight:'10px',
                                flex:1,
                                minWidth:0,
                                color:'rgba(0, 0, 0, 0.25)',
                                fontWeight:'bold',
                                textAlign:'left',
                              }}
                            >
                              <div style={{display:'inline-flex', alignItems:'center', minWidth:0}}>
                                <button
  type="button"
  aria-label="資産区分を並べ替え"
  onClick={() => this.handleAssetSearchSort('asset')}
  style={{
    display:'inline-flex', alignItems:'center', gap:3,
    padding:'4px 0', border:0, background:'transparent',
    cursor:'pointer', color:'#1677ff', font:'inherit',
    whiteSpace:'nowrap', fontWeight:'inherit',
  }}
>
  <span>資産区分</span>
  <span style={{
    display:'inline-flex', flexDirection:'column',
    justifyContent:'center', gap:2, marginLeft:1,
    fontSize:9, lineHeight:'9px',
  }}>
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      aria-hidden="true"
      style={{ display:'block', overflow:'visible' }}
    >
      <polygon
        points="6,1 1,8 11,8"
        fill={this.state.assetSearchSortField === 'asset' && this.state.assetSearchSortOrder === 'asc' ? '#1677ff' : '#ffffff'}
        stroke={this.state.assetSearchSortField === 'asset' && this.state.assetSearchSortOrder === 'asc' ? '#1677ff' : '#8b9bad'}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
    </svg>
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      aria-hidden="true"
      style={{ display:'block', overflow:'visible' }}
    >
      <polygon
        points="1,2 11,2 6,9"
        fill={this.state.assetSearchSortField === 'asset' && this.state.assetSearchSortOrder === 'desc' ? '#1677ff' : '#ffffff'}
        stroke={this.state.assetSearchSortField === 'asset' && this.state.assetSearchSortOrder === 'desc' ? '#1677ff' : '#8b9bad'}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
    </svg>
  </span>
</button>
                                {this.renderSearchHeaderHelpIcon('search-asset-header')}
                              </div>
                              <div style={{display:'inline-flex', alignItems:'center', minWidth:0}}>
                                <button
  type="button"
  aria-label="銘柄コードを並べ替え"
  onClick={() => this.handleAssetSearchSort('code')}
  style={{
    display:'inline-flex', alignItems:'center', gap:3,
    padding:'4px 0', border:0, background:'transparent',
    cursor:'pointer', color:'#1677ff', font:'inherit',
    whiteSpace:'nowrap', fontWeight:'inherit',
  }}
>
  <span>銘柄コード</span>
  <span style={{
    display:'inline-flex', flexDirection:'column',
    justifyContent:'center', gap:2, marginLeft:1,
    fontSize:9, lineHeight:'9px',
  }}>
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      aria-hidden="true"
      style={{ display:'block', overflow:'visible' }}
    >
      <polygon
        points="6,1 1,8 11,8"
        fill={this.state.assetSearchSortField === 'code' && this.state.assetSearchSortOrder === 'asc' ? '#1677ff' : '#ffffff'}
        stroke={this.state.assetSearchSortField === 'code' && this.state.assetSearchSortOrder === 'asc' ? '#1677ff' : '#8b9bad'}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
    </svg>
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      aria-hidden="true"
      style={{ display:'block', overflow:'visible' }}
    >
      <polygon
        points="1,2 11,2 6,9"
        fill={this.state.assetSearchSortField === 'code' && this.state.assetSearchSortOrder === 'desc' ? '#1677ff' : '#ffffff'}
        stroke={this.state.assetSearchSortField === 'code' && this.state.assetSearchSortOrder === 'desc' ? '#1677ff' : '#8b9bad'}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
    </svg>
  </span>
</button>
                                {this.renderSearchHeaderHelpIcon('search-code-header')}
                              </div>
                              <div style={{display:'inline-flex', alignItems:'center', minWidth:0}}>
                                <button
  type="button"
  aria-label="ベンチマークを並べ替え"
  onClick={() => this.handleAssetSearchSort('benchmark')}
  style={{
    display:'inline-flex', alignItems:'center', gap:3,
    padding:'4px 0', border:0, background:'transparent',
    cursor:'pointer', color:'#1677ff', font:'inherit',
    whiteSpace:'nowrap', fontWeight:'inherit',
  }}
>
  <span>ベンチマーク</span>
  <span style={{
    display:'inline-flex', flexDirection:'column',
    justifyContent:'center', gap:2, marginLeft:1,
    fontSize:9, lineHeight:'9px',
  }}>
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      aria-hidden="true"
      style={{ display:'block', overflow:'visible' }}
    >
      <polygon
        points="6,1 1,8 11,8"
        fill={this.state.assetSearchSortField === 'benchmark' && this.state.assetSearchSortOrder === 'asc' ? '#1677ff' : '#ffffff'}
        stroke={this.state.assetSearchSortField === 'benchmark' && this.state.assetSearchSortOrder === 'asc' ? '#1677ff' : '#8b9bad'}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
    </svg>
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      aria-hidden="true"
      style={{ display:'block', overflow:'visible' }}
    >
      <polygon
        points="1,2 11,2 6,9"
        fill={this.state.assetSearchSortField === 'benchmark' && this.state.assetSearchSortOrder === 'desc' ? '#1677ff' : '#ffffff'}
        stroke={this.state.assetSearchSortField === 'benchmark' && this.state.assetSearchSortOrder === 'desc' ? '#1677ff' : '#8b9bad'}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
    </svg>
  </span>
</button>
                                {this.renderSearchHeaderHelpIcon('search-benchmark-header')}
                              </div>
                            </div>
                          </div>
                          {this.renderValSettingHelpContent(
                            'search-asset-header',
                            <span>
                              最適化は資産区分ごとに行います。資産区分は、地域（日本、米国、先進国、新興国など）とアセットクラス（株式・債券・不動産など）の組み合わせを基本として分類しています。詳しくは
                              <a
                                href="https://cloudoz.jp/%E9%8A%98%E6%9F%84%E9%81%B8%E6%8A%9E/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(event) => event.stopPropagation()}
                                style={{textDecoration:'underline'}}
                              >
                                資産区分の代表銘柄
                              </a>
                              をご参照ください。
                            </span>
                          )}
                          {this.renderValSettingHelpContent(
                            'search-code-header',
                            <span>
                              株式は証券コード、投資信託は
                              <a
                                href="https://toushin-lib.fwg.ne.jp/FdsWeb/FDST000000"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(event) => event.stopPropagation()}
                                style={{textDecoration:'underline'}}
                              >
                                投信ライブラリ
                              </a>
                              （ISIN）コードを表示しています。
                            </span>
                          )}
                          {this.renderValSettingHelpContent(
                            'search-benchmark-header',
                            <span>
                              この銘柄の資産区分を決定する際に参考にしているベンチマーク（指数または銘柄）です。
                              投資信託・国内ETFは
                              <a
                                href="https://toushin-lib.fwg.ne.jp/FdsWeb/FDST000000"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(event) => event.stopPropagation()}
                                style={{textDecoration:'underline'}}
                              >
                                投信ライブラリ
                              </a>
                              にリンクされた交付目論見書、米国ETFは
                              <a
                                href="https://www.sec.gov/edgar/search/#"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(event) => event.stopPropagation()}
                                style={{textDecoration:'underline'}}
                              >
                                EDGAR
                              </a>
                              の開示資料等をもとに判定しています。
                            </span>
                          )}
                          <div style={{backgroundColor:'#c8c8c8', height:'1px', marginTop:'2px'}}></div>
                        </div>

                        <Table style={{margin:'0', minWidth:0}}
                          tableLayout="fixed"
                          columns={searchColumns}
                          dataSource={searchResult}
                          rowKey={(record, index) =>
                            record?.Key
                            || record?.InstrumentCode
                            || record?.Code
                            || record?.code
                            || `search-result-${index}`
                          }
                          showHeader={false}
                          locale={{ emptyText: searchEmptyText }}
                          pagination={{
                            position: ['bottomRight'],
                            total: this.state.assetSearchTotal,
                            current: this.state.assetSearchPage,
                            pageSize: this.state.assetSearchPageSize,
                            pageSizeOptions: ASSET_SEARCH_PAGE_SIZES.map(String),
                            showSizeChanger: true,
                            hideOnSinglePage: false,
                            locale: { items_per_page: '件 / ページ' },
                            showTotal: (total) => `全${total}件`,
                            onChange: this.handleAssetSearchPageChange,
                          }}
                        />
                      </div>
                    </Drawer>

                    
                    <Drawer
                      title={null}
                      placement="left"
                      closable={false}
                      onClose={()=>this.setState({assetEditVisible:false})}
                      visible={assetEditVisible}
                      width={window.innerWidth}
                      zIndex={2000}
                      style={{ position: 'fixed', top: 0, left: 0 }} 
                    >
                      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh',width:'100%' }}>
                        <div style={{ display: 'flex'}}>
                          <div style={{ flex: 1}}>
                            <div style={{display:'flex',justifyContent: "space-between",margin:'0px 0px',fontSize:'18px',color:'#a6a6a6'}}>
                                <span>{isDividendEditor ? '配当編集' : (currentAssetItem.New?'約定登録':'約定編集')}</span>
                                {!currentAssetItem.New && (
                                  this.supportsScopedDeleteSelection(currentAssetItem) ? (
                                    <Dropdown
                                      overlay={this.getRecurringDeleteMenu(currentAssetItem)}
                                      trigger={['click']}
                                      placement="bottomRight"
                                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                      overlayStyle={{ zIndex: 3100 }}
                                    >
                                      <Button
                                        style={{height:'28px',width:'148px',fontSize:14,padding:'0 10px',display:'flex',alignItems:'center',justifyContent:'space-between', marginRight:'10px'}}
                                      >
                                        <span>削除方法を選択</span>
                                        <DownOutlined />
                                      </Button>
                                    </Dropdown>
                                  ) : (
                                    <ClickButton style={{height:'28px',width: '100px',fontSize:16, marginRight:'10px'}} onClick={()=>this.handleClickAssetDelete('single')}>{'削除'}</ClickButton>
                                  )
                                )}
                            </div>   
                            <div style={{display:'flex',margin:'0px 0px',fontSize:'18px',color:'#a6a6a6',fontWeight:'bold'}}>
                                <div style={{ marginRight: '10px'}}>{currentAssetItem.Title}</div><a href={currentAssetItem.URL} target='_blank' rel='noopener noreferrer' onClick={this.handleLinkClick} style={{ textDecoration: 'underline' }}> {currentAssetItem.SubCode}</a>
                            </div>  
                            <div style={{display:'flex',margin:'0px 0px',fontSize:'18px',fontWeight:'bold'}}>
                                <span>{currentAssetItem.SubTitle}</span>
                            </div>    
                          </div>
                          <div style={{
                          width: (currentAssetItem.TranId && !currentAssetItem.New) ? '148px' : '100px',
                          flexShrink: 0,
                          display:'flex',
                          flexDirection: 'column',
                          justifyContent:'flex-start',
                          alignItems:'flex-end',
                          marginRight:'10px'
                        }}>
                            {(currentAssetItem.TranId && !currentAssetItem.New) ? (
                              <div style={{marginBottom:'20px'}}>
                                {currentAssetItem.Changed ? (
                                  <Dropdown
                                    overlay={this.getRecurringUpdateMenu()}
                                    trigger={['click']}
                                    placement="bottomRight"
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    overlayStyle={{ zIndex: 3100 }}
                                  >
                                    <Button
                                      style={{height:'28px',width:'148px',fontSize:14,padding:'0 10px',display:'flex',alignItems:'center',justifyContent:'space-between'}}
                                    >
                                      <span>更新方法を選択</span>
                                      <DownOutlined />
                                    </Button>
                                  </Dropdown>
                                ) : (
                                  <Button
                                    disabled
                                    style={{height:'28px',width:'148px',fontSize:14,padding:'0 10px',display:'flex',alignItems:'center',justifyContent:'space-between'}}
                                  >
                                    <span>更新方法を選択</span>
                                    <DownOutlined />
                                  </Button>
                                )}
                              </div>
                            ) : (
                              <ClickButton style={{height:'28px',width: '100px',fontSize:16,marginBottom:'20px'}} disabled={!currentAssetItem.New && !currentAssetItem.Changed} onClick={()=>this.handleClickAssetEditApply('single')}>{'適用'}</ClickButton>
                            )}
                            <ClickButton style={{height:'28px',width: '100px',fontSize:16}} onClick={()=>this.handleClickAssetEditCancel()}>{'キャンセル'}</ClickButton>
                          </div>
                        
                        {/* <div style={{width:'100%',display:'flex',marginTop:'15px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-end'}}>
                        </div> */}

                        </div>
                          <div style={{height:'10px' }}><span></span></div>
                          <div style={{backgroundColor:'#c8c8c8',height:'1px',marginTop:'2px'}}></div>
                        {isDividendEditor ? (
                          <>
                            <div style={{width:'100%',display:'flex',marginTop:'15px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>税区分</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <Select value={currentAssetItem.TaxCategory} style={{ width:'180px' }} size="middle"
                                  onChange={this.onDividendTaxCategoryChange}
                                  getPopupContainer={(triggerNode) => triggerNode.parentNode}>
                                  <Option value={"1"}>特定預り</Option>
                                  <Option value={"2"}>NISA成長投資枠</Option>
                                  <Option value={"3"}>NISAつみたて投資枠</Option>
                                  <Option value={"4"}>旧NISA</Option>
                                  <Option value={"5"}>iDeCo</Option>
                                  <Option value={"6"}>企業型DC</Option>
                                  <Option value={"7"}>一般預り</Option>
                                </Select>
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>日付</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <PasteableDatePicker
                                  value={moment(currentAssetItem.TradeDate,'YYYY-MM-DD')}
                                  style={{fontSize:'16px',width:'180px' }}
                                  onChange={this.onDividendTradeDateChange}
                                />
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>一株配当</div>
                              <div style={{flex:9,textAlign:'left',display:'flex',alignItems:'center'}}>
                                <InputNumber
                                  style={{fontSize:'16px',width:'180px',color:'black',background:'white'}}
                                  min={0}
                                  inputMode="decimal"
                                  formatter={(value) => {
                                    if (value === '' || value === undefined || value === null) return '';
                                    const num = value.toString().replace(/,/g, '');
                                    const [intPart, decimalPart] = num.split('.');
                                    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                    return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
                                  }}
                                  parser={(value) => {
                                    if (value === '' || value === undefined || value === null) return '';
                                    return ToHalfWidthNumber(value);
                                  }}
                                  value={currentAssetItem.DividendPerShare}
                                  onChange={this.onDividendPerShareChange}
                                  onBlur={this.onDividendPerShareBlur}
                                />
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>数量</div>
                              <div style={{flex:9,textAlign:'left',display:'flex',alignItems:'center'}}>
                                <InputNumber
                                  style={{fontSize:'16px',width:'180px',color:'#595959'}}
                                  inputMode="decimal"
                                  controls={false}
                                  readOnly
                                  disabled
                                  formatter={(value) => {
                                    if (value === '' || value === undefined || value === null) return '';
                                    const num = value.toString().replace(/,/g, '');
                                    const [intPart, decimalPart] = num.split('.');
                                    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                    return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
                                  }}
                                  value={currentAssetItem.DividendQuantity}
                                />
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>配当金</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <Input
                                  style={{fontSize:'16px',width:'180px',color:'#595959'}}
                                  value={formatCurrencyAmount(currentAssetItem.DividendGrossAmount, currentAssetItem.DividendSettleCcy)}
                                  readOnly
                                  disabled
                                />
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>税率</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <Input
                                  style={{fontSize:'16px',width:'180px',color:'#595959'}}
                                  value={formatDividendTaxRate(currentAssetItem.DividendGrossAmount, currentAssetItem.DividendTaxAmount)}
                                  readOnly
                                  disabled
                                />
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>税額</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <Input
                                  style={{fontSize:'16px',width:'180px',color:'#595959'}}
                                  value={formatCurrencyAmount(currentAssetItem.DividendTaxAmount, currentAssetItem.DividendSettleCcy)}
                                  readOnly
                                  disabled
                                />
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>受取額</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <Input
                                  style={{fontSize:'16px',width:'180px',color:'#595959'}}
                                  value={formatCurrencyAmount(currentAssetItem.DividendNetAmount, currentAssetItem.DividendSettleCcy)}
                                  readOnly
                                  disabled
                                />
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>配当通貨</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <Input
                                  style={{fontSize:'16px',width:'180px',color:'#595959'}}
                                  value={getCurrencyLabel(currentAssetItem.DividendCcy)}
                                  readOnly
                                  disabled
                                />
                              </div>
                            </div>
                            {currentAssetItem.DividendCcy !== currentAssetItem.DividendSettleCcy && (
                              <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                                <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>為替</div>
                                <div style={{flex:9,textAlign:'left'}}>
                                  <Input
                                    style={{fontSize:'16px',width:'180px',color:'#595959'}}
                                    value={currentAssetItem.DividendFxRate ?? ''}
                                    readOnly
                                    disabled
                                  />
                                </div>
                              </div>
                            )}
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>決済通貨</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <Input
                                  style={{fontSize:'16px',width:'180px',color:'#595959'}}
                                  value={getCurrencyLabel(currentAssetItem.DividendSettleCcy)}
                                  readOnly
                                  disabled
                                />
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>備考</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <TextArea
                                  style={{fontSize:'16px'}}
                                  value={currentAssetItem.DividendMemo ?? currentAssetItem.Memo}
                                  readOnly
                                  disabled
                                  autoSize={{ minRows: 2, maxRows: 4 }}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div style={{width:'100%',display:'flex',marginTop:'15px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>売買</div>
                              <div style={{flex:5,textAlign:'left',width:'100px'}}>
                                <Radio.Group value={currentAssetItem.PorS} buttonStyle="solid"
                                          onChange={(v)=>this.onAssetItemChange(v.target.value,'PorS')} >
                                  <Radio.Button value={1}>買</Radio.Button>
                                  <Radio.Button value={2}>売</Radio.Button>
                              </Radio.Group>
                              </div>
                              <div style={{flex:4,textAlign:'right'}}>
                                {/* <ClickButton style={{height:'28px',width: '100px',fontSize:16}} >{'積立'}</ClickButton> */}
                              </div>

                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>税区分</div>
                              <div style={{flex:9,textAlign:'left'}}>
                              <Select value={currentAssetItem.TaxCategory} style={{ width:'180px' }} size="middle"
                                onChange={(v)=>this.onAssetItemChange(v,'TaxCategory')}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}>
                                                <Option value={"1"}>特定預り</Option>
                                                <Option value={"2"}>NISA成長投資枠</Option>
                                                <Option value={"3"}>NISAつみたて投資枠</Option>
                                                <Option value={"4"}>旧NISA</Option>
                                                <Option value={"5"}>iDeCo</Option>
                                                <Option value={"6"}>企業型DC</Option>
                                                <Option value={"7"}>一般預り</Option>
                                              </Select>
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>日付</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <PasteableDatePicker
                                  value={moment(currentAssetItem.TradeDate,'YYYY-MM-DD')}
                                  style={{fontSize:'16px',width:'180px' }}
                                  onChange={this.onChangeTradeDate}
                                />
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>口座</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <Select
                                  value={currentAssetItem.AccountId ?? (currentAssetItem.Account ? `legacy:${currentAssetItem.Account}` : undefined)}
                                  style={{ width:'180px' }}
                                  size="middle"
                                  placeholder="口座を選択"
                                  onChange={this.onTradeAccountChange}
                                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                >
                                  {this.state.userAccounts.map((account) => (
                                    <Option key={account.id} value={account.id}>{account.displayName}</Option>
                                  ))}
                                  {currentAssetItem.AccountId && !this.state.userAccounts.some((account) => account.id === currentAssetItem.AccountId) && (
                                    <Option value={currentAssetItem.AccountId} disabled>{currentAssetItem.Account || '無効な口座'}（無効）</Option>
                                  )}
                                  {!currentAssetItem.AccountId && currentAssetItem.Account && (
                                    <Option value={`legacy:${currentAssetItem.Account}`} disabled>{currentAssetItem.Account}（旧データ）</Option>
                                  )}
                                </Select>
                                <Button type="link" style={{paddingLeft:'8px'}} onClick={this.openAccountManager}>口座を追加・編集</Button>
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',height:'32px',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left',paddingTop:'5px'}}>積立コース</div>
                              <div style={{flex:9,textAlign:'left',display:'flex',alignItems:'center'}}>
                                <div className='radio-group-horizontal'>
                                <Radio.Group
                                  disabled={!currentAssetItem.New}
                                  onChange={(e)=>this.onAssetItemChange(e.target.value,'AutoPlan')}
                                  value={currentAssetItem.AutoPlan}
                                  options={[
                                    { value: false, label: 'なし' },
                                    { value: true, label: '毎月' },
                                  ]}
                                />
                                </div>
                              </div>
                            </div>

                            {currentAssetItem.AutoPlan && <div style={{width:'100%',display:'flex',height:'32px',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left',paddingTop:'5px'}}>積立最終日</div>
                              <div style={{flex:9,textAlign:'left',display:'flex',alignItems:'center'}}>
                                <div className='radio-group-horizontal'>
                                <Radio.Group
                                  onChange={(e)=>this.onChangeLastDateFlg(e.target.value)}
                                  value={currentAssetItem.LastDateFlg}
                                  options={[
                                    { value: false, label: '未定' },
                                    { value: true, label: '指定あり' },
                                  ]}
                                />
                                </div>
                              </div>
                            </div>}
                            {currentAssetItem.LastDateFlg && <div style={{width:'100%',display:'flex',height:'35px',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}></div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <PasteableDatePicker
                                  value={moment(currentAssetItem.LastPlanDate,'YYYY-MM-DD')}
                                  style={{fontSize:'16px',width:'180px'}}
                                  onChange={this.onChangeLastPlanDate}
                                />
                              </div>
                            </div>}
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>数量</div>
                              <div style={{flex:9,textAlign:'left',display:'flex',alignItems:'center'}}><Input
                                          style={{
                                            fontSize:'16px',
                                            width:'130px',
                                            color: currentAssetItem.AutoQuantity ? '#bfbfbf' : 'black',
                                            background: currentAssetItem.AutoQuantity ? '#f5f5f5' : 'white',
                                            cursor: currentAssetItem.AutoQuantity ? 'not-allowed' : 'text'
                                          }}
                                          inputMode="decimal"
                                          readOnly={currentAssetItem.AutoQuantity}
                                          onFocus={()=>this.onTradeFieldFocus('Quantity')}
                                          onChange={(e)=>this.onTradeFieldDraftChange('Quantity',e)}
                                          onBlur={()=>this.onTradeFieldBlur('Quantity')}
                                          value={this.state.quantityDraft}/>
                                          <div style={{width:'20px',marginLeft:'2px'}}> </div>
                                          <Switch style={{marginLeft:'2px',width:'80px'}} checkedChildren="自動" unCheckedChildren="手入力"
                                            checked={currentAssetItem.AutoQuantity}
                                            onChange={(v)=>this.onChangeEnabled(v,'AutoQuantity')}/>
                              </div>
                            </div>

                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>建値通貨</div>
                              <div style={{flex:9,textAlign:'left',display:'flex',alignItems:'center'}}>
                              <Select  value={currentAssetItem.Ccy} size="middle" style={{ width:'130px' }}
                                onSelect={(v)=>this.onAssetItemChange(v,'Ccy')} disabled={true}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}>
                                                <Option value={"JPY"}>日本円</Option>
                                                <Option value={"USD"}>米ドル</Option>
                                              </Select>
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>価格</div>
                              <div style={{flex:9,textAlign:'left',display:'flex',alignItems:'center'}}>
                                <Input
                                          style={{
                                            fontSize:'16px',
                                            width:'130px',
                                            color: currentAssetItem.AutoPrice ? '#bfbfbf' : 'black',
                                            background: currentAssetItem.AutoPrice ? '#f5f5f5' : 'white',
                                            cursor: currentAssetItem.AutoPrice ? 'not-allowed' : 'text'
                                          }}
                                          inputMode="decimal"
                                          readOnly={currentAssetItem.AutoPrice}
                                          onFocus={()=>this.onTradeFieldFocus('Price')}
                                          onChange={(e)=>this.onTradeFieldDraftChange('Price',e)}
                                          onBlur={()=>this.onTradeFieldBlur('Price')}
                                          value={this.state.priceDraft} />
                                          <div style={{width:'20px',marginLeft:'2px'}}> </div>
                                          <Switch style={{marginLeft:'2px',width:'80px'}} checkedChildren="自動" unCheckedChildren="手入力"
                                            checked={currentAssetItem.AutoPrice}
                                            onChange={(v)=>this.onChangeEnabled(v,'AutoPrice')}/>
                              </div>
                            </div>

                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>決済通貨</div>
                              <div style={{flex:9,textAlign:'left',display:'flex',alignItems:'center'}}>
                              <Select  value={currentAssetItem.SettleCcy} size="middle" style={{ width:'130px' }}
                                onSelect={(v)=>this.onAssetItemChange(v,'SettleCcy')}
                                disabled={currentAssetItem.AutoSettleCcy}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}>
                                                <Option value={"JPY"}>日本円</Option>
                                                <Option value={"USD"}>米ドル</Option>
                                              </Select>
                                <div style={{width:'20px',marginLeft:'2px'}}> </div>
                                  <Switch style={{marginLeft:'2px',width:'80px'}} checkedChildren="自動" unCheckedChildren="手入力"
                                  checked={currentAssetItem.AutoSettleCcy}
                                  onChange={(v)=>this.onChangeEnabled(v,'AutoSettleCcy')}/>
                              </div>
                            </div>
                            {currentAssetItem.SettleCcy!==currentAssetItem.Ccy && <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>為替</div>
                              <div style={{flex:9,textAlign:'left',display:'flex',alignItems:'center'}}><Input
                                          style={{
                                            fontSize:'16px',
                                            width:'130px',
                                            color: currentAssetItem.AutoFxRate ? '#bfbfbf' : 'black',
                                            background: currentAssetItem.AutoFxRate ? '#f5f5f5' : 'white',
                                            cursor: currentAssetItem.AutoFxRate ? 'not-allowed' : 'text'
                                          }}
                                          inputMode="decimal"
                                          readOnly={currentAssetItem.AutoFxRate}
                                          onFocus={()=>this.onTradeFieldFocus('FXRate')}
                                          onChange={(e)=>this.onTradeFieldDraftChange('FXRate',e)}
                                          onBlur={()=>this.onTradeFieldBlur('FXRate')}
                                          value={this.state.fxRateDraft} />
                                          <div style={{width:'20px',marginLeft:'2px'}}> </div>
                                          <Switch style={{marginLeft:'2px',width:'80px'}} checkedChildren="自動" unCheckedChildren="手入力"
                                          checked={currentAssetItem.AutoFxRate}
                                          onChange={(v)=>this.onChangeEnabled(v,'AutoFxRate')}/>
                              </div>
                            </div>}
                            {this.shouldShowSettingAmountField(currentAssetItem) && <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>設定額</div>
                              <div style={{flex:9,textAlign:'left',display:'flex',alignItems:'center'}}><Input
                                          style={{
                                            fontSize:'16px',
                                            width:'130px',
                                            color: currentAssetItem.AutoAmount ? '#bfbfbf' : 'black',
                                            background: currentAssetItem.AutoAmount ? '#f5f5f5' : 'white',
                                            cursor: currentAssetItem.AutoAmount ? 'not-allowed' : 'text'
                                          }}
                                          inputMode="decimal"
                                          onFocus={this.onSettingAmountFocus}
                                          onChange={this.onSettingAmountDraftChange}
                                          onBlur={this.onSettingAmountBlur}
                                          readOnly={currentAssetItem.AutoAmount}
                                          disabled={currentAssetItem.AutoAmount}
                                          className={currentAssetItem.AutoAmount ? 'portfolio-auto-input' : ''}
                                          placeholder={currentAssetItem.AutoAmount ? '' : '設定額を入力'}
                                          value={this.state.settingAmountDraft} />
                                          <div style={{width:'20px',marginLeft:'2px'}}> </div>
                                          <Switch style={{marginLeft:'2px',width:'80px'}} checkedChildren="自動" unCheckedChildren="手入力"
                                          checked={!!currentAssetItem.AutoAmount}
                                          onChange={(v)=>this.onChangeEnabled(v,'AutoAmount')}/>
                              </div>
                            </div>}
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>約定代金</div>
                              <div style={{flex:9,textAlign:'left',display:'flex',alignItems:'center'}}><Input
                                          style={{
                                            fontSize:'16px',
                                            width:'130px',
                                            color: currentAssetItem.AutoNotional ? '#bfbfbf' : 'black',
                                            background: currentAssetItem.AutoNotional ? '#f5f5f5' : 'white',
                                            cursor: currentAssetItem.AutoNotional ? 'not-allowed' : 'text'
                                          }}
                                          inputMode="decimal"
                                          readOnly={currentAssetItem.AutoNotional}
                                          onFocus={()=>this.onTradeFieldFocus('Cashflow')}
                                          onChange={(e)=>this.onTradeFieldDraftChange('Cashflow',e)}
                                          onBlur={()=>this.onTradeFieldBlur('Cashflow')}
                                          value={this.state.cashflowDraft} />
                                          <div style={{width:'20px',marginLeft:'2px'}}> </div>
                                          <Switch style={{marginLeft:'2px',width:'80px'}} checkedChildren="自動" unCheckedChildren="手入力"
                                          checked={currentAssetItem.AutoNotional}
                                          onChange={(v)=>this.onChangeEnabled(v,'AutoNotional')}/>
                              </div>
                            </div>
                            <div style={{width:'100%',display:'flex',marginTop:'5px', marginLeft:'20px',paddingRight:'20px',justifyContent:'flex-start'}}>
                              <div style={{flex:3 ,fontSize:'15px',color:'#a6a6a6',textAlign:'left'}}>備考</div>
                              <div style={{flex:9,textAlign:'left'}}>
                                <TextArea placeholder="" allowClear  style={{fontSize:'16px'}}
                                          onChange={(v)=>this.onAssetItemChange(v.target.value,'Memo')}
                                           value={currentAssetItem.Memo} />
                              </div>
                            </div>
                          </>
                        )}

  
                      </div>
                    </Drawer>
                </div>
                
              </>
            </TabPane>
          );
          })}

        </Tabs>
        <Modal
      title={
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <span>口座一覧</span>
          <div style={{display:'flex',gap:'8px',marginRight:'8px'}}>
            {!this.state.accountDraft && (
              <Button type="primary" onClick={this.startNewAccount}>
                口座を追加
              </Button>
            )}
            <Button
              type="primary"
              onClick={() => this.setState({ accountManagerVisible:false, accountDraft:null })}
            >
              閉じる
            </Button>
          </div>
        </div>
      }
      visible={this.state.accountManagerVisible}
      width={360}
      footer={null}
      closable={false}
      wrapClassName="account-manager-modal" 
      onCancel={() => this.setState({ accountManagerVisible:false, accountDraft:null })}
      zIndex={3200}
    >
          {this.state.accountDraft ? (
            <div>
              <div style={{marginBottom:'10px'}}>金融機関</div>
              <Select
                value={this.state.accountDraft.financialInstitutionId}
                style={{width:'100%',marginBottom:'12px'}}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  this.normalizeFinancialInstitutionSearchText(option?.children)
                    .includes(this.normalizeFinancialInstitutionSearchText(input))
                }
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                onChange={(financialInstitutionId) => {
                  const institution = this.state.financialInstitutions.find((item) => item.id === financialInstitutionId);
                  this.setState({
                    accountDraft:{
                      ...this.state.accountDraft,
                      financialInstitutionId,
                      displayName:this.getFinancialInstitutionDisplayName(institution?.name),
                    }
                  });
                }}
              >
                {this.state.financialInstitutions.map((institution) => (
                  <Option key={institution.id} value={institution.id}>
                    {this.getFinancialInstitutionDisplayName(institution.name)}
                  </Option>
                ))}
              </Select>
              <div style={{marginBottom:'10px'}}>表示名</div>
              <Input value={this.state.accountDraft.displayName} onChange={(event) => this.setState({ accountDraft:{ ...this.state.accountDraft, displayName:event.target.value } })} />
              <div style={{display:'flex',gap:'18px',marginTop:'16px',alignItems:'center'}}>
                <span>デフォルト <Switch checked={this.state.accountDraft.isDefault} onChange={(isDefault) => this.setState({ accountDraft:{ ...this.state.accountDraft, isDefault } })} /></span>
                <span>有効 <Switch checked={this.state.accountDraft.isActive} onChange={(isActive) => this.setState({ accountDraft:{ ...this.state.accountDraft, isActive, isDefault:isActive ? this.state.accountDraft.isDefault : false } })} /></span>
                <Button onClick={() => this.setState({ accountDraft:null })}>戻る</Button>
                <Button type="primary" onClick={this.saveManagedAccount}>保存</Button>
              </div>
            </div>
          ) : (
            <div>
              {this.state.managedUserAccounts.map((account) => (
                <div key={account.id} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderTop:'1px solid #f0f0f0'}}>
                  <span>{account.displayName} {!account.isActive && '（無効）'} {account.isDefault && '（デフォルト）'}</span>
                  <Button size="small" onClick={() => this.setState({ accountDraft:{ ...account } })}>編集</Button>
                </div>
              ))}
            </div>
          )}
        </Modal>
        </div>
        </div>
                            <Drawer 
                              title={<div style={{ height:'50px'}}>
                                      <div style={{display: 'flex'}}>
                                              <div style={{fontSize:'18px',fontWeight:'bold',marginRight:'20px'}}>制約条件</div>
                                              <div style={{ flex: 1}}></div>
                                              <ClickButton style={{width:'80px'}} onClick={settingFlg ? this.handleRatioSettingApply : this.handleRatioSettingClose}>{settingFlg?'適用':'閉じる'}</ClickButton>
                                        </div>
                                        <div style={{ color:'red'}}>{errorMsg}</div>
                                    </div>}
                              visible={settingVisible2}
                              placement="right" 
                              closable={false}
                              width={constraintDrawerWidth}
                              drawerStyle={constraintDrawerStyle}
                              bodyStyle={constraintDrawerBodyStyle}
                              onClose={()=>this.setState({settingVisible2:false})}
                            >
                                <Row>
                                {ratioSettingList.map((item, index) => {
                                  const assetKey = this.getConstraintAssetKey(item);
                                  const isFixedConstraint = !!item?.IsFixedConstraint;
                                  const benchmarkDisplay = this.getConstraintBenchmarkDisplay(item);
                                  return <Col key={`${assetKey}:${item.Code || index}`} span={24} style={{height:'30px',paddingRight:'10px'}}>
                                        <div style={{display:'flex'}}>
                                        <span style={{flex: 1,color:item.Color}}>■</span>
                                        <span style={{flex: 11,fontSize:13,width:`${CONSTRAINT_LABEL_WIDTH}px`,maxWidth:`${CONSTRAINT_LABEL_WIDTH}px`,color:'#a6a6a6',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                                          <span style={{ color:'black' ,}}>{item.Asset}</span>(
                                          {this.wrapInstrumentLink(item, benchmarkDisplay)}
                                          )
                                        </span>
                                          {this.isFixedRatioConstraintAsset(item) ? (
                                            <Select
                                              value="="
                                              style={{width:`${CONSTRAINT_OPERATOR_WIDTH}px`,minWidth:`${CONSTRAINT_OPERATOR_WIDTH}px`}}
                                              size="small"
                                              disabled
                                            >
                                              <Option value="=">=</Option>
                                            </Select>
                                          ) : (
                                            <Select
                                              value={normalizeConstraintOperator(item.Express) || '='}
                                              onSelect={this.onChangeConditionExpress(assetKey)}
                                              style={{width:`${CONSTRAINT_OPERATOR_WIDTH}px`,minWidth:`${CONSTRAINT_OPERATOR_WIDTH}px`}}
                                              size="small"
                                              disabled={isFixedConstraint}
                                            >
                                              <Option value="<=">&lt;=</Option>
                                              <Option value=">=">&gt;=</Option>
                                              <Option value="=">=</Option>
                                            </Select>
                                          )}
                                            <InputNumber 
                                              className="constraint-number-input"
                                              style={{width:`${CONSTRAINT_VALUE_WIDTH}px`,minWidth:`${CONSTRAINT_VALUE_WIDTH}px`}} 
                                              min={0} 
                                              max={100} 
                                              inputMode="decimal"
                                              disabled={isFixedConstraint}
                                              onChange={this.onChangeConditionExpressValue(assetKey)}
                                              value={item.ExpressValue} size="small"  />
                                              <span>%</span>
                                        </div>  
                                  </Col>    
                                })}
                                  <Col span={24} style={{minHeight:'30px',paddingRight:'10px'}}>
                                        <div style={{display:'flex'}}>
                                        <span style={{flex: 1,color:'Black'}}></span>
                                        <span style={{flex: 11,fontSize:13,width:`${CONSTRAINT_LABEL_WIDTH}px`,maxWidth:`${CONSTRAINT_LABEL_WIDTH}px`,color:'#a6a6a6',whiteSpace:'nowrap'}}>
                                          <span style={{ color:'black' ,}}>無リスク金利</span>
                                          {this.renderValSettingHelpIcon('fixedDeposit10Year')}
                                        </span>
                                            <InputNumber 
                                              className="constraint-number-input"
                                              style={{width:`${CONSTRAINT_RATE_VALUE_WIDTH}px`,minWidth:`${CONSTRAINT_RATE_VALUE_WIDTH}px`}} 
                                              min={0} 
                                              max={100} 
                                              // readOnly={true}
                                              disabled
                                              inputMode="decimal"
                                              formatter={(value) => this.formatConstraintRateValue(value)}
                                              onChange={(value) =>this.setState({fixedDepositSetting:value,settingFlg:true})}
                                              value={fixedDepositSetting} size="small"  />
                                              <span>%</span>
                                        </div>  
                                        {this.renderValSettingHelpContent('fixedDeposit10Year', '円預金の代表銘柄には個人向け国債（変動10年）を用い、最新の利率（税引前の年率）を無リスク金利として使用します。最適化計算では、この利率を固定の期待収益率として扱い、将来の利率変動は織り込みません。将来シミュレーションでは、円預金に適用する現在の利率が計算期間中も続き、満期後も同じ利率で運用を継続できると仮定します。実際の個人向け国債（変動10年）の適用利率は半年ごとに見直されるため、将来の利率や運用成果を保証するものではありません。')}
                                  </Col>   
          
                                    <Col span={24} style={{height:'60px',paddingRight:'10px'}}>                            
                                          <div style={{display:'flex'}}>
                                            <div style={{flex: 1,color:'Green',display: 'flex', alignItems:'flex-start'}}></div>
                                            <div style={{flex: 11,fontSize:13,width:`${CONSTRAINT_LABEL_WIDTH}px`,maxWidth:`${CONSTRAINT_LABEL_WIDTH}px`,color:'#a6a6a6',whiteSpace:'nowrap',display: 'flex', alignItems:'flex-start'}}>
                                              <span style={{ color:'black' ,}}>観測期間の開始日</span>
                                            </div>
                                              <Radio.Group
                                                    style={{flex: 6,}}
                                                    onChange={this.onChangeObservValue}
                                                    value={newObservValue}
                                                    options={[
                                                      { value: 1, label: 'リーマン後' },
                                                      { value: 2, label: '最古' }
                                                    ]}
                                                  />
                                          </div>  
                                    </Col>  
                                  
                                </Row>
                            </Drawer >
                    <Drawer
                      title={null}
                      placement="left"
                      closable={false}
                      onClose={this.closeCashTransactionModal}
                      visible={this.state.cashModalVisible}
                      width={window.innerWidth}
                      zIndex={2000}
                      style={{ position: 'fixed', top: 0, left: 0 }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', width:'95%' }}>
                        <div style={{ display: 'flex'}}>
                          <div style={{ flex: 1}}>
                            <div style={{display:'flex',justifyContent: "space-between",margin:'0px 0px',fontSize:'18px',color:'#a6a6a6'}}>
                              <span>{this.state.cashTransactionIsNew ? '入出金登録' : '入出金編集'}</span>
                            </div>
                            <div style={{display:'flex',margin:'0px 0px',fontSize:'18px',fontWeight:'bold'}}>
                              <span>{this.state.cashTransactionInstrumentName}</span>
                            </div>
                            <div style={{display:'flex',margin:'4px 0px 0px',fontSize:'12px',color:'#8c8c8c'}}>
                              <span>{`${this.state.cashTransactionInstrumentCode} | ${this.state.cashTransactionInstrumentAsset}`}</span>
                            </div>
                          </div>
                          <div style={{ width: '220px',display:'flex',flexDirection: 'column',justifyContent:'flex-start'}}>
                            <div style={{display:'flex',justifyContent:'flex-end',gap:'10px',marginBottom:'20px'}}>
                              {!this.state.cashTransactionIsNew && (
                                <ClickButton
                                  style={{height:'28px',width: '100px',fontSize:16}}
                                  onClick={async () => {
                                    this.setState({ loading:true, cashModalVisible:false });
                                    const delResult = await reqDelTransaction(this.state.cashTransactionId, 'single');
                                    if (delResult.status !== 0) {
                                      this.setState({ loading:false, cashModalVisible:true });
                                      message.error(delResult?.data?.msg || '削除に失敗しました');
                                      return;
                                    }
                                    await this.GetPortfolio(this.state.activeTab);
                                    this.setState({ loading:false });
                                    message.success('入出金を削除しました');
                                  }}
                                >
                                  削除
                                </ClickButton>
                              )}
                              <ClickButton
                                style={{height:'28px',width: '100px',fontSize:16}}
                                onClick={this.submitCashTransaction}
                              >
                                {this.state.cashTransactionIsNew ? '登録' : '適用'}
                              </ClickButton>
                            </div>
                            <div style={{display:'flex',justifyContent:'flex-end'}}>
                              <ClickButton style={{height:'28px',width: '100px',fontSize:16}} onClick={this.closeCashTransactionModal}>{'キャンセル'}</ClickButton>
                            </div>
                          </div>
                        </div>
                        <div style={{height:'10px' }}><span></span></div>
                        <div style={{backgroundColor:'#c8c8c8',height:'1px',marginTop:'2px'}}></div>
                        <div className="cash-transaction-form" style={{marginTop:'15px', marginLeft:'20px', paddingRight:'20px'}}>
                        <div className="cash-transaction-row">
                          <span className="cash-transaction-label">種別</span>
                          <Radio.Group
                            value={this.state.cashTransactionType}
                            onChange={(e) => this.setState({ cashTransactionType: e.target.value })}
                            buttonStyle="solid"
                          >
                            <Radio.Button value="DEPOSIT">入金</Radio.Button>
                            <Radio.Button value="WITHDRAWAL">出金</Radio.Button>
                          </Radio.Group>
                        </div>
                        <div className="cash-transaction-row">
                          <span className="cash-transaction-label">日付</span>
                          <PasteableDatePicker
                            value={moment(this.state.cashTransactionDate,'YYYY-MM-DD')}
                            style={{width:'180px'}}
                            onChange={(_, dateString) => this.setState({ cashTransactionDate: dateString })}
                          />
                        </div>
                        <div className="cash-transaction-row">
                         <span className="cash-transaction-label">口座</span>
                         <div>
                           <Select
                             value={
                               this.state.cashTransactionAccountId
                               ?? (
                                 this.state.cashTransactionAccount
                                   ? `legacy:${this.state.cashTransactionAccount}`
                                   : undefined
                               )
                             }
                             style={{width:'180px'}}
                             size="middle"
                             placeholder="口座を選択"
                             onChange={this.onCashTransactionAccountChange}
                             getPopupContainer={(triggerNode) => triggerNode.parentNode}
                           >
                             {this.state.userAccounts.map((account) => (
                               <Option key={account.id} value={account.id}>
                                 {account.displayName}
                               </Option>
                             ))}
                             {this.state.cashTransactionAccountId
                               && !this.state.userAccounts.some(
                                 (account) => account.id === this.state.cashTransactionAccountId
                               ) && (
                                 <Option value={this.state.cashTransactionAccountId} disabled>
                                   {this.state.cashTransactionAccount || '無効な口座'}（無効）
                                 </Option>
                             )}
                             {!this.state.cashTransactionAccountId
                               && this.state.cashTransactionAccount && (
                                 <Option
                                   value={`legacy:${this.state.cashTransactionAccount}`}
                                   disabled
                                 >
                                   {this.state.cashTransactionAccount}（旧データ）
                                 </Option>
                             )}
                           </Select>
                           <Button
                             type="link"
                             style={{paddingLeft:'8px'}}
                             onClick={this.openAccountManager}
                           >
                             口座を追加・編集
                           </Button>
                         </div>
                       </div>
                       <div className="cash-transaction-row">
                          <span className="cash-transaction-label">金額</span>
                          <Input
                            style={{width:'180px'}}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            autoComplete="off"
                            allowClear
                            placeholder="金額を入力"
                            value={
                              this.state.cashTransactionAmountFocused
                                ? this.state.cashTransactionAmount
                                : (this.state.cashTransactionAmount === ''
                                    ? ''
                                    : numFormat(this.state.cashTransactionAmount))
                            }
                            onChange={this.handleCashTransactionAmountChange}
                            onFocus={() => this.setState({ cashTransactionAmountFocused: true })}
                            onBlur={() => this.setState({ cashTransactionAmountFocused: false })}
                          />
                        </div>
                        <div className="cash-transaction-row cash-transaction-row-notes">
                          <span className="cash-transaction-label">備考</span>
                          <TextArea
                            style={{width:'180px'}}
                            rows={3}
                            value={this.state.cashTransactionMemo}
                            onChange={(e) => this.setState({ cashTransactionMemo: e.target.value })}
                            onPaste={this.handleCashTransactionMemoPaste}
                            placeholder=""
                          />
                        </div>
                      </div>
                      </div>
                    </Drawer>
      </div>
      
    );
  }
}




// WATCH_TEST
